export default String.raw`
let countSelected = 0;

const euCountriesISOWithoutPL = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PT", "RO", "SK", "SI", "ES", "SE"];

var productsInCart;

$(document).ready(function() {
	const mainContentMinHeight = $('.header-js').outerHeight() + $('.footer-js').outerHeight() + $('.header-top-banner').outerHeight();
	$('.main-content-js').css('min-height', 'calc(100vh - ' + (mainContentMinHeight ? mainContentMinHeight : 0) + 'px)');
	app.init();
});

$(document).ajaxSuccess(function(a,b,c,d) {
	if(d && d.action && d.action.Code == 100){
		if(d.action.Action == 'Order/Add'){
			setTimeout(function(){
				app.reload();
			}, 3000)
		} else if(d.action.Action != 'Get/Vies') {
			app.reload();
		}
	}
});

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.register('sw.js')
		.then(function(registration) {
			console.log('Registration successful, scope is:', registration.scope);
		})
		.catch(function(error) {
			console.log('Service worker registration failed, error:', error);
		});
}

var app = {
    //Block IE
    blockIE: function() {
        var nAgt = navigator.userAgent;
        var verOffset;
        if((verOffset=nAgt.indexOf("MSIE"))!=-1 || (verOffset=nAgt.indexOf("Trident/"))!=-1){
        	$('body').html(
				'<div class="blocked-IE">' +
					'<div class="blocked-IE-title">'+__translations.BrowserNotSupported+'.</div>' +
					'<div class="blocked-IE-container">' +
						'<div class="blocked-IE-info">'+__translations.UseOtherBrowser+':</div>' +
						'<ul class="blocked-IE-list">' +
							'<li class="blocked-IE-browser"><a href="https://www.google.com/chrome"><img alt="chrome" src="https://static.comarchesklep.pl/files/img/chrome.png" width="128" height="128"></a></li>' +
							'<li class="blocked-IE-browser"><a href="https://www.mozilla.org/firefox"><img alt="firefox" src="https://static.comarchesklep.pl/files/img/firefox.png" width="128" height="128"></a></li>' +
							'<li class="blocked-IE-browser"><a href="https://www.microsoft.com/microsoft-edge"><img alt="edge" src="https://static.comarchesklep.pl/files/img/edge.png" width="128" height="128"></a></li>' +
							'<li class="blocked-IE-browser"><a href="https://support.apple.com/HT204416"><img alt="safari" src="https://static.comarchesklep.pl/files/img/safari.png" width="128" height="128"></a></li>' +
							'<li class="blocked-IE-browser"><a href="https://www.opera.com/pl/download"><img alt="opera" src="https://static.comarchesklep.pl/files/img/opera.png" width="128" height="128"></a></li>' +
						'</ul>' +
					'</div>' +
				'</div>'
			);
        	return true;
		} else {
        	return false;
		}
    },

    // Initiate all events and images.
	init: function() {
    	if(!this.blockIE()){
            this.events();
			this.formLabelAnimationOnLoadPage();
		}
	},

    validationSelect: function(e, input){
		if (input == undefined){
			var input = $(e.currentTarget);
		}
	
		if (input.prop('required') && input.length !== 0){
			if (input.val() === '' || input.val() === null ){
				if (input.attr('name') === 'gender') {
					input.parent().find('.validation-required-js').removeClass('hidden-js');
					input.parent().find('.form__input-info').addClass('validation-error');
					input.addClass('validation-error-js');
				}
			} else {
				if (input.attr('name') === 'gender') {
					input.parent().find('.validation-required-js').addClass('hidden-js');
					input.parent().find('.form__input-info').removeClass('validation-error');
					input.removeClass('validation-error-js');
				}
			}
		}
		
		var wrapper = input.parents('.form__input-wrapper');

		if (input.attr('id') === 'selectDSA') {
			var selectedText = wrapper.find('.selected-js').text().trim();

			if (selectedText === '' || selectedText === '{{ translations.ReportContentType }}') {
				wrapper.find('.validation-required-js').removeClass('hidden-js');
				wrapper.find('.form__input-info').addClass('validation-error');
				wrapper.find('.form__input-value').addClass('validation-error-js');
			} else {
				wrapper.find('.validation-required-js').addClass('hidden-js');
				wrapper.find('.form__input-info').removeClass('validation-error');
				wrapper.find('.form__input-value').removeClass('validation-error-js');
			}
		}
	},

	validatePhoneNo: function(e, paste = false) {
        const validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "Backspace", "ArrowLeft", "ArrowRight", "Delete", "+"];
        const invalidChars = ["-", "e", ".", ",", "E"];
        if (paste == false) {
            if (invalidChars.includes(e.key) || !(validChars.includes(e.key))) {
                e.preventDefault();
            } else if (e.key == "+") {
                if ($(e.currentTarget).val().includes(e.key) || e.target.selectionStart != 0) {
                    e.preventDefault();
                }
            }
        } else {
            let data = $(e.currentTarget).val();
            for (let i=0; i<data.length; i++) {
                if (invalidChars.includes(data[i]) || !(validChars.includes(data[i]))) {
                    data = data.substring(0,i) + '' + data.substring(i + 1);
                    i-=1;
                } else if (data[i] == "+") {
                    if (i != 0) {
                        data = data.substring(0,i) + '' + data.substring(i + 1);
                        i-=1;
                    }
                }
            }
            $(e.currentTarget).val(data);
        }
    },

	// Validate input on client side while changing value of input.
	validation: function(e,input) {
		if (input == undefined){
			var input = $(e.currentTarget);
		}
		if (input.prop('readonly')) {
			return;
		}
		var type = input.attr('type');
		var name = input.attr('name');
		var aria = input.attr('aria-label');
		var parent = input.parent();
		var form = input.parents('.form-js');
		var passwordInput = form.find('[name="password"]');
		var passwordRepeatInput = form.find('[name="passwordRepeat"]');
		var emailInput = form.find('[name="email"]');
		var emailRepeatInput = form.find('[name="emailRepeat"]');
		if (form.find('[name="countryCode"]:not([disabled]) option:selected').length > 0){
			var selectedCountry = form.find('[name="countryCode"]:not([disabled]) option:selected');
		} else {
			var selectedCountry = form.find('[name="countryCode"]');
		}

		// required
		if (input.prop('required')){
			if (((type == 'checkbox' || type == 'radio') && !input.prop('checked')) || ((type != 'checkbox' && type != 'radio') && input.val().replace(/\s/g, '').length == 0)){
				parent.find('.validation-info-js').addClass('hidden-js');
				parent.find('.validation-required-js').removeClass('hidden-js');
				parent.find('.validation-info-password-repeat-js').addClass('hidden-js');
				parent.find('.form__input-info').addClass('validation-error');
				parent.find('.validation-zip-code-js').addClass('hidden-js');
				if (type == 'checkbox') {
					input.next('label').addClass('validation-error-js');
				}
				input.addClass('validation-error-js');
				var requiredError = true;
			} else {
				parent.find('.validation-required-js').addClass('hidden-js');
				parent.find('.form__input-info').removeClass('validation-error');
				if (type == 'checkbox') {
					input.next('label').removeClass('validation-error-js');
				}
                input.removeClass('validation-error-js');
			}
		}

		// required at least 1 channel in required input
        if (input.attr('name') === 'channelKey') {
            var channelParent = input.parent().parent().parent();
            var tos = channelParent.find('[name=tos]');

            if (input.prop('required') || channelParent.hasClass('statement-js') || (tos != undefined && (tos.prop('checked') || tos.prop('required')))) {
                var channels = channelParent.find('[name=channelKey]');
                var nothingSelected = true;
                channels.each(function () {
                    if ($(this).prop('checked')) {
                        nothingSelected = false;
                    }
                });
                if (nothingSelected) {
                    channelParent.find('.form__validation-channel-js').removeClass('hidden-js');
                } else {
                    channelParent.find('.form__validation-channel-js').addClass('hidden-js');
                }
            }
        }

		if (input.attr('name') === 'tos' && !form.hasClass('adding-order-form-js')) {
            app.checkIfChannelsSelected(input);
        }

		if (requiredError == undefined){
			// e-mail
			if (name == 'email' && (input.prop('required') || (!input.prop('required') && input.val() != ''))){
				var regex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}$/;
				if (!regex.test(input.val())){
					parent.find('.email-valid-js').removeClass('hidden-js');
					parent.find('.form__input-info').addClass('validation-error');
					input.addClass('validation-error-js');
					var emailError = true;
				} else {
					parent.find('.email-valid-js').addClass('hidden-js');
					parent.find('.form__input-info').removeClass('validation-error');
					input.removeClass('validation-error-js');
					var emailError = false;
				}
			}

			if (name == 'emailRepeat') {
				if (emailInput.val() === '' || emailInput.val() !== emailRepeatInput.val()) {
					parent.find('.validation-email-mismatch-js').removeClass('hidden-js');
					parent.find('.form__input-info').addClass('validation-error');
					input.addClass('validation-error-js');
				} else {
					parent.find('.validation-email-mismatch-js').addClass('hidden-js');
					parent.find('.form__input-info').removeClass('validation-error');
					input.removeClass('validation-error-js');
				}
			}

			if (name === 'email') {
				if (emailRepeatInput.val() === '' || emailRepeatInput.val() !== emailInput.val()) {
					emailRepeatInput.parent().find('.validation-email-mismatch-js').removeClass('hidden-js');
					emailRepeatInput.parent().find('.form__input-info').addClass('validation-error');
					emailRepeatInput.parent().find('.validation-required-js').addClass('hidden-js');
					emailRepeatInput.addClass('validation-error-js');
				} else {
					emailRepeatInput.parent().find('.validation-email-mismatch-js').addClass('hidden-js');
					emailRepeatInput.parent().find('.form__input-info').removeClass('validation-error');
					emailRepeatInput.removeClass('validation-error-js');
				}
			}

			if (!emailError && emailRepeatInput.val() == ''){
			} else if (!emailError && emailRepeatInput.val() === emailInput.val()) {
				emailRepeatInput.parent().find('.form__input-info').removeClass('validation-error');
				emailRepeatInput.removeClass('validation-error');
				emailRepeatInput.removeClass('validation-error-js');
			}

			// password
			if (name == 'password' && aria != 'password-login' || name == 'passwordRepeat' || name == 'oldPassword'){
				var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*['!@#$%^&*()_+\-=[\]{},;:.?/])[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{8,}$/;
				if (!regex.test(input.val())){
					parent.find('.password-valid-js').removeClass('hidden-js');
					parent.find('.form__input-info').addClass('validation-error');
					input.addClass('validation-error-js');
					var passwordError = true;
					var min8CharRegex = /^[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{8,}$/;
					var bigLetterRegex = /^(?=.*[A-Z])[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{1,}$/;
					var smallLetterRegex = /^(?=.*[a-z])[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{1,}$/;
					var digitRegex = /^(?=.*\d)[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{1,}$/;
					var specialCharRegex = /^(?=.*['!@#$%^&*()_+\-=[\]{},;:.?/])[A-Za-z\d'!@#$%^&*()_+\-=[\]{},;:.?/\u0000-~\u0080-þĀ-žƀ-ɎḀ-ỾⱠ-\u2c7e꜠-ꟾ]{1,}$/;
					if (!min8CharRegex.test(input.val())) {
						parent.find('.min-8-char-js').removeClass('valid-data-js');
						parent.find('.min-8-char-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-circle-'+__iconStyle);
					} else {
						parent.find('.min-8-char-js').addClass('valid-data-js');
						parent.find('.min-8-char-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle);
					}
					if (!bigLetterRegex.test(input.val())) {
						parent.find('.big-letter-js').removeClass('valid-data-js');
						parent.find('.big-letter-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-circle-'+__iconStyle);
					} else {
						parent.find('.big-letter-js').addClass('valid-data-js');
						parent.find('.big-letter-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle);
					}
					if (!smallLetterRegex.test(input.val())) {
						parent.find('.small-letter-js').removeClass('valid-data-js');
						parent.find('.small-letter-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-circle-'+__iconStyle);
					} else {
						parent.find('.small-letter-js').addClass('valid-data-js');
						parent.find('.small-letter-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle);
					}
					if (!digitRegex.test(input.val())) {
						parent.find('.digit-js').removeClass('valid-data-js');
						parent.find('.digit-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-circle-'+__iconStyle);
					} else {
						parent.find('.digit-js').addClass('valid-data-js');
						parent.find('.digit-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle);
					}
					if (!specialCharRegex.test(input.val())) {
						parent.find('.special-char-js').removeClass('valid-data-js');
						parent.find('.special-char-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-circle-'+__iconStyle);
					} else {
						parent.find('.special-char-js').addClass('valid-data-js');
						parent.find('.special-char-js svg use').attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle);
					}
				} else {
					parent.find('.password-valid-js').addClass('hidden-js');
					parent.find('.form__input-info').removeClass('validation-error');
                    input.removeClass('validation-error-js');
					var passwordError = false;
				}
			}

			// password mismatch
			if (name === 'passwordRepeat') {
				if (passwordInput.val() === '' || passwordInput.val() !== passwordRepeatInput.val()) {
					parent.find('.validation-info-password-repeat-js').removeClass('hidden-js');
					parent.find('.form__input-info').addClass('validation-error');
					input.addClass('validation-error-js');
				} else {
					parent.find('.validation-info-password-repeat-js').addClass('hidden-js');
					parent.find('.form__input-info').removeClass('validation-error');
					input.removeClass('validation-error-js');
				}
			}
			
			if (name === 'password' && passwordRepeatInput.length > 0) {
				if (passwordRepeatInput.val() === '' || passwordRepeatInput.val() !== passwordInput.val()) {
					passwordRepeatInput.parent().find('.validation-info-password-repeat-js').removeClass('hidden-js');
					passwordRepeatInput.parent().find('.form__input-info').addClass('validation-error');
					passwordRepeatInput.parent().find('.validation-required-js').addClass('hidden-js');
					passwordRepeatInput.addClass('validation-error-js');
				} else {
					passwordRepeatInput.parent().find('.validation-info-password-repeat-js').addClass('hidden-js');
					passwordRepeatInput.parent().find('.form__input-info').removeClass('validation-error');
					passwordRepeatInput.removeClass('validation-error-js');
				}
			}
			
			if (!passwordError && passwordRepeatInput.val() == ''){
			} else if (!passwordError && passwordRepeatInput.val() === passwordInput.val()) {
				passwordRepeatInput.parent().find('.form__input-info').removeClass('validation-error');
				passwordRepeatInput.removeClass('validation-error');
				passwordRepeatInput.removeClass('validation-error-js');
			}
			
			// zip code
			var zipCode = form.find('[name="zipCode"]:not([disabled])');
			if (name == 'zipCode' || (name == 'countryCode' && zipCode.val() != '')){
				var regex = new RegExp(selectedCountry.data('zip-regex'));
				var format = selectedCountry.data('zip-format');
				if (!regex.test(zipCode.val()) && zipCode.val() != ''){
					zipCode.parent().find('.validation-zip-code-js').removeClass('hidden-js').find('.zip-format-js').text(format);
					zipCode.parent().find('.form__input-info').addClass('validation-error');
					zipCode.addClass('validation-error-js');
					if (zipCode.hasClass('show-map-js')){
						$('.map-info-js').removeClass('hidden-js');
						$('.map-js').addClass('hidden-js');
						$('.machines-filter-js').addClass('hidden-js');
						$('.collection-points-list-js').addClass('hidden-js');
					}
				} else {
					zipCode.parent().find('.validation-zip-code-js').addClass('hidden-js');
					zipCode.parent().find('.form__input-info').removeClass('validation-error');
                    zipCode.removeClass('validation-error-js');
					if (zipCode.hasClass('show-map-js')){
						$('.map-info-js').addClass('hidden-js');
						$('.map-js').removeClass('hidden-js');
						$('.machines-filter-js').removeClass('hidden-js');
						$('.collection-points-list-js').removeClass('hidden-js');
						window.pointChoosen = false;
					}
				}
			}

			var selectBirthDate = form.find('input[name="birthdate"]');
			if (name === 'birthdate') {
				if (selectBirthDate.val() === '' || selectBirthDate.val() === null) {
					selectBirthDate.parent().find('.validation-required-js').removeClass('hidden-js');
					selectBirthDate.parent().find('.form__input-info').addClass('validation-error');
					selectBirthDate.addClass('validation-error-js');
				} else {
					selectBirthDate.parent().find('.validation-required-js').addClass('hidden-js');
					selectBirthDate.parent().find('.form__input-info').removeClass('validation-error');
					selectBirthDate.removeClass('validation-error-js');
				}
			}

			// TIN
			if (form.length > 1) {
				form = form.eq(0); 
			}
			var tin = form.find('[name="tin"]');
			if(name == 'tin' || (name == 'countryCode' && tin.val() != '' && tin.val() != undefined)){
				var regex = new RegExp(selectedCountry.data('tin-regex'));
				var checkSum = tin.data('check-sum');
				tin.val(tin.val().replace(/-/g, ''));
				if(tin.val() != '' && regex != '/.*/' && !app.validateTin(tin.val(), checkSum, regex)){
					tin.parent().find('.validation-tin-js').removeClass('hidden-js');
					tin.parent().find('.form__input-info').addClass('validation-error');
					tin.parent().find('.validation-gus-js').addClass('hidden-js');
					tin.addClass('validation-error-js');
				} else {
					tin.parent().find('.validation-tin-js').addClass('hidden-js');
					tin.removeClass('validation-error-js');
                    if(tin.parents('.with-database-check-js').index() != -1 && tin.parents('.external-base-js').index() == -1){
						
						app.getDataFromExternalBase(e, function() {
							if ($(e.currentTarget).parents('.order-template-js').length > 0 || $(e.currentTarget).parents('.customer-profile-js').length > 0) {
								var form = tin.parents('.with-database-check-js');
								var isReadonly = true;
								if (form.find('[name=countryCode]').val() != "PL") {
									if (form.data('edit-data-from-vies') == 'yes') {
										isReadonly = false;
									}
									if ($(e.currentTarget).val() == "" || 
										(form.find('[name=countryCode]').val() == "GB" && $(e.currentTarget).val() != "XI")) {
											isReadonly = false;
									}
								} else {
									if (form.data('edit-data-from-gus') == 'yes') {
										isReadonly = false;
									}
								}
								app.readonlyFormFields(form, isReadonly);
							}
						});
					}
				}
			}

			// quantity
			if(name == 'quantity'){
				var val = input.val();
				// decimal units
				if(__decUnits == 'true' && (val.indexOf('.') !== -1 || val.indexOf(',') !== -1)){
					if(__decSep == ","){
						var regex = /^\d{1,5}\,\d{1,4}$/;
						val = val.replace('.', ',').split(',');
					} else {
						var regex = /^\d{1,5}\.\d{1,4}$/;
						val = val.replace(',', '.').split('.');
					}
					var dec = val[1];
					var size = dec.length;
					if(!regex.test(val)){
						var toDelete = size - 4;
						if(toDelete > 0){
							dec.slice(0, -toDelete);
						}
						size = dec.length;
					}
					if(size == 4){
						for(var i=0; i<4; i++){
							var lastDigit = dec.slice(-1);
							if(lastDigit == '0'){
								dec = dec.slice(0, -1);
							} else {
								break;
							}
						}
					}
					val = val[0] + __decSep + dec;
					input.val(val);
					if(__decSep == ","){
						val = val.replace(',', '.');
					}
					if(size > 0){
						val = Number(val);
					}
				} else {
					val = Number(val);
				}

				// quantity range
				var min = Number(input.data('min').toString().replace(',', '.'));
				var max = Number(input.data('max').toString().replace(',', '.'));
				if(input.data('minq')){
					var minQ = Number(input.data('minq').toString().replace(',', '.'));
				}

				if(min >= max){
					app.temporaryPopupMessage(undefined, __translations.stockLvlExceeded, 'err');
				} else {
                    if(val < min && parent.find('.validation-min-quantity-js').length > 0){
						parent.find('.validation-quantity-range-js').addClass('hidden-js');
						parent.find('.validation-quantity-range-max-js').addClass('hidden-js');
						parent.find('.validation-min-quantity-js').removeClass('hidden-js');
                        parent.find('.validation-min-quantity-js').show().delay(3000).hide(300, function(){
                            parent.find('.validation-min-quantity-js').addClass('hidden-js');
                        });
					} else if(minQ > 0){
						if(val > max){
							parent.find('.validation-min-quantity-js').addClass('hidden-js');
							parent.find('.validation-quantity-range-js').addClass('hidden-js');
							parent.find('.validation-quantity-range-max-js').removeClass('hidden-js');
							parent.find('.validation-quantity-range-max-js').show().delay(3000).hide(300, function(){
								parent.find('.validation-quantity-range-max-js').addClass('hidden-js');
							});
						}
					} else if((val < 0 )
						|| (val < 0.01 && __decUnits == 'true' && $('.zero-allowed-js').index() == -1)
						|| (val < 1 && __decUnits == 'false' && $('.zero-allowed-js').index() == -1)
						|| val > max){
						parent.find('.validation-min-quantity-js').addClass('hidden-js');
						parent.find('.validation-quantity-range-max-js').addClass('hidden-js');
						parent.find('.validation-quantity-range-js').removeClass('hidden-js');
						parent.find('.validation-quantity-range-js').show().delay(3000).hide(300, function(){
							parent.find('.validation-quantity-range-js').addClass('hidden-js');
						});
					}
				}

                if($('.zero-allowed-js').index() != -1 && val <= 0){
                    if(__decUnits == 'true'){
                        input.val('0'+__decSep+'00');
                    } else {
                        input.val(0);
                    }
					input[0].dispatchEvent(new Event('input', { bubbles: true }));
                } else if(val < 1){
                    if(__decUnits == 'true'){
                        if(val < 0.01){
                            val = 0 + __decSep + '01';
                            input.val(val);
                        }
                    } else {
                        input.val(1);
                    }
					input[0].dispatchEvent(new Event('input', { bubbles: true }));
                }

				if(val < min && parent.find('.validation-min-quantity-js').length > 0){
                    input.val(min);
                }

                if(val > max){
                    if($('.zero-allowed-js').index() == -1 && min >= max && __decUnits == 'false'){
                        var max = '1';
					} else {
                        var max = input.data('max');
					}
                    input.val(max);
                }
				app.blockQuantityButtons(e, input);

				// quantity multiplicity
				if (typeof input.data('multiplicity') !== 'undefined') {
					val = Number(input.val().toString().replace(',', '.'));
					var multiplicity = Number(input.attr('data-multiplicity').toString().replace(',', '.'));
					if(multiplicity > 0 && val%multiplicity != 0){
						if(input.parents('.child-js').length > 0){
							input.parents('.child-js').find('.multiplicity-info-js').addClass('error');
						} else if(input.parents('.form-js').length > 0){
							input.parents('.form-js').find('.multiplicity-info-js').addClass('error');
						} else {
							$('.multiplicity-info-js').addClass('error');
						}
						input.addClass('validation-error');
						setTimeout(() => {
							$('.multiplicity-info-js').removeClass('error');
							input.removeClass('validation-error');
						}, 3000);
						var howManyTimes = Math.floor(val/multiplicity);
						if(howManyTimes < 1){
							val = multiplicity;
						} else {
							var lower = howManyTimes * multiplicity;
							var higher = (howManyTimes + 1) * multiplicity;
							var mid = (lower + higher) / 2;
							if(val < mid){
								val = lower;
							} else {
								val = higher;
								if(val > max){
									val -= multiplicity;
								}
							}
						}
						input.val(val);
						input[0].dispatchEvent(new Event('input', { bubbles: true }));
					}
				}
			}
		}
	},

	// Allow only digits and "," or "." in quantity input. Only 1-5 digits before decimal separator and 1-4 after. Don't allow decimal separator if __decUnits == 'false'.
	validateQuantitySigns: function(e) {
		var chr = String.fromCharCode(e.which);
		var val = $(e.currentTarget).val();
		var string = "0123456789";

		var ele  = e.currentTarget;
		if(window.getSelection().toString() != '' || (ele.value && ele.value.substring(ele.selectionStart, ele.selectionEnd) != '')){
			val = val.slice(0, ele.selectionStart) + val.slice(ele.selectionEnd);
		}

		if(__decUnits == 'true'){
			if(__decSep == ","){
				if(chr == __decSep){
					var regex = /^\d{1,5}\,\d{0,4}$/;
				} else {
					if(val.indexOf(__decSep) < 0){
						var regex = /^\d{1,5}$/;
					} else {
						var regex = /^\d{1,5}\,\d{1,4}$/;
					}
				}
			} else {
				if(chr == __decSep){
					var regex = /^\d{1,5}\.\d{0,4}$/;
				} else {
					var regex = /^\d{1,5}\.\d{1,4}$/;
				}
			}
			if(val.indexOf(__decSep) < 0){
				string = string + __decSep;
			}
		} else {
			var regex = /^\d{1,5}$/;
		}

		var selectionIndex = ele.selectionStart;
		var valWithChr = val.slice(0, selectionIndex) + chr + val.slice(selectionIndex);

		if (string.indexOf(chr) < 0 || (val != '' && !regex.test(valWithChr))){
			e.preventDefault();
			var separatorIndex = val.indexOf(',');
			if (separatorIndex < 0) {
				separatorIndex = val.indexOf('.');
			}
			if ((chr == '.' || chr == ',') && (val.charAt(selectionIndex) == ',' || val.charAt(selectionIndex) == '.')) {
				ele.setSelectionRange(selectionIndex + 1, val.length);
			} else if (separatorIndex > -1) {
				ele.setSelectionRange(separatorIndex, separatorIndex);
			}
		}

		app.blockQuantityButtons(e);
	},

    validateTin: function(tin, checkSum, formatRegexp) {
		tin = tin.toString();

		if(formatRegexp == undefined){
            var formatRegexp = new RegExp(/^(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})|(\d{2}-\d{3}-\d{3}-\d{2})|(\d{10})$/);
		}
		if (!formatRegexp.test(tin)) {
			return false;
		}

		if(formatRegexp != '/.*/' && checkSum){
			//Check checkdigit
			var sum = 6 * tin[0] +
				5 * tin[1] +
				7 * tin[2] +
				2 * tin[3] +
				3 * tin[4] +
				4 * tin[5] +
				5 * tin[6] +
				6 * tin[7] +
				7 * tin[8];
			sum %= 11;
			if (tin[9] != sum){
				return false;
			}
		}

		return true;
	},

	// Validate form on client side just before post.
	validationBeforePost: function(e, form) {
		var validation = '';
		if(form == undefined){
            var form = $(e.currentTarget).parents('.form-js');
		}
		var inputs = form.find('input:not([type="hidden"]):not([disabled])');
		if(form.hasClass('search-advanced-js')){
			var searchAdvanced = true;
		}
		inputs.each(function(index) {
			var type = $(this).attr('type');
			if(type == 'search' && $(this).val().replace(/\s/g, '').length == 0 && !searchAdvanced){
				validation = 'error';
			}
			if(searchAdvanced){
				if(index == 0){
					validation = 'error';
				}
				if((type == 'search' && $(this).val().replace(/\s/g, '').length != 0) || (type == 'checkbox' && $(this).prop('checked')) || (type == 'number' && $(this).val().replace(/\s/g, '').length != 0)){
					validation = '';
				}
			}
			if($(this).prop('required') && (((type == 'checkbox' || type == 'radio') && !$(this).prop('checked')) || ((type != 'checkbox' && type != 'radio') && $(this).val().replace(/\s/g, '').length == 0 && $(this).val().replace(/\s/g, '').length == 0))){
				$(this).parent().find('.validation-required-js').removeClass('hidden-js');
				$(this).parent().find('.form__input-info').addClass('validation-error');
				$(this).parent().find('.form__invalid-input.validation-info-js.validation-info-password-repeat-js').addClass('hidden-js');
				$(this).addClass('validation-error-js');
				if (type == 'checkbox') {
					$(this).next('label').addClass('validation-error-js');
				}
			}
            if($(this).attr('name') == 'channelKey' && $(this).attr('type') != 'hidden'){
                var channelParent = $(this).parent().parent();
                var tos = channelParent.find('[name=tos]');
                if($(this).prop('required') || channelParent.hasClass('statement-js') || (tos != undefined && (tos.prop('checked') || tos.prop('required')))){
                    var channels = channelParent.find('[name=channelKey]');
                    var nothingSelected = true;
                    channels.each(function () {
                        if($(this).prop('checked')){
                            nothingSelected = false;
                        }
                    });
                    if(nothingSelected){
                        channelParent.find('.validation-channel-js').removeClass('hidden-js');
                        $(this).addClass('validation-error-js');
                        validation = 'error';
                    }
				}
            }
			if (type == 'file') {
				var allowedFormats = $(this).attr('accept').split(',').map(x => x.trim());
				var maxFilesSize = $(this).data('file-size');
				if (this.files.length > 0) {
					var fileFormat = this.files[0].name.split('.')[1].toLowerCase();
					if (maxFilesSize && this.files[0].size > maxFilesSize) {
						var popup = '<div class="message-popup-background container-to-delete-js">'+
                		                '<div class="popup-container message-popup-on-background-js">'+
											'<div class="data-form__header">'+
												'<span>'+__translations.AttachementsNotAdded+'</span>'+
												'<form method="dialog">'+
													'<button class="close-button close-js" aria-label="'+__translations.Close+'">'+
														'<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
													'</button>'+
												'</form>'+
											'</div>'+
											'<div class="info">'+
                		                    	'<div><strong>'+this.files[0].name+'</strong>: '+$(this).data('size-exceeded')+'</div>'+
											'</div>'+
										'</div>'+
                		            '</div>';

						const modal = document.querySelector('.info-popup-js');
						modal.innerHTML = popup;
						modal.showModal();
						validation = 'error';
					}
					if (allowedFormats && !allowedFormats.includes('.' + fileFormat)) {
						var popup = '<div class="message-popup-background container-to-delete-js">'+
                		                '<div class="popup-container message-popup-on-background-js">'+
											'<div class="data-form__header">'+
												'<span>'+__translations.AttachementsNotAdded+'</span>'+
												'<form method="dialog">'+
													'<button class="close-button close-js" aria-label="'+__translations.Close+'">'+
														'<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
													'</button>'+
												'</form>'+
											'</div>'+
											'<div class="info">'+
                		                    	'<div><strong>'+this.files[0].name+'</strong>:</div>'+
												'<div>'+
													$(this).data('invalid-file')+
												'</div>'+
											'</div>'+
										'</div>'+
                		            '</div>';

						const modal = document.querySelector('.info-popup-js');
						modal.innerHTML = popup;
						modal.showModal();
						validation = 'error';
					}
				}
			}
			var validationInfos = $(this).parent().find('.validation-info-js');
			validationInfos.each(function() {
				if(!$(this).hasClass('hidden-js') && !$(this).hasClass('validation-min-quantity-js')){
					validation = 'error';
				}
				if ($(this).hasClass('allow-not-hidden-js')) {
					validation = '';
				}
			});
		});
		var textarea = $(e.currentTarget).parents('.form-js').find('textarea');
		if(textarea.prop('required') && textarea.val().replace(/\s/g, '').length == 0){
			textarea.parent().find('.validation-required-js').removeClass('hidden-js');
			textarea.parent().find('.form__input-info').addClass('validation-error');
			textarea.addClass('validation-error-js');
			validation = 'error';
		}
		if(searchAdvanced){
			var selects = form.find('select');
			selects.each(function(index) {
				if($(this).val() != ''){
					validation = '';
				}
			});
		}

		var selectGender = form.find('select[name="gender"]'); 
		if (selectGender.prop('required') && selectGender.length !== 0){
			selectGender.each(function(index) {
				if($(this).val() === '' || $(this).val() === null ){
					$(this).parent().find('.validation-required-js').removeClass('hidden-js');
					$(this).parent().find('.form__input-info').addClass('validation-error');
					$(this).addClass('validation-error-js');
					validation = 'error';
				} else{
					$(this).parent().find('.validation-required-js').addClass('hidden-js');
					$(this).parent().find('.form__input-info').removeClass('validation-error');
					$(this).removeClass('validation-error-js');
				}
			});
		}

		var customSelect = form.find('#selectDSA');
		if (customSelect.length > 0) {
			if (customSelect.val() === 'null') {
				customSelect.parents('.form__input-wrapper').find('.validation-required-js').removeClass('hidden-js');
				customSelect.parents('.form__input-wrapper').find('.form__input-info').addClass('validation-error');
				customSelect.parents('.form__input-wrapper').find('.form__input-value').addClass('validation-error-js');
				validation = 'error';
			} else {
				customSelect.parents('.form__input-wrapper').find('.validation-required-js').addClass('hidden-js');
				customSelect.parents('.form__input-wrapper').find('.form__input-info').removeClass('validation-error');
				customSelect.parents('.form__input-wrapper').find('.form__input-value').removeClass('validation-error-js');
			}
		}

		return validation;
	},

	// Serialize and post form via AJAX. You can type callback (function to trigger after AJAX success) and callbackObj (parameters of callback).
	post: function(e, callback, callbackObj, container, template) {
		if(app.validationBeforePost(e) != 'error'){
			var form = $(e.currentTarget).parents('.form-js').eq(0);
			var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
			var temp = template;
			var cont = container;
			const eventCopy = {...e};
			
			for(var i=0; i<data.length; i++){
				if(data[i].value.includes('Get/')){
					var get = true;
				}
			}

			if(get == undefined){
				data.push({name: "__csrf", value: __CSRF});
			}

			// decide which Id to post (only on product-presentation forms)
			if(form.hasClass('need-product-id-js')){
				if($(e.currentTarget).parents('.ammount-stepper-js').data('supply-id') != undefined){
					var productId = $(e.currentTarget).parents('.ammount-stepper-js').data('supply-id');
				} else if($('[name="supplyId"]').index() != -1 && !form.hasClass('add-to-cart-js') && $('[name="productType"]').val() == 'clip'){
					if (form.parents('.ask-for-price-js').index() != -1) {
						var supplies = $('[name="supplyId"]');
						for (let i in supplies) {
							if ($(supplies[i]).parent().hasClass('active-js')) {
								var productId = $(supplies[i]).val();
								break;
							}
						}
					} else {
						var productId = $('[name="supplyId"]').val();
					}
				} else if($(e.currentTarget).data('id') != undefined && $(e.currentTarget).parents('.add-variants-to-cart-from-prod-list-popup-background-js').length > 0){
					var productId = $(e.currentTarget).data('id');
				} else {
					var productId = $('[data-product-id]').data('product-id');
				}
				data.push({name: "productId", value: productId});
			}

            if(form.hasClass('add-to-cart-js')){
				if($(e.currentTarget).hasClass('add-to-inquiry-js')){
					var activeInquiryId = app.getCookie('activeInquiryId');
					if(activeInquiryId == -1 || activeInquiryId == ''){
						activeInquiryId = callbackObj;
					}
					data.push({name: "cartId", value: activeInquiryId});
				} else if(window.app.getCookie('lastCartId') == undefined || window.app.getCookie('lastCartId') == -1){
					data.push({name: "__collection", value: 'customer.Cart.Id'});
				}
                if(form.hasClass('add-set-to-cart-js')){
					var set = {setId:Number($(e.currentTarget).data('set-id')), quantity:1, products:[]};
					var setProducts = form.find('.set-product-js');
					setProducts.each(function () {
						var setProduct = {
							setElementId: Number($(this).data('set-element-id')),
							setProductId: Number($(this).data('set-product-id'))
						};
						
						var supplyInput = $(this).find('.set-product-supply-id-js');
						if(supplyInput.length > 0) {
							setProduct.supplyId = Number(supplyInput.val());
						}
						
						if($(this).find('[name=attributePolyvalent]').length > 0){
							var attributesPolyvalent = [];
							$(this).find('[name=attributePolyvalent]').each(function(){
								var attribute = {
									id: Number($(this).data('id')),
									valueId: Number($(this).val())
								};
								attributesPolyvalent.push(attribute);
							});
							setProduct.attributesPolyvalent = attributesPolyvalent;
						}
						if($(this).find('[name=attributeEditable]').length > 0){
							var attributesEditable = [];
							$(this).find('[name=attributeEditable]').each(function(){
								var attribute = {
									id: Number($(this).data('id')),
									value: $(this).val()
								};
								attributesEditable.push(attribute);
							});
							setProduct.attributesEditable = attributesEditable;
						}
						set.products.push(setProduct);
					});
					var data = [
						{name: "__csrf", value: __CSRF}, 
						{name: "__action", value: 'Cart/SetExtAdd'}, 
						{name: "set", value: JSON.stringify(set)}
					];
					if(window.app.getCookie('lastCartId') == undefined || window.app.getCookie('lastCartId') == -1){
						data.push({name: "__collection", value: 'customer.Cart.Id'});
					}
				}
            }

			var obj = app.getTemplate(e);

            if(data[0].value == 'Customer/Logout') {
                obj.template = undefined;
			}

			var templatesArr = [];
            for(i=0; i<data.length; i++){
            	if(data[i].name == '__template'){
            		var dataTemplate = data[i].value;
            		data.splice(i, 1);
				}
			}

            if(dataTemplate != undefined) {
                templatesArr.push(dataTemplate);
            }
            if(obj.template != undefined && obj.template != dataTemplate) {
            	templatesArr.push(obj.template);
			}
            if(template != undefined && template != dataTemplate && template != obj.template) {
                templatesArr.push(template);
            }

			var templatesString = templatesArr.join('|');

            if(data[0].value == 'Cart/QuantityChange' && templatesString.indexOf('partials/common/header/client-area.html') === -1 && templatesString != '') {
				data.push({name: "__template", value: templatesString+'|partials/common/header/client-area.html'});
			} else if ($(e.currentTarget).hasClass('header-cart-deleter-js') || $(e.currentTarget).hasClass('header-inquiry-deleter-js')) {
				data.push({name: "__template", value: 'partials/common/header/client-area.html'});
				if ($(e.currentTarget).hasClass('header-cart-deleter-js')) {
					data.push({name: "__include", value: '"showSmallCart"'});
				} else {
					data.push({name: "__include", value: '"showSmallInquiry"'});
				}
			} else if(templatesString != '') {
				data.push({name: "__template", value: templatesString});
			} else if (data[0].value == 'Cart/QuantityChange' && $('.order-template-js').length > 0) {
				data.push({name: "__template", value: $('.order-template-js').data('template')});
			}

            if(obj.include != null ){
                data.push({name: "__include", value: obj.include});
			}

			if($(e.currentTarget).hasClass('remove-product-from-cart-js')){
				data.push({name: "__collection", value: 'customer.Cart.CartEmpty'});
			}

			if($(e.currentTarget).parents('.set-element-js').length > 0){		
				var setNo = $(e.currentTarget).parents('[data-product-no]:not(.set-element-js)').data('product-no');
			}

			if (data[0].value == 'Cart/Add') {
				let isSource = false;
				let indexToRemove = -1;
				$.each(data, function(index, value) {
					if (value.name && value.name === 'source') {
						if (value.value && value.value != '') {
							isSource = true;
						} else {
							indexToRemove = index;
						}
					}
				});
				
				if (indexToRemove != -1) {
					data.splice(indexToRemove, 1);
				}
	
				const urlParameters = new URLSearchParams(window.location.search);
				const AIProductRecommendation = urlParameters.get('ai-recommendation');
				const AICartRecommendation = urlParameters.get('ai-cart-recommendation');
			
				if ((__AIEnabled == true || __AIEnabled == 'true') && isSource == false) {
					if (AIProductRecommendation) {
						data.push({name: "source", value: 1});
					} else if (AICartRecommendation) {
						data.push({name: "source", value: 2});
					}
				}
			}
			
			$.post(obj.url, data, function(result) {
				if(window.step == 'Start'){
					if((obj.template != undefined && temp != undefined) || (obj.template != undefined  && data[0].value == 'Cart/QuantityChange')){
						var template = result.template[0];
					} else {
						var template = result.template;
					}
					app.afterReplaceTemplate(e, obj, template);
				} else {
					if(form.hasClass('add-to-cart-js')){
						var products = result.action.Products;
						if(products.length > 0){
							var productsForDataLayer = [];
							var productsForGA4DataLayer = [];
							var productsForFBPixel = [];
							var productsForTTPixel = [];
							var productsForSCPixel = [];
							var totalValue = 0;
							var basicUnitTotalValue = 0;
							for(var i=0; i<products.length; i++){
								var productDL = { id: products[i].Id.toString(), name: products[i].NameNoHtml, price: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
								var productGA4DL = { item_id: products[i].Id.toString(), item_name: products[i].NameNoHtml, price: products[i].TotalPrice, quantity: products[i].Quantity };
								var productFBP = { id: products[i].Id.toString(), content_name: products[i].NameNoHtml, value: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
								var productTTP = { content_id: products[i].Id.toString(), content_name: products[i].NameNoHtml, price: products[i].BasicUnitTotalPrice, quantity: products[i].BasicUnitQuantity };
								totalValue = totalValue + (products[i].TotalPrice * products[i].Quantity);
								basicUnitTotalValue = basicUnitTotalValue + (products[i].BasicUnitTotalPrice * products[i].BasicUnitQuantity);
								productsForDataLayer.push(productDL);
								productsForGA4DataLayer.push(productGA4DL);
								productsForFBPixel.push(productFBP);
								productsForTTPixel.push(productTTP);
								productsForSCPixel.push(products[i].Id.toString());
							}
							var dataLayerProds = {
								"products": productsForDataLayer
							};
							window.dataLayer.push({
								"event": "addToCart",
								"ecommerce": {
									"currencyCode": __currCode,
									"add": dataLayerProds
								}
							});
							if(typeof gtag != 'undefined'){
								gtag("event", "add_to_cart", {
									currency: __currCode,
									value: totalValue,
									items: productsForGA4DataLayer
								});
							}
							if(typeof _edrone !== 'undefined') {
								_edrone.action_type = 'add_to_cart';
								_edrone.init();
							}
							if(typeof fbq !== 'undefined') {
								fbq('track', 'AddToCart',
									{
										value: basicUnitTotalValue,
										currency: __currCode,
										content_type: 'product',
										contents: productsForFBPixel
									}
								);
							}
							if(typeof ttq !== 'undefined') {
								ttq.track('AddToCart',
									{
										value: basicUnitTotalValue,
										currency: __currCode,
										content_type: 'product',
										contents: productsForTTPixel
									}
								);
							}
							if(typeof snaptr !== 'undefined') {
								snaptr('track', 'ADD_CART',
									{
										price: basicUnitTotalValue,
										currency: __currCode,
										items_ids: productsForSCPixel,
										number_items: i,
										client_dedup_id: 'ADD_CART_' + new Date().getTime()
									}
								);
							}
						}
					}
					if(result.action.Code == 1023 || result.action.Code == 1024){						
						const productLists = document.querySelector('.products-list-js');
						let isGridView = false;
						if (productLists) {
							isGridView = productLists.contains(productLists.querySelector('.with-grid-view-js'));
						}

						if (isGridView || document.querySelector('.newsSection-js') || document.querySelector('.comparer-js') || document.querySelector('.lookbook-js')) {
                            const promise = new Promise((resolve) => {
                                const productId = data.find((element) => element.name === 'productId').value;
                                const response = $.get('_/3-2-' + productId, {
                                    __template: 'partials/product/amount-set-product.html',
                                });
                                resolve(response);
                            });

                            promise.then((response) => {
                                const message = result.action.Validation[0].Error;
                                const template = response?.template;

								if (!template) {
									app.serverMessage(result, form, eventCopy);
									return;
								}

                                document.getElementById('main').insertAdjacentHTML('afterend', template);
                                const popup = document.querySelector(".set-amount-popup-js");

                                const amountStepperInput = popup.querySelector('[name = "quantity"][type="text"]');
                                const price = parseFloat(amountStepperInput.dataset.priceNumber);
                                const sumText = popup.querySelector('.set-amount-sum-js');
                                const amount = parseFloat(amountStepperInput.value);
                                const button = popup.querySelector(".add-proper-amount-js");
								const multiplicity = parseFloat(amountStepperInput.dataset.multiplicity);

                                const minq = parseFloat(amountStepperInput.dataset.minq);

								button.disabled = result.action.Code === 1023;
								
                                popup.querySelector(".message-amount-js").innerHTML = message;

                                const transformTextSum = (text) => {
                                    text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                                    text = text.replace('.', ',');

                                    return text;
                                }
                                
                                sumText.innerHTML = transformTextSum((price * amount).toFixed(2).toString());

                                amountStepperInput.addEventListener('input', (e) => {
                                    const val = e.currentTarget.value;
									const numberVal = parseFloat(val);
									sumText.innerHTML = isNaN(numberVal) ? '0,00' : transformTextSum((price * numberVal).toFixed(2).toString());
                                    popup.querySelector('[name = "quantity"][type="hidden"]').value = numberVal;
									const rest = numberVal % multiplicity;

                                    if ((numberVal < minq && result.action.Code === 1023) || isNaN(numberVal) || (rest !== 0 && !isNaN(multiplicity))) {
                                        button.disabled = true;
                                    } else {
                                        button.disabled = false;
                                    }
                                });

                                popup.showModal();
                            });
						} else {
							const isInquiry = data.some(param => {
								return param.name === 'cartId';
							});

							if (!isInquiry) {
								const validationContainer = e.target.closest('.add-to-cart-js');
								const inputs = validationContainer.querySelectorAll('[name="quantity"][type="text"]');
								const allUnits = validationContainer.querySelectorAll('.memory-js');
								const addToCartButton =  validationContainer.querySelector('.add-to-cart-update-client-area-js');
								app.MMQVal(inputs, allUnits, addToCartButton);
							}

							app.serverMessage(result, form, eventCopy);
						}
					}else {
						app.serverMessage(result, form, eventCopy);
					}
					if (result.action.Result) {
						if(form.hasClass('add-to-cart-js') && !$(e.currentTarget).hasClass('add-to-inquiry-js') && (window.app.getCookie('lastCartId') == undefined || window.app.getCookie('lastCartId') == -1 || window.app.getCookie('lastCartId') == '')){
							var cartId = result.collection;
							window.app.setCookie('lastCartId', cartId);
						}
						if(result.collection){
							window.app.setCookie('lastCartId', -1);
						}
						var isCallbackAlreadyTrigger = false;
						if(result.action.Redirect302 != null && !form.hasClass('add-to-cart-js') && !form.hasClass('sign-in-cart-js') && !form.hasClass('sign-in-form-popup-js')){
							if(window.location.hash.includes('#back-to-cart')){
								var url = window.location.hash.split('-')[3];
								app.replace(url);
							} else if (result.action.Action === 'Customer/LanguageChange') {
								app.replace(app.getLanguageChangeRedirect(eventCopy, result.action.Redirect302));
							} else {
								app.replace(result.action.Redirect302);
							}
							
						} else if(form.hasClass('sign-in-cart-js') || form.hasClass('sign-in-form-popup-js')){
							if(callback != undefined){
								callback(callbackObj).then(function() {
									isCallbackAlreadyTrigger = true;
									app.reload();
								}).catch(function() {
									setTimeout(function(){ 
										app.reload();
									}, 3000);
								});
							} else {
								setTimeout(function(){ 
									app.reload();
								}, 3000);
							}
						}
						if(result.template){
							if((obj.template != undefined && temp != undefined) || result.template[1]){
								if ($(eventCopy.currentTarget).hasClass('header-cart-deleter-js') || $(eventCopy.currentTarget).hasClass('header-inquiry-deleter-js')) {
									$(cont).html(result.template);
									if ($(eventCopy.currentTarget).parents('.setParent-js').length > 0) {
										var count = Number($(eventCopy.currentTarget).parents('.setParent-js').data('set-elements'));
									} else {
										var count = 1;
									}
									app.removeItemFromCartHeader(count);
									app.activateFocusTrap('.header-cart', e.currentTarget);
								} else {
									if (Array.isArray(result.template)) {
										if ($(cont).hasClass('replace-with-js')) {
											$(cont).replaceWith(result.template[1]);
										} else {
										$(cont).html(result.template[1]);
										}
									} else {
										if ($(cont).hasClass('replace-with-js')) {
											$(cont).replaceWith(result.template);
									} else {
										$(cont).html(result.template);
									}
										$(cont).html(result.template);
									}
								}
								changeHeaderCart();

							} else if(temp != undefined) {
								if ($(e.currentTarget).hasClass('header-cart-deleter-js') || $(e.currentTarget).hasClass('header-inquiry-deleter-js')) {
									$(cont).html(result.template);

									let currentPrice = parseFloat($('.cart-value-js .cart-value-with-currency-js').html().replace(',', '.').replace('&nbsp;', '').replace(' ', ''));
									let newValue = parseFloat(currentPrice - parseFloat(data[2].value.replace(',', '.')));

									$('.cart-value-js').text(newValue > 0 ? newValue.toPrice() : 0);
									$('.cart-value-with-currency-js').text(newValue > 0 ? newValue.toPrice() : 0);
									
									currentCount == 1 ? $('.counter-bg-js').addClass('hidden-js') : '';
								} else {
									$(cont).html(result.template);
								}
								changeHeaderCart();
							}
						}
						if(setNo){
							$('[data-product-no='+setNo+']').find('.dropdown-arrow').trigger('click');
						}
						if(callback != undefined && !isCallbackAlreadyTrigger){
							callback(callbackObj);
						}
					} else if(form.hasClass('login-form-js')) {
						var container = $('.login-form-js');
						container.children().removeClass('hidden-js');
						container.find('.loading-cart-in-progress-js').addClass('hidden-js');
						container.find('.loader-js').addClass('hidden-js');
					}
				}
				if (result.action.Result && data[0].value == 'Cart/QuantityChange') {
					if (data[2].name !== 'isFromHeader' && $('.inquiry-container-js').index() == -1) {
						if(obj.template != undefined){
							$('.client-area-js').html(result.template[1]);
						} else {
							$('.client-area-js').html(result.template);
						}
						changeHeaderCart();
					}
				}
				$('.during-ajax-modal-js').addClass('hidden-js');

				setTimeout(function() {
					app.focusManager.restoreFocus();
				}, 1500);
			});

			// delete validation error on input from auto-post form (only 2nd and 3rd step on order)
			$(e.currentTarget).removeClass('error-js');
		} else {
			// mark validation error on input from auto-post form (only 2nd and 3rd step on order)
			$(e.currentTarget).addClass('error-js');
			$('.during-ajax-modal-js').addClass('hidden-js');
			if($(e.currentTarget).hasClass('login-js')) {
				var container = $('.login-form-js');
				container.children().removeClass('hidden-js');
				container.find('.loading-cart-in-progress-js').addClass('hidden-js');
				container.find('.loader-js').addClass('hidden-js');
			}
		}
	},

	// Create message after posting some data. Messages are taken from server.
	serverMessage: function(result, form, e) {
        if (result.action.Result) {
            if (result.action.Message != "" && result.action.Message != null) {
                var message = '<p role="alert" class="popup-message-js">' + result.action.Message + "</p>"
            }
            if (result.action.Description != "" && result.action.Description != null) {
                message += '<p role="alert" class="popup-message-js">' + result.action.Description + "</p>"
            }
			if (["Customer/PasswordRecover", "Customer/PasswordChange", "Customer/OldPasswordChange"].includes(result.action.Action)) {
				app.formIntoMessage(result, form, message);
			} else if (form.hasClass("form-into-data-js") && message != undefined) {
				var obj = app.getTemplate(e);
				if (typeof result.template == "object") {
					app.afterReplaceTemplate(e, obj, result.template[0]);
					app.temporaryPopupMessage(form, message, result.action.Type);
				} else {
					app.afterReplaceTemplate(e, obj, result.template);
					app.temporaryPopupMessage(form, message, result.action.Type);
				}
            } else if (form.hasClass("form-into-data-js") && message == undefined && form != undefined && form.data("success") != undefined) {
                var message = form.data("success");
                var obj = app.getTemplate(e);
                if (typeof result.template == "object") {
                    app.afterReplaceTemplate(e, obj, result.template[0], message)
                } else {
                    app.afterReplaceTemplate(e, obj, result.template, message)
                }
            } else if (form.hasClass("form-into-temporary-message-js") && message != undefined) {
                app.temporaryPopupMessage(form, message, result.action.Type)
            } else if (form.hasClass("form-into-temporary-message-js") && message == undefined && form != undefined && form.data("success") != undefined) {
                var message = form.data("success");
                app.temporaryPopupMessage(form, message, result.action.Type)
            } else if (form.hasClass("add-to-cart-js") && message != undefined) {
                if ($(e.currentTarget).hasClass("add-to-inquiry-js")) {
                    if(typeof result.template == 'object'){
						window.dispatchEvent(new CustomEvent('inquiry:added', {
							detail: {
							  event: e,
							  template: result.template[0],
							  products: result.action.Products
							}
						  }));
                    } else {
						window.dispatchEvent(new CustomEvent('inquiry:added', {
							detail: {
							  event: e,
							  template: result.template,
							  products: result.action.Products
							}
						  }));
                    }
                } else {
                    if (typeof result.template == "object") {
                        var productsInCart;
                        if (__productIsInCart == "productIsInCart-yes") {
                            app.getProductsIdsFromCart(function(res) {
                                productsInCart = res
                            });
                            $(".product-item-js").each(function(index) {
                                let productId = parseInt($(".product-item-js").eq(index).find("#isInCartId").val());
                                if (!isNaN(productId)) {
                                    let isInCart = app.checkIfProductIsInCart(productsInCart, productId);
                                    app.enableDisableInCartButton(isInCart, 2, index)
                                }
                            });
							if($('[name=productType]').val() == 'simple' && $('.product-presentation-js').length > 0){
								let productId = parseInt($('.product-presentation-js').data('product-id'));
								if (!isNaN(productId)) {
									let isInCart = app.checkIfProductIsInCart(productsInCart, productId);
									app.enableDisableInCartButton(isInCart)
								}
							}
                        }
						window.dispatchEvent(new CustomEvent('cart:added', {
							detail: {
								event: e,
								template: result.template[0],
								products: result.action.Products
							}
						}));
                    } else {
						window.dispatchEvent(new CustomEvent('cart:added', {
							detail: {
								event: e,
								template: result.template,
								products: result.action.Products
							}
						}));
                    }
                }
			} else if (result.action.Message === null && result.action.Results !== undefined) {
				if (result.action.Results.length > 0) {
					let isError = 0;
					let allProducts = 0;
					for (const response of result.action.Results) {
						allProducts++;
						if (response.Result !== true) {
							isError++;
						}
					}
					if (isError === 0) {
						window.dispatchEvent(new CustomEvent('cart:added', {
							detail: {
								event: e,
								template: result.template,
								products: result.action.Products
							}
						}));
					} else {
						const lookbookMessage =__translations.Lookbook_Add_All_Cart.replace("{0}", isError).replace("{1}", allProducts);
						app.temporaryPopupMessage(form, lookbookMessage, "err");
					}
				}
            } else if (message != undefined || message == undefined && form != undefined && form.data("success") != undefined) {
				if (form.hasClass("lookbook-js") && result.action.Result) {
					window.dispatchEvent(new CustomEvent('cart:added', {
						detail: {
							event: e,
							template: result.template,
							products: result.action.Products
						}
					}));
				} else {
					app.temporaryPopupMessage(form, message, result.action.Type)
				}
            } else if (form.hasClass("no-message-js")) {
                var obj = app.getTemplate(e);
                if (result.template == null) {} else if (typeof result.template == "object") {
                    if ($(".validation-min-quantity-js:not(.hidden-js)").length > 0) {
                        setTimeout( () => {
                            app.afterReplaceTemplate(e, obj, result.template[0]);
                            // app.setProductNameMaxWidthInTable()
                        }
                        , 3e3)
                    } else {
                        app.afterReplaceTemplate(e, obj, result.template[0])
                    }
                } else {
                    app.afterReplaceTemplate(e, obj, result.template)
                }
            }
        } else {
            var messageInPopup = false;
            if (form.hasClass("popup-message-js")) {
                messageInPopup = true
            }
            if (result.action.Results) {
                var validationArr = result.action.Results[0].Validation;
                var msg = result.action.Results[0].Message;
                var description = result.action.Results[0].Description
            } else {
                var validationArr = result.action.Validation;
                var msg = result.action.Message;
                var description = result.action.Description
            }
            if (validationArr != null) {
                var length = validationArr.length;
                var errors = "";
                for (var i = 0; i < length; i++) {
                    errors = errors + "<p>" + validationArr[i].Error + "</p>"
                }
                var message = "<strong>" + msg + "</strong>" + errors
            } else {
                if (messageInPopup) {
                    if (msg != "" && msg != null || description != "" && description != null) {
                        var message = "<p>" + msg + "<br/>" + description + "</p>"
                    }
                } else {
                    if (msg != "" && msg != null) {
                        var message = "<p>" + msg + "</p>"
                    }
                    if (description != "" && description != null) {
                        message += "<p>" + description + "</p>"
                    }
                }
            }
            if(result.action.Code != 100){
				if(form.hasClass('change-quantity-in-cart-js')){
                    var container = form.find('.cart-amount-stepper-validation-js');
					if (container.length <= 0) {
						container = form;
					}
                    container.find('.error-msg-js').remove();
                    var messageContainer = '<div class="cart-amount-stepper-validation__error error-msg-js">'+description+'</div>';
					if(result.action.Code == 102) {
						messageContainer = '<div class="cart-amount-stepper-validation__error error-msg-js">Przekroczono wartość maksymalną.</div>';
                    }
                    container.append(messageContainer);
                    container.find(".error-msg-js").delay(3e3).fadeOut(300, function() {
                        $(this).remove()
                    });

                    var input = form.find('[name="quantity"]');
					var lastProperQuantity = input.data('last-proper-quantity');
					if (__decUnits == 'true') {
						var decimal = lastProperQuantity.toString().split('.')[1];
                        if (decimal != undefined && decimal.length == 1) {
							if (__decSep == ',') {
								lastProperQuantity = lastProperQuantity.toString().replace('.', ',') + '0';
                            } else {
								lastProperQuantity = lastProperQuantity + '0';
                            }
                        } else if (decimal == undefined) {
							lastProperQuantity = lastProperQuantity + __decSep + '00';
						} else if (__decSep == ',') {
							lastProperQuantity = lastProperQuantity.toString().replace('.', ',');
                        }
                    }
					input.val(lastProperQuantity);
                } else {
                    app.temporaryPopupMessage(form, message, result.action.Type)
                }
            }
			if(result.action.Action == "Order/CouponAdd" && result.action.Code == 107){
				const emailInput = $('.cart-coupon-box-js [name="email"]');
				emailInput.prop('required', true);
				$('.cart-coupon-email-js').removeClass('hidden-js');
            }
        }
    },
	
	// Create message.
	message: function(message) {
		var container = '<div class="popup-in-form error" style="display:none;"><div class="popup-in-form__content"><svg width="16" height="16" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#exclamation-circle-'+__iconStyle+'"></use></svg>'+ message +'</div><button class="popup-in-form__close close-js"><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button></div>';
		$('#main').find('.popup-in-form').remove();
		$('#main').prepend(container).find('.popup-in-form').fadeIn(300);
		$('.popup-in-form').delay(4000).fadeOut(600);
	},

	// create popup message (in progress)
	temporaryPopupMessage: function(form, message, messageType) {
		$('body').find('.popup-info').remove();
		form = $('body');
		var dom = $.parseHTML(message);
		var popupTitle, popupIcon, temporaryPopup, title = '';
		var msgType = messageType || 'info';
	
		switch (msgType) {
			case 'msg':
				popupTitle = __translations.MessageSuccess;
				popupIcon = '<svg height="16" width="16"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#check-circle-'+__iconStyle+'"></use></svg>';
				break;
			case 'err':
				popupTitle = __translations.MessageError;
				popupIcon = '<svg height="16" width="16"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#exclamation-circle-'+__iconStyle+'"></use></svg>';
				break;
			case 'warn':
				popupTitle = __translations.MessageWarning;
				popupIcon = '<svg height="16" width="16"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#exclamation-triangle-'+__iconStyle+'"></use></svg>';
				break;
			case 'info':
			default:
				popupTitle = __translations.MessageInfo;
				popupIcon = '<svg height="16" width="16"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#exclamation-circle-'+__iconStyle+'"></use></svg>';
				break;
		}
	
		if (dom[0] != undefined) {
			var title = dom[0].textContent;
			var infos = '';
			if (dom.length > 1) {
				for (var i = 1; i < dom.length; i++) {
					infos += dom[i].outerHTML;
				}
                infos = '<div class="info">'+infos+'</div>';
				form.prepend('<div role="alert" class="popup-info ' + msgType + ' popup-info-js" style="display:none;" data-isStarted="false"><button aria-label="'+__translations.Close+'" class="popup-info__close popup-info-close-js"><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button><div class="popup-info__content"><h2>' + popupIcon + title +
					'</h2>'+ infos +'</div><div class="popup-info__bar"><div class="popup-info__bar-progress"></div></div></div>');
			} else {
				form.prepend('<div role="alert" class="popup-info ' + msgType + ' popup-info-js" style="display:none;" data-isStarted="false"><button aria-label="'+__translations.Close+'" class="popup-info__close popup-info-close-js"><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button><div class="popup-info__content"><h2>' + popupIcon + popupTitle +
					'</h2><div role="alert" class="popup-message-js"><p>' + title + '</p></div></div><div class="popup-info__bar"><div class="popup-info__bar-progress"></div></div></div>');
			}
		}
	
		var temporaryPopup = $('body .popup-info');
		temporaryPopup.fadeIn(300);
		this.popupInfo();
	},
	
    //create message container
    createMessageContainer: function(message) {
        var dom = $.parseHTML(message);
        if(dom[0] != undefined){
            var title = dom[0].textContent;
            if(dom.length > 1){
                var infos = '';
                for(var i=1; i<dom.length; i++){
                    infos += dom[i].textContent;
                }
                infos = '<div class="info">'+infos+'</div>';
                var messageContainer = '<div class="successfull-post-message successfull-post-message-js"><span class="message-header">'+ title +'</span>'+ infos +'</div>';
            } else {
                var messageContainer = '<div class="successfull-post-message successfull-post-message-js"><span class="message-header">'+ title +'</span></div>';
            }
            return messageContainer;
		}
    },

	// After successfull post - replace form with info for customer that post was successfull.
	formIntoMessage: function(result, form, message) {

        if(form.data('success') != undefined){
            message = form.data('success');
        }

		if(result.action.Action === "Customer/PasswordRecover")  {
			urlLogin = $('.reminder-container').data('url');
			emailValue = $('.reminder-container input[name=email]').val();
			if($('.remove-tab-title').index() != -1){
				$('.remove-tab-title').remove();
			}
			var messageContainer = '<div class="reminder-header">' + __translations.LinkSent +'</div><div class="reminder-info">' + __translations.PasswordRecovery + '</div><a class="primary-action-button" aria-label="loginRedirect" href="'+ urlLogin +'" rel="nofollow" class="loginRedirect">'+ __translations.BackToLogin + '</a>';
			form.replaceWith(messageContainer);
			$('body').find( "span.reminder-email" ).text(emailValue);
		} else if (result.action.Action === "Customer/PasswordChange") {
			urlLogin = $('.reminder-container').data('url');
			var messageContainer = app.createMessageContainer(message) + '</div><a class="primary-action-button" aria-label="loginRedirect" href="'+ urlLogin +'" rel="nofollow" class="loginRedirect">'+ __translations.BackToLogin + '</a>';
			form.replaceWith(messageContainer);
		} else if ("Customer/OldPasswordChange") {
			var messageContainer = app.createMessageContainer(message);
			form.replaceWith(messageContainer);
		} else {
			var messageContainer = app.createMessageContainer(message);
			form.replaceWith(messageContainer);
			if($('.remove-tab-title').index() != -1){
				$('.remove-tab-title').remove();
			}
		}
	},
	
	// After successfull post - replace form with temporary info for customer that post was successfull.
	formIntoTemporaryMessage: function(form, message) {
        var messageContainer = app.createMessageContainer(message);
		var container = form.parents('.container-js');
		container.html(messageContainer);
		setTimeout(function () {
            container.html('');
        }, 3000);
	},

	// After successfull post - append temporary message that will disappear after few seconds.
	temporaryMessage: function (container, message) {
		container.find('.successfull-post-message-js').remove();
        var messageContainer = app.popupMessage(message);
		container.append(messageContainer);
		container.find('.successfull-post-message-js').delay(3000).fadeOut(300, function(){
			$(this).remove();
		});
	},

	formLabelAnimationOnLoadPage: function () {
		let allInputs = document.querySelectorAll('input, select, textarea');
		if (document.querySelector('.order-template-js')) {
			allInputs = document.querySelectorAll('input, select');
		}
		for (var i = 0; i < allInputs.length; i++) {
			var input = allInputs[i];
			if (input.id === 'selectDSA' || input.type === 'date') {
				continue;
			}
			if (input.closest('.form__input-wrapper')) {
				formLabelAnimation(input);
			}
		}
	},

	// Reload page.
	reload: function(delay, form) {
		if(delay != undefined){
			setTimeout(function () {
				window.location.reload();
			}, delay);
		} else {
			window.location.reload();
		}
	},

	// Redirect target after Customer/LanguageChange (blog details -> blog list in new language).
	getLanguageChangeRedirect: function(e, defaultUrl) {
		if (typeof __languageRedirectUrls === 'undefined') return defaultUrl;

		const lang = $(e.currentTarget).data('lname');

		return __languageRedirectUrls[lang] || defaultUrl;
	},

	// Replace page.
	replace: function(url, delay, form) {
		if(delay != undefined){
			if($('.successfull-post-message-js .info').index() != -1){
                $('.successfull-post-message-js .info').append('<div>'+__redirectInfo+'</div>');
			} else {
                $('.successfull-post-message-js').append('<div class="info">'+__redirectInfo+'</div>');
			}
            if($('.remove-tab-title-js').index() != -1){
                $('.remove-tab-title-js').remove();
			}
			setTimeout(function () {
				window.location.assign(url);
			}, delay);
		} else {
			window.location.assign(url);
		}
	},

	// Dropdown position updater
	updateDropdownPosition: function(trigger, dropdown) {
		const triggerOffset = trigger.offset();
		const triggerHeight = trigger.outerHeight();
		const triggerWidth = trigger.outerWidth();
		const scrollTop = $(window).scrollTop();
		const windowWidth = $(window).width();
		
		const distanceFromRight = windowWidth - (triggerOffset.left + triggerWidth);
		const newTop = triggerOffset.top - scrollTop + triggerHeight;
		
		dropdown.css({
			position: 'fixed',
			top: newTop + 'px',
			right: distanceFromRight + 'px',
			minWidth: triggerWidth + 'px'
		});
	},

	// Scroll and resize listener for dropdown
	bindScrollListener: function(trigger, dropdown) {
		const scrollHandler = () => {
			this.closeDropdown(trigger);
		};
		
		const resizeHandler = () => {
			if (!dropdown.hasClass('hidden-js')) {
				this.updateDropdownPosition(trigger, dropdown);
			}
		};

		$(window).on('scroll.dropdownScroll', scrollHandler);
		$(window).on('resize.dropdownScroll', resizeHandler);
		$('.eshop__table-container').on('scroll.dropdownScroll', scrollHandler);
	},

	// Bind keyboard navigation for dropdown
	bindKeyboardNavigation: function(trigger, dropdown) {
		const options = dropdown.find('a, button, [tabindex]').filter(':visible');
		let currentIndex = -1;
		
		$(document).on('keydown.dropdownNav', (e) => {
			if (e.key === 'ArrowDown') {
				e.preventDefault();
				options.eq(currentIndex).removeClass('focused-option-js');
				currentIndex = (currentIndex + 1) % options.length;
				options.eq(currentIndex).focus();
				options.eq(currentIndex).addClass('focused-option-js');
			} 
			else if (e.key === 'ArrowUp') {
				e.preventDefault();
				options.eq(currentIndex).removeClass('focused-option-js');
				currentIndex = (currentIndex - 1 + options.length) % options.length;
				options.eq(currentIndex).focus();
				options.eq(currentIndex).addClass('focused-option-js');
			} 
			else if (e.key === 'Escape') {
				e.preventDefault();
				this.closeDropdown(trigger);
				trigger.focus();
			} 
			else if (e.key === 'Home') {
				e.preventDefault();
				options.eq(currentIndex).removeClass('focused-option-js');
				currentIndex = 0;
				options.eq(currentIndex).focus();
				options.eq(currentIndex).addClass('focused-option-js');
			} 
			else if (e.key === 'End') {
				e.preventDefault();
				options.eq(currentIndex).removeClass('focused-option-js');
				currentIndex = options.length - 1;
				options.eq(currentIndex).focus();
				options.eq(currentIndex).addClass('focused-option-js');
			} 
			else if (e.key === 'Tab') {
				this.closeDropdown(trigger);
			} 
			else if (e.key === 'Enter' || e.key === ' ') {
				if (document.activeElement === trigger[0])
					e.preventDefault();

				const timeOut = setTimeout(() => {
					this.closeDropdown(trigger);
					clearTimeout(timeOut);
				}, 100)
			}
		});

		if (options.length) {
			options.eq(0).focus();
			currentIndex = 0;
			if (!trigger.is(':hover'))
				options.eq(currentIndex).addClass('focused-option-js');
		}
	},

	// Remove keyboard navigation bindings
	unbindKeyboardNavigation: function() {
		$(document).off('keydown.dropdownNav');
		$('.dropdown-js').find('.focused-option-js').removeClass('focused-option-js');
	},

	// Toggle dropdown visibility
	toggleDrop: function(trigger, show) {
		const currentDropdown = trigger.parent().find('.dropdown-js').first();
		currentDropdown.addClass('hidden-js').hide();
		$('.close-dropdown-js').addClass('open-dropdown-js').removeClass('close-dropdown-js');
		
		$(window).off('scroll.dropdownScroll resize.dropdownScroll');
		$('.eshop__table-container').off('scroll.dropdownScroll');
		this.unbindKeyboardNavigation();

		if (show) {
			this.updateDropdownPosition(trigger, currentDropdown);
			currentDropdown.removeClass('hidden-js').show();
			trigger.addClass('close-dropdown-js').removeClass('open-dropdown-js');
			this.bindScrollListener(trigger, currentDropdown);
			this.bindKeyboardNavigation(trigger, currentDropdown);
		} else {
			trigger.addClass('open-dropdown-js').removeClass('close-dropdown-js');
		}
	},

	// Dropdown open
	openDropdown: function(e) {
		e.stopPropagation();
		const trigger = $(e.currentTarget);
		
		const openDropdownTriggers = $('.close-dropdown-js');
		if (openDropdownTriggers.length) {
			openDropdownTriggers.each((_, element) => {
				this.closeDropdown($(element));
			});
		}
		
		app.toggleDrop(trigger, true);

		$('body').off('click.closeDropdown').on('click.closeDropdown', (e) => {
			if (!$(e.target).closest('.dropdown-js').length && !$(e.target).closest('.close-dropdown-js').length) {
				const activeTrigger = $('.close-dropdown-js');
				if (activeTrigger.length) {
					this.closeDropdown(activeTrigger);
				}
			}
		});
		trigger.closest('tr.row').addClass('hovered-js');
	},

	// Dropdown close
	closeDropdown: function(e) {
		const trigger = e.currentTarget ? $(e.currentTarget) : e;
		app.toggleDrop(trigger, false);
		$('body').off('click.closeDropdown');
		this.unbindKeyboardNavigation();
		trigger.closest('tr.row').removeClass('hovered-js');
	},

	// Set cookie. Set its name, value and expiration date (counted in days).
	setCookie: function(cname, cvalue, exdays) {
		var date = new Date();
		date.setTime(date.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+date.toUTCString();
		document.cookie = cname + "=" + cvalue + "; " + expires + "; SameSite=Lax; path=/";
	},

	// Get cookie value. You have to type its name.
	getCookie: function(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
		  var c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return "";
	},

	// Close cookie-message popup.
	closeMessagePopup: function(e) {
		$(e.currentTarget).parents('.message-popup-js, .popup-in-form').remove();
		app.offLockFocus();
	},

	// Set cookie that remove cookie-message which popped up in the window center by clicking OUTSIDE the popup and close that popup.
	closeCenteredCookieMessage: function(e) {
		var close = $(e.currentTarget).find('.close-js');
		var name = close.data('name');
		var days = close.data('days');
		app.setCookie(name, 'hidden', days);
		$(e.currentTarget).remove();
	},
	
	// zmiana ustawien ciasteczek

	// After successfull sign up - wait few moments to let customer read message and then redirect to home-page.
	signUpSuccess: function(parameters) {
		var url = parameters.url;
		var delay = parameters.delay;
		var form = parameters.form;
		var e = parameters.event;
        $.get('', {__collection: 'customer.UserId32'}, function (result) {
            var userId = result.collection;
            app.dataLayerPush('register', userId);
			if(typeof gtag != 'undefined'){
				gtag("event", "sign_up", {
					method: userId
				});
			}
			if(typeof fbq !== 'undefined') {
				fbq('track', 'CompleteRegistration', {status: true, content_name: userId});
			}
			app.replace(url, delay, form);
        });
	},

	// After successful sign-out, check if the current page is the client profile page.
	signOutSuccess: function() {
		window.app.setCookie('lastCartId', -1);
		window.app.setCookie('activeInquiryId', -1);
		
		if ($('.is-profile-page-js').index() != -1) {
			app.replace('');
		} else {
			const updatedSearchParams = new URLSearchParams();
			window.history.replaceState(null, null, window.location.pathname + updatedSearchParams.toString());
			app.reload();
		}
	},

    // Sort products.
	sort: function() {
		const sortingQuery = this.parentNode.dataset.sortingQuery;
		const sortingType = this.dataset.sortingType;
		const queryString = window.location.search.substring(1);
		let url = window.location.pathname;
		let sortingTypeInUrl = false;
		if(queryString != ''){
			let elements = queryString.split('&');
			for(let i=0; i<elements.length; i++){
				if(elements[i].indexOf(sortingQuery) !== -1){
					sortingTypeInUrl = true;
					let sorting = elements[i].split('=');
					sorting[1] = sortingType;
					elements[i] = sorting[0] + '=' + sorting[1];
				}
                if(elements[i].indexOf('pageId=') === -1){
                    if(i == 0){
                        url += '?' + elements[i];
                    } else {
                        url += '&' + elements[i];
                    }
				} else if(i==0){
					var onlyPageId = true;
				} else {
					var onlyPageId = false;
				}
			}
			if(!sortingTypeInUrl){
				if(onlyPageId){
					url += '?' + sortingQuery + '=' + sortingType;
				} else {
					url += '&' + sortingQuery + '=' + sortingType;
				}
			}
		} else {
			url += '?' + sortingQuery + '=' + sortingType;
		}
		app.replace(url);
	},

    // Get template.
    getTemplate: function(e) {
		var ct = e;
		if ((e instanceof jQuery) === false) {
			ct = $(e.currentTarget);

			if(e.currentTarget.tagName == 'SELECT'){
				ct = ct.find('option:selected');
			}
		}

        // Get url.
        if(ct.attr('data-url')){
            var url = ct.data('url');
        } else {
            var url = null;
        }

        // Get template.
        if(ct.attr('data-template')){
            var template = ct.data('template');
        } else {
            var template = ct.parents('[data-template]').data('template');
        }

        // Get container in witch template will be replaced.
        if(ct.hasClass('container-reload-js')){
            var container = ct.parents('.container-js').eq(0);
        } else if(ct.hasClass('parent-container-reload-js')){
            var container = ct.parents('.parent-container-js').eq(0);
        } else if(ct.attr('data-container')){
            var container = ct.data('container');
        } else {
            var container = ct.parents('[data-container]').data('container');
        }

        // Get include.
        if(ct.attr('data-include')) {
            var include = '"'+ct.data('include')+'"';
        } else if($(container).attr('data-include')) {
            if($(container).data('include').toString().indexOf('|') != -1){
                var include = '"'+$(container).data('include')+'"';
            } else {
                var include = $(container).data('include');
            }
        } else {
            var include = null;
        }

        // If template will reload more than 1 container - get index that will help to find proper container in which message will appear.
        if($(container).hasClass('parent-container-js')){
            var index = ct.parents('.container-js').data('include');

            // If index doesn't exist it means we try to add new container.
            if(index == undefined){
                var newContainer = true;
            }
        }

        if(include == 'add-review'){
            var starIndex = ct.index();
        }

        if(include == 'rating'){
            var rating = 'product-presentation.Product.Rating';
        }

		if (template == 'partials/product/product-presentation-data.html') {
			app.reset360Data();
		}

		return {
        	template: template,
			include: include,
			url: url,
			ct: ct,
			container: container,
			newContainer: newContainer,
			index: index,
			starIndex: starIndex,
			rating: rating
		};
    },

    // Things to do after replacing template.
    afterReplaceTemplate: function(e, obj, template, message, callback, callbackObj) {
		if ($(obj.container).hasClass('replace-with-js')) {
			$(obj.container).replaceWith(template);
		} else {
		$(obj.container).html(template);
		}

		var liCount = $('.attributes-list-js li').length;
		if(liCount > 1){
			var hiddenLiCount = $('.attributes-list-js li.hidden-js').length;
			var halfLiCount = Math.ceil((liCount-hiddenLiCount)/2);
			$('.attributes-list-js li').removeClass('odd-element');
			if(halfLiCount%2 != 0 && $( window ).width() > 1279){
				$('.attributes-list-js li').removeClass('odd-element');
				$('.attributes-list-js li').filter(':visible').slice(0,halfLiCount).filter(':even').addClass('odd-element')
				$('.attributes-list-js li').filter(':visible').slice(halfLiCount, liCount).filter(':even').addClass('odd-element')               
			} else {
				$('.attributes-list-js li').removeClass('odd-element');
				$('.attributes-list-js li:visible:even').addClass('odd-element')
			}
		}

		if(message != undefined){
			if($(obj.container).hasClass('parent-container-js')){
				var containers = $(obj.container).find('.container-js');
				if(obj.newContainer){
					var formContainer = containers.last();
				} else {
					var formContainer;
					containers.each(function(){
						if($(this).data('include') == obj.index){
							formContainer = $(this);
						}
					});
				}
			} else if($(obj.container).hasClass('container-js')){
				var formContainer = $(obj.container);
			}
			app.temporaryPopupMessage(formContainer, message);
		}

		if(obj.include == 'add-review'){
			app.setRating(e, obj.starIndex);
			app.colorStarsNew(e, obj.starIndex);
		}

		if(obj.include == 'rating'){
			$.get(obj.url, {__collection: obj.rating}, function (result) {
				$('[data-rating]').data('rating', result.collection)
				app.colorStarsNew(e, '', result.collection);
			});
		}

		if(obj.ct.hasClass('choose-other-address-js')){
			window.otherAddressChoosen = true;
		}

		if(obj.ct.hasClass('load-erp-data-js')){
			erpDataDownloading();
		}

		if(callback != undefined){
			callback(callbackObj);
		}

		if ($(obj.container).hasClass('product-presentation-js')) {
			app.getProperBackground();
			productDetails.init();
			if ($('.sets-container').length > 0) {
				if (typeof window.initSetSlider === 'function') {
					window.initSetSlider();
				}
			}
		
			if ($('.related-container').length > 0) {
				if (typeof window.initRelatedSlider === 'function') {
					window.initRelatedSlider();
				}
			}

			const elements = document.getElementsByClassName('review-content-js');
			for(let element of elements){
				if (element.offsetHeight == element.scrollHeight) {
					const buttons = element.parentNode.getElementsByClassName('toggle-more-review-js');
					for(let button of buttons){
						button.classList.add('hidden-js');
					}
				}
			}
			
		}
		
		app.formLabelAnimationOnLoadPage();
		app.updateSlider();
		app.selects($(obj.container));
		app.focusManager.restoreFocus();
    },

	replaceTemplate: function(e, message, callback, callbackObj, changeFocus = false) {
		var obj = app.getTemplate(e);
		
		$.get(obj.url, { __template: obj.template, __include: obj.include }, function(result) {
			app.afterReplaceTemplate(e, obj, result.template, message, callback, callbackObj);

			if (changeFocus) {
				app.activateFocusTrap(obj.container, e.currentTarget);
			}
		});
	},

	// Delete some container.
	delete: function(e) {
		var container = $(e.currentTarget).parents('.container-to-delete-js');
		if(container.siblings().length <= 0){
			var message = $(e.currentTarget).data('no-products');
			container.parent().append(message);
		}
		if($(e.currentTarget).hasClass('container-to-delete-js')){
            $(e.currentTarget).remove();
		} else {
            $(e.currentTarget).parents('.container-to-delete-js').remove();
		}
	},

	checkIfChannelsSelected: function (input) {
        var channelParent = $(input).closest('.js-multipleChoice');

        if ($(input).prop('checked') || $(input).prop('required')) {
            var channels = channelParent.find('[name=channelKey]');
            var nothingSelected = true;
            channels.each(function () {
                if ($(this).prop('checked')) {
                    nothingSelected = false;
                }
            });
            if (nothingSelected) {
                channelParent.find('.form__validation-channel-js').show();
            } else {
                channelParent.find('.form__validation-channel-js').hide();
            }
        }
    },

    checkChannels: function (form) {
        var channelsParents = $(form).find('.js-multipleChoice input');
        var channelsValidationInfos = $(form).find('.js-validation-channel');
        var validate = true;

        if (channelsParents.length > 0) {
            $.each(channelsParents, function (index, value) {
                app.checkIfChannelsSelected($(value));
            });
        }

        $.each(channelsValidationInfos, function (index, value) {
            if ($(value).is(':visible')) {
                validate = false;
            }
        });

        return validate;
    },

    toggleParentTOS: function (form) {
        let parentTOS = $(form).parents('.consents-wrapper').children('.checkBoxes__container').children('.parentTOS');

        if (parentTOS.length > 0) {
            if ($('.standalone-channel-js:checked').length > 0) {
                parentTOS.attr('checked', true);
            } else {
                parentTOS.attr('checked', false)
            }
        }
    },

    enableChannels: function (e) {
        var consentContainer = $(e.currentTarget).closest('.js-multipleChoice');
        var channels = $(consentContainer).find('.channel-js');

        $.each(channels, function (index, value) {
            if (!$(value).hasClass('js-always-checked')) {
                if ($(value).attr('disabled')) {
                    $(value).removeAttr('disabled');
                } else {
                    $(value).prop('checked', false);
                    $(value).removeAttr('checked');
                    $(value).attr('disabled', true);
                }
            }
        });

    },

	// Set rating value.
	setRating: function(e, starIndex) {
		var form = $(e.currentTarget).parents('.form-js');
		if(starIndex != undefined){
			var rating = starIndex + 1;
			$('.add-review-js').find('[name="rating"]').val(rating);
		} else {
			var rating = $(e.currentTarget).index() + 1;
			form.find('[name="rating"]').val(rating);
		}
	},

	// Color stars in rating depending on index of star which is currently mouseover.
	colorStarsNew: function(e, starIndex, rating) {
		if(starIndex != undefined && starIndex !== ''){
			var container = $('.add-review-js').find('.rating-js .star-js').eq(starIndex);
		} else if(rating != undefined) {
			var container = $('[data-rating]').find('.star-js').eq(rating - 1);
		} else {
			var container = $(e.currentTarget);
		}
		container.addClass('star-active-js');
		container.prevAll().addClass('star-active-js');
		container.nextUntil('.star-js:not(.star-active-js)').removeClass('star-active-js');
	},

	// Color stars in rating depending on value of rating input.
	colorStarsOld: function(e) {
		if($(e.currentTarget).parents('[data-rating]').index() != -1){
			var container = $(e.currentTarget).parents('[data-rating]');
			var index = container.data('rating') - 1;
			var stars = container.find('.star-js');
		} else {
			var form = $(e.currentTarget).parents('.form-js');
			var index = form.find('[name="rating"]').val() - 1;
			var stars = form.find('.rating-js .star-js');
		}

		if(index == -1){
			stars.removeClass('star-active-js');
		} else {
			stars.eq(index).addClass('star-active-js');
			stars.eq(index).prevAll().addClass('star-active-js');
			stars.eq(index).nextUntil('.star-js:not(.star-active-js)').removeClass('star-active-js');
		}
	},

	// Scroll to element.
	scrollToElement: function(e, elementClass) {
		if(elementClass == undefined){
			var elementClass = $(e.currentTarget).data('scroll-to-element');
		}
		$('body,html').animate({
			scrollTop: $(elementClass).offset().top
		}, 300);
	},

	// Input value validation
	validateIntValue: function(e) {
		var val = $(e.currentTarget).val();
		if ($.isNumeric(val)) {
			if(val.indexOf(',') !== -1){
				val = val.replace(',', '.');
			}
			if (val.includes('.')) {
				$(e.currentTarget).val(Math.floor(val));
			}
		}
		else {
			$(e.currentTarget).val(1);
		}
	},

	// Change quantity via "+" and "-" buttons.
	changeQuantity: function(e, callback, callbackObj, callbackAfterDelay, callbackObjAfterDelay) {
		if($(e.currentTarget).hasClass('change-quantity-header-input')) {
			var input = $(e.currentTarget);
		} else if($('.ammount-stepper-js').index() != -1){
			if($(e.currentTarget).hasClass('change-quantity-header')) {
				var input = $(e.currentTarget).parents('.form-js').find('[name="quantity"]');
			} else {
				var input = $(e.currentTarget).parents('.ammount-stepper-js').find('[name="quantity"]');
			}
		} else {
			var input = $(e.currentTarget).parents('.form-js').find('[name="quantity"]');
		}
		var val = input.val();
		if(val.indexOf(',') !== -1){
			val = val.replace(',', '.');
		}
		val = Number(val);
		var multiplicity = Number(input.attr('data-multiplicity'));
		if ($(e.currentTarget).hasClass('change-quantity-header-input')) {
		} else if($(e.currentTarget).hasClass('decrement-js')){
			if(multiplicity > 0){
				if(input.hasClass('zero-allowed-js') && val <= multiplicity){
					val = 0;
				} else if(val > multiplicity){
					val -= multiplicity;
				}
			} else if(input.hasClass('zero-allowed-js')){
				if(val > 0){
					val --;
				}
			} else {
				if(val > 1){
					val --;
				}
			}
		} else {
			if(multiplicity > 0){
				val += multiplicity;
			} else {
				val ++;
			}
		}
		val = Math.round(val * 10000) / 10000;
		if(__decUnits == 'true'){
			var decimal = val.toString().split('.')[1];
			if(decimal != undefined && decimal.length == 1){
				if(__decSep == ','){
					val = val.toString().replace('.', ',') + '0';
				} else {
                    val = val + '0';
				}
			} else if(decimal == undefined){
				val = val + __decSep + '00';
			} else if(__decSep == ','){
                val = val.toString().replace('.', ',')
			}
		}
		input.val(val);
		input[0].dispatchEvent(new Event('input', { bubbles: true }));

		if(timeOut!=null){
			clearTimeout(timeOut);
			timeOut=null;
		}

		if($('.product-presentation-js').length > 0 || $(e.currentTarget).hasClass('no-delay')){
			var delay = 0;
		} else {
			var delay = 300;
		}

		timeOut = setTimeout(function(){
			app.validation(e,input);
			if($('.total-price-on-list-view-js').length > 0){
				js.updateTotalPriceOnShoppingList();
			}
			if($('.total-deposit-on-list-view-js').length > 0){
				js.updateDepositPriceOnShoppingList();
			}
			if(input.attr('data-last-proper-quantity')){
				if($('.cart-products-container-js').index() != -1){
					$('.cart-products-container-js .during-ajax-modal-js').removeClass('hidden-js');
				}
				app.post(e);
			}
			if($('.wishlist-container-js').index() != -1){
				if (__isB2B == 'true') {
					var productId = input.closest('.can-add-js').data('product-id');
					if(val == 0){
						val = 1;
					}
					$.post('', {__csrf: __CSRF, __action: 'Wishlist/ProductQuantityChange', id: productId, quantity: val});
				} else {
					var productId = input.parents('.form-js').find('[name="productId"]').val()
					$.post('', {__action: 'Product/WishListDelete', productId: productId, __csrf: __CSRF}, function() {
						if(val == 0){
							val = 1;
						}
						$.post('', {__action: 'Product/WishListAdd', quantity: val, productId: productId, __csrf: __CSRF});
					});
				}
			}

            if(callbackAfterDelay != undefined){
                callbackAfterDelay(callbackObjAfterDelay);
            }
		}, delay);

		if(callback != undefined){
			callback(callbackObj);
		}
	},

	// Url for history.pushState/replaceState - always same-origin path (links are absolute, e.g. //host/path, host may differ from current one).
	historyUrl: (url) => {
		if (!url) return url;
		try {
			const u = new URL(url, document.baseURI);
			return u.pathname + u.search + u.hash;
		} catch (e) {
			return url;
		}
	},

	// Redirect to new page with new url (adds new history entry).
	newUrl: async (url, delay, callback, callbackObj) => {
		if(delay != undefined){
			if(document.getElementsByClassName('successfull-post-message-js')[0].innerHTML == ''){
                document.getElementsByClassName('successfull-post-message-js')[0].innerHTML = '<p>'+__redirectInfo+'</p>';
			} else if(document.querySelector('.successfull-post-message-js .info')) {
                document.querySelector('.successfull-post-message-js .info').innerHTML = '<div>'+__redirectInfo+'</div>';
			} else {
                document.getElementsByClassName('successfull-post-message-js').innerHTML = '<div class="info">'+__redirectInfo+'</div>';
			}
			setTimeout(function () {
				window.location.href = url;
			}, delay);
		} else if(url.includes('add-inquiry=true')) {
			const id = window.app.getCookie('activeInquiryId');
			const res = await js.post({__action: 'Cart/Change', id: id});
			window.location.href = url;
		} else {
			window.location.href = url;
		}
		if(callback != undefined){
			callback(callbackObj);
		}
	},

	// Change input value (without reloading template).
	changeInputValue: function(e, val, parent, input, callback, callbackObj) {
		var id = $(e.currentTarget).data(val);
		$(e.currentTarget).parents(parent).find('[name="'+input+'"]').val(id);
		if(callback != undefined){
			callback(callbackObj);
		}
	},

	// Block quantity buttons if quantity can't be lower or higher.
	blockQuantityButtons: function(e, input) {
		if(input == undefined) {
            if ($(e.currentTarget).hasClass('decrement-js')) {
                var input = $(e.currentTarget).next();
            } else if ($(e.currentTarget).hasClass('increment-js')) {
                var input = $(e.currentTarget).prev();
            } else {
                var input = $(e.currentTarget);
            }
        }

        var val = input.val();
		if(val != undefined){
            val = Number(val.toString().replace(',','.'));
            var min = Number(input.data('min').toString().replace(',','.'));
            var max = Number(input.data('max').toString().replace(',','.'));

            if(min >= max) {
                input.prev().addClass('disabled-js');
				input.prev().prop('disabled', true);
                input.next().addClass('disabled-js');
				input.next().prop('disabled', true);
            } else if(val >= max){
                input.prev().removeClass('disabled-js');
				input.prev().prop('disabled', false);
                input.next().addClass('disabled-js');
				input.next().prop('disabled', true);
            } else if(val <= min){
                input.prev().addClass('disabled-js');
				input.prev().prop('disabled', true);
                input.next().removeClass('disabled-js');
				input.next().prop('disabled', false);
            } else {
                input.prev().removeClass('disabled-js');
				input.prev().prop('disabled', false);
                input.next().removeClass('disabled-js');
				input.next().prop('disabled', false);
            }
		}
	},

    fillFromExternalDatabase: function(res, form, deliveryAddressForm, allowEditClass, baseValidationClass) {
		var companyName = res.companyName;
		var name = form.find('[name="name"]');
		var name2 = form.find('[name="name2"]');
		if(deliveryAddressForm) {
			var nameDA = deliveryAddressForm.find('[name="name"]');
			var name2DA = deliveryAddressForm.find('[name="name2"]');
		}
		if (companyName.length > 50) {
			var firstSubstring = companyName.substring(0, 50);
			var length = 50;
			for(i=0; i<50; i++){
				var lastChar = firstSubstring.charAt(length);
				if(lastChar == ' '){
					length++;
					break;
				}
				length--;
			}
			name2.show();
			name.val(companyName.substring(0, length));
			name2.val(companyName.substring(length, length+50));
			if(name.hasClass('validation-error-js')){
				name.removeClass('validation-error-js validation-error');
				name.parent().find('.validation-info-js').addClass('hidden-js');
			}
			if(deliveryAddressForm) {
				if (deliveryAddressForm.index() != -1 && nameDA.val() == '' && name2DA.val() == '') {
					name2DA.show();
					nameDA.val(companyName.substring(0, length));
					name2DA.val(companyName.substring(length, length+50));
					if(nameDA.hasClass('validation-error-js')){
						nameDA.removeClass('validation-error-js validation-error');
						nameDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
			}
		} else {
			name.val(companyName);
			name2.hide();
			if(name.hasClass('validation-error-js')){
				name.removeClass('validation-error-js validation-error');
				name.parent().find('.validation-info-js').addClass('hidden-js');
			}
			if(deliveryAddressForm){
				if(deliveryAddressForm.index() != -1 && nameDA.val() == ''){
					nameDA.val(companyName);
					if(nameDA.hasClass('validation-error-js')){
						nameDA.removeClass('validation-error-js validation-error');
						nameDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
			}
		}
	
		if (!form.hasClass(allowEditClass)) {
			$('.second-step-js input:not([name="phoneNo"]):not([type="checkbox"])').each(function() {
				$(this).prop('readonly', true);
				$('label[for="' + $(this).attr('name') + '"]').attr('readonly', true);
			});
		}
		
	
		var street = form.find('[name="street"]');
		var streetNo = form.find('[name="streetNo"]');
		var unitNo = form.find('[name="unitNo"]');
		var city = form.find('[name="city"]');
		var zipCode = form.find('[name="zipCode"]');
	
		if(res.street == ''){
			if(res.city == '' && street.prop('required')){
				street.prop('readonly', false);
			} else if(res.city != '') {
				street.val(res.city);
				if(street.hasClass('validation-error-js')){
					street.removeClass('validation-error-js validation-error');
					street.parent().find('.validation-info-js').addClass('hidden-js');
				}
			}
		} else {
			street.val(res.street);
			if(street.hasClass('validation-error-js')){
				street.removeClass('validation-error-js validation-error');
				street.parent().find('.validation-info-js').addClass('hidden-js');
			}
		}
	
		if(res.streetNo == '' && streetNo.prop('required')){
			streetNo.prop('readonly', false);
		} else if(res.streetNo != '') {
			streetNo.val(res.streetNo);
			if(streetNo.hasClass('validation-error-js')){
				streetNo.removeClass('validation-error-js validation-error');
				streetNo.parent().find('.validation-info-js').addClass('hidden-js');
			}
		}
	
		if(res.unitNo == '' && unitNo.prop('required')){
			unitNo.prop('readonly', false);
		} else if(res.unitNo != '') {
			unitNo.val(res.unitNo);
			if(unitNo.hasClass('validation-error-js')){
				unitNo.removeClass('validation-error-js validation-error');
				unitNo.parent().find('.validation-info-js').addClass('hidden-js');
			}
		}
	
		if(res.city == '' && city.prop('required')){
			city.prop('readonly', false);
		} else if(res.city != '') {
			city.val(res.city);
			if(city.hasClass('validation-error-js')){
				city.removeClass('validation-error-js validation-error');
				city.parent().find('.validation-info-js').addClass('hidden-js');
			}
		}
	
		if(res.zipCode == '' && zipCode.prop('required')){
			zipCode.prop('readonly', false);
		} else if(res.zipCode != '') {
			zipCode.val(res.zipCode);
			if(zipCode.hasClass('validation-error-js')){
				zipCode.removeClass('validation-error-js validation-error');
				zipCode.parent().find('.validation-info-js').addClass('hidden-js');
			}
		}
	
		if(deliveryAddressForm) {
			if (deliveryAddressForm.index() != -1) {
				var streetDA = deliveryAddressForm.find('[name="street"]');
				var streetNoDA = deliveryAddressForm.find('[name="streetNo"]');
				var unitNoDA = deliveryAddressForm.find('[name="unitNo"]');
				var cityDA = deliveryAddressForm.find('[name="city"]');
				var zipCodeDA = deliveryAddressForm.find('[name="zipCode"]');
				if (res.street == '') {
					if (res.city != '' && streetDA.val() == '') {
						streetDA.val(res.city);
						if(streetDA.hasClass('validation-error-js')){
							streetDA.removeClass('validation-error-js validation-error');
							streetDA.parent().find('.validation-info-js').addClass('hidden-js');
						}
					}
				} else if (streetDA.val() == '') {
					streetDA.val(res.street);
					if(streetDA.hasClass('validation-error-js')){
						streetDA.removeClass('validation-error-js validation-error');
						streetDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
				if (res.streetNo != '' && streetNoDA.val() == '') {
					streetNoDA.val(res.streetNo);
					if(streetNoDA.hasClass('validation-error-js')){
						streetNoDA.removeClass('validation-error-js validation-error');
						streetNoDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
				if (res.unitNo != '' && unitNoDA.val() == '') {
					unitNoDA.val(res.unitNo);
					if(unitNoDA.hasClass('validation-error-js')){
						unitNoDA.removeClass('validation-error-js validation-error');
						unitNoDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
				if (res.city != '' && cityDA.val() == '') {
					cityDA.val(res.city);
					if(cityDA.hasClass('validation-error-js')){
						cityDA.removeClass('validation-error-js validation-error');
						cityDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
				if (res.zipCode != '' && zipCodeDA.val() == '') {
					zipCodeDA.val(res.zipCode);
					if(zipCodeDA.hasClass('validation-error-js')){
						zipCodeDA.removeClass('validation-error-js validation-error');
						zipCodeDA.parent().find('.validation-info-js').addClass('hidden-js');
					}
				}
			}
		}
	
		var tin = form.find('[name="tin"]');
		tin.parent().find('.' + baseValidationClass).addClass('hidden-js');
		tin.removeClass('validation-error-js');
		tin.removeClass('validation-error');
		// checkIfRegistrationFilled();
		updateLabelAfterFill(form);
	},

	externalDatabaseNotRespond: function(form, allowEditClass, validationAllowEditClass, dontAllowEditClass, validationDontAllowEditClass, allowNextStep) {
		var tin = form.find('[name="tin"]');
		if (!allowNextStep) {
			tin.addClass('validation-error-js');
			tin.addClass('validation-error');
		}
		if(form.hasClass(allowEditClass) || allowNextStep){
			$('.second-step-js input:not([name="phoneNo"]):not([type="checkbox"])').prop('readonly', false);
			tin.parent().find('.' + validationAllowEditClass).removeClass('hidden-js');
		} else if(form.hasClass(dontAllowEditClass)){
			$('.second-step-js input:not([name="phoneNo"]):not([type="checkbox"])').prop('readonly', true);
			tin.parent().find('.' + validationDontAllowEditClass).removeClass('hidden-js');
		} else {
			$('.second-step-js input:not([name="phoneNo"]):not([type="checkbox"])').prop('readonly', true);
		}
	},
	
	externalDatabaseNotValid: function(form, validationGusClass, allowNextStep) {
		var tin = form.find('[name="tin"]');
		tin.parent().find('.' + validationGusClass).removeClass('hidden-js');
		if (allowNextStep) {
			form.find('input[readonly]').each(function() {
				$(this).attr('readonly', false);
			});
		}
	},

    getDataFromExternalBase: function(e, callback) {
		if($('.with-database-check-js').index() != -1){
			if($('.with-database-check-js').length > 1){
				var form = $(e.currentTarget).parents('.with-database-check-js');
			} else {
				var form = $('.with-database-check-js');
			}
			
			var deliveryAddressForm = form;
			
		} else {
			var form = $('.external-base-js');
		}
		var tin = form.find('[name=tin]').val();
		var vateu = form.find('[name=vateu]').val();
		var country = form.find('[name=countryCode]').val();
		var isTinRequired = form.find('[name="tin"]').prop('required');

		if(tin){
			tin = tin.toString();
			if (country == 'PL' && !app.validateTin(tin,true)) {
				return false;
			}
			var properTin = tin.replace(/[-\s]/g, '');
			if (country == 'PL') {
				let editGusAfterDownload = false;
				if (form.find('[name=tin]').data('edit-gus') == 'yes') {
					editGusAfterDownload = true;
				}
				if (tin.length > 10) {
					return false;
				} else {
					return $.get({url:'https://gus.comarchesklep.pl/gus/api/nip/'+properTin+'/extended', statusCode: {
							500: function() {
								app.externalDatabaseNotRespond(form, 'allow-edit-when-gus-not-responding-js', 'validation-gus-allow-when-not-responding-js', 'dont-allow-edit-when-gus-not-responding-js', 'validation-gus-dont-allow-when-not-responding-js', false);
								return false;
							}
						}}).then(function (res) {
							if (res.dataZakonczeniaDzialalnosci != '') {
								app.externalDatabaseNotValid(form, 'validation-gus-js', editGusAfterDownload);
								return false;
							} else {
								const resultData = {
									companyName: res.nazwaFirmy,
									street: res.ulica,
									city: res.miejscowosc,
									streetNo: res.nrNieruchomosci,
									unitNo: res.nrLokalu,
									zipCode: res.kodPocztowy
								};
								app.fillFromExternalDatabase(resultData, form, deliveryAddressForm, 'allow-edit-gus-js', 'validation-gus-js');
								if (callback != undefined) {
									callback();
								}
								return true;	
							}
					}, function () {
						app.externalDatabaseNotValid(form, 'validation-gus-js', true);
						form.find('[name=tin]').parent().find('.form__input-info').addClass('validation-error');
						form.find('[name=tin]').parent().find('.form__input-value').addClass('validation-error-js');
						return false;
					});
				}
			}
			if ((euCountriesISOWithoutPL.includes(country) && vateu != '') || (country == 'GB' && vateu == 'XI')) {
				if(!isTinRequired){
					form.find('input[readonly]').removeAttr('readonly');
					return;
				}
				$.get(null, {__action: 'Get/Vies', Prefix: vateu, Nip: properTin}, function(res) {
					if (!res || !res.action) {
						app.externalDatabaseNotRespond(form, 'allow-edit-when-vies-not-responding-js', 'validation-vies-allow-when-not-responding-js', 'dont-allow-edit-when-vies-not-responding-js', 'validation-vies-dont-allow-when-not-responding-js', true);
						return;	
					}
					if (res.action.Object) {
						const result = res.action.Object;
						if (!result.IsValid) {
							app.externalDatabaseNotValid(form, 'validation-vies-js', true);
							form.find('[name=tin]').parent().find('.form__input-info').addClass('validation-error');
							form.find('[name=tin]').parent().find('.form__input-value').addClass('validation-error-js');
							return;
						}
						var resultData = {};
						if (result.BuildingNumber) {
							resultData = {
								...resultData,
								companyName: result.Name,
								street: result.Street,
								city: result.City,
								streetNo: result.BuildingNumber,
								unitNo: result.ApartmentNumber,
								zipCode: result.ZipCode
							}
						} else {
							var streetMaxLength = form.find('[name="street"]').prop('maxlength');
							var fullAddress = result.FullAddress;
							if (fullAddress.length > streetMaxLength) {
								fullAddress = fullAddress.slice(0, streetMaxLength);
							}
							resultData = {
								...resultData,
								companyName: result.Name,
								street: fullAddress,
								city: "",
								streetNo: "",
								unitNo: "",
								zipCode: ""
							}
						}
						app.fillFromExternalDatabase(resultData, form, deliveryAddressForm, 'allow-edit-vies-js', 'validation-vies-js');
						if (callback != undefined) {
							callback();
						}
					}
				});
			}
		}
		if(!isTinRequired && (!tin || tin.trim() === '')){
			form.find('.tin-error-checker-no-required').removeClass('validation-error');
			form.find('input[readonly]').removeAttr('readonly');
		}
		updateLabelAfterFill(form);
	},

    // Initiate Google Maps Api.
    initiateGoogleMapsApi: function() {
        if(window.google == undefined || window.google.maps == undefined){
            $.getScript('https://maps.googleapis.com/maps/api/js?v=3&key='+__gap).done(function(){
                app.findMaps();
            });
        } else {
            app.findMaps();
        }
    },

	// Find google map containers.
    findMaps: function() {
        var maps = $('.map-js:not(.hidden-js)');
        maps.each(function() {
            if(window.map == undefined || window.otherAddressChoosen){
                app.renderMap(this);
                window.otherAddressChoosen = false;
            } else {
                $(this).replaceWith(window.map.__gm.R);
                if(window.markersChanged){
                    app.renderMarkers();
                }
            }
        });
    },

	// Render google map.
    renderMap: function(mapContainer) {
        var mapOptions = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
			zoom: 4,
  			gestureHandling: 'greedy'
        };
        window.map = new google.maps.Map(mapContainer, mapOptions);
        window.allMachinesDownloaded = false;
        app.renderMarkers();
    },

	// Render markers on map.
    renderMarkers: function() {
        if(window.collectionPointType == 2){
            window.pointChoosen = false;
        }
        // map on contact page
        var latitude = $('.map-js').data('latitude');
        var longitude = $('.map-js').data('longitude');
        var shopAddress = $('.map-js').data('address');
        var shopName = $('.map-js').data('shop-name');
        var info = '<div><p>'+ shopName + '</p><p>' + shopAddress + '</p></div>';
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(latitude, longitude),
            map: window.map,
            icon: 'https://static.comarch.com/files/img/google-marker.png'
        });
        app.centerMap(marker);
        var infoWindow = new google.maps.InfoWindow({
            content: info
        });
        marker.addListener('click', function() {
            infoWindow.open(window.map, marker);
        });
        infoWindow.open(window.map, marker);
    },

	// Center map.
    centerMap: function(marker) {
        window.map.panTo(marker.getPosition());
        window.map.setZoom(15);
    },

    dataLayerPush: function(event, userId){
        var dataLayerData;
        switch(event) {
            case 'login':
                dataLayerData = {
                    'event': event,
                    'userId' : userId
                }
                break;
            case 'register':
                dataLayerData = {
                    'event': event,
                    'userId' : userId
                }
                break;
            case 'selectedPayment':
                dataLayerData = {
                    'event': event,
                    // 'delivery' : $('.change-delivery-js').first().find('[selected]').text(),
                    'payment' : $('.change-delivery-js').last().find(':selected').text()
                }
                break;
            default:
        }
        window.dataLayer.push(dataLayerData);
    },

	importCSV: async function (file) {
		const data = new FormData();
		data.append('__csrf', __CSRF);
		data.append('__action', 'Cart/ImportCSV');
		data.append('file', file);

		const cart = document.querySelector('.order-template-js');
		let templates = 'partials/common/header/client-area.html'
		if (cart) {
			templates += '|elements/cart/' + __cartId + '.html';
		}
		data.append('__template', templates); 
	
		try {
			const response = await $.ajax({
				data: data,
				processData: false,
				contentType: false,
				type: 'POST'
			});

			const products = response?.action?.Products;
			const notAddedProducts = response?.action.Results;

			$('.prevent-double-change-js').removeClass('prevent-double-change-js');
            $('.import-cart-input-js').val('');

			if (response?.action.Code != 0) {
				app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
				return;
			}

			if (products?.length === 0) {
				app.temporaryPopupMessage(undefined, __translations.NotImportedAnyProducts, 'warn');
				return;
			}

            if (Array.isArray(response.template)) {
                $('.client-area-js').html(response.template[0]);
                
                if (cart) {
                    $('.order-template-js').replaceWith(response.template[1]);
                }
            } else {
                $('.client-area-js').html(response.template);
            }

			window.dispatchEvent(new CustomEvent('cart:added', {
				detail: {
					products: products,
					strategy:  notAddedProducts?.length > 0 ? "2" : __aatc
				}
			}));

			const isSingleProductNotAdded =  (!response?.action.Result && response?.action?.Object);
			if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
				window.dispatchEvent(new CustomEvent('validation:failure', {
					detail: {
						title: __translations.NotImportedProducts,
						results: response.action.Results || [response.action]
					}
				}));
			}
		} catch (error) {
			console.error('Error importing CSV file:', error);
			return;
		}
	},

    serialAddingToCartMinQuantityCheck: function(res) {
		let minQuantityTestPassed = true;
		const infoElement = document.querySelector('.proper-amount-info-js');
		if(res.action.Multiple){
			const results = res.action.Results;
			for(let i=0; i<results.length; i++){
				if(results[i].Code == 1023){
					minQuantityTestPassed = false;
					const message = results[i].Message
					if (infoElement) {
						infoElement.appendChild(document.createTextNode(message));
						infoElement.classList.remove('hidden-js');
					} else {
						this.temporaryPopupMessage(undefined, message, 'err');
					}
					
					if (!document.activeElement.classList.contains('add-to-inquiry-js')) {
						document.activeElement.disabled = true;
					}
					break;
				}
			}

		} else if(res.action.Code == 1023){
			minQuantityTestPassed = false;
			const message = res.action.Message;
			if (infoElement) {
				infoElement.appendChild(document.createTextNode(message));
				infoElement.classList.remove('hidden-js');
			} else {
				this.temporaryPopupMessage(undefined, message, 'err');
			}
			if (!document.activeElement.classList.contains('add-to-inquiry-js')) {
				document.activeElement.disabled = true;
			}
		}
			
		return minQuantityTestPassed;
	},
	
    get360Image: function(e, isProductList = false) {
        if (isProductList == false) {
			if ($('#photoLink').index() >= 0) {
				var containerUrl = $('#photoLink').val();
			} else if ($('#parentPhotoLink').index() >= 0) {
				var containerUrl = $('#parentPhotoLink').val();
			} else {
				var containerUrl = '';
			}
        } else {
            var containerUrl = $(e.currentTarget).parent().find('.photoLink').val();
        }

		containerUrl = containerUrl.replace('Comarch&', '');

		if (!containerUrl || containerUrl == '') {
        } else {
			var fileextensions = [".jpg", ".jpeg", ".png"];
			let setFormat = false;
			for (let fileext in fileextensions) {
				let isImg = true;
				let i = 0;
				while(isImg) {
					i = i+1;
					$.ajax({
						url: containerUrl + i + fileextensions[fileext],
						async: false,
						success: function () {
							$("#imageContainer360").append("<img class='image360' data-id='" + i + "' src='" + containerUrl + i + fileextensions[fileext] + "'>");
							setFormat = true;
						},
						error: function() {
							if (setFormat == true) {
								isImg = false;
								$('.image360').addClass('hidden-js');
								$('.image360').eq(0).removeClass('hidden-js').addClass('cur');
								maxImgRotateId = i-1;
							} else if (setFormat == false && fileext == 2) {
								isImg = false;
							}
						},
					});
				}
				if (setFormat) {
					break;
				}
			}
		}
    },

    move360Image: function(direction) {
        let currentId = Number($('.image360.cur').data('id') - 1);
        if (direction === 'right') {         
            $('.image360.cur').addClass('toRemove');

            if (currentId + 1 < maxImgRotateId) {
                $('.image360').eq(currentId + 1).removeClass('hidden-js').addClass('cur');
                $('.image360.toRemove').addClass('hidden-js').removeClass('cur').removeClass('toRemove');
            } else {
                $('.image360').eq(0).removeClass('hidden-js').addClass('cur');
                $('.image360.toRemove').addClass('hidden-js').removeClass('cur').removeClass('toRemove');
            }

        } else if (direction === 'left') {
            $('.image360.cur').addClass('toRemove');

            if (currentId - 1 >= 0 ) {
                $('.image360').eq(currentId - 1).removeClass('hidden-js').addClass('cur');
                $('.image360.toRemove').addClass('hidden-js').removeClass('cur').removeClass('toRemove');
            } else {
                $('.image360').eq(maxImgRotateId - 1).removeClass('hidden-js').addClass('cur');
                $('.image360.toRemove').addClass('hidden-js').removeClass('cur').removeClass('toRemove');
            }
        }
    },

    enableDisableAutoRotate: function(parameter) {
        if (parameter === 'disable') {
            $('.imageContainer--360btn.btn-auto').removeClass('btn-active');
            clearInterval(rotateInterval);
        } else if (parameter === 'enable') {
            rotateInterval = setInterval(function() {
                $('.imageContainer--360btn.btn-auto').addClass('btn-active');
                app.move360Image('right');
            }, 200);
        }
    },

	reset360Data: function() {
        $('.reset360').click();
        maxImgRotateId = 0;
	},

    getProductsIdsFromCart: function(callBack) {
        let productsInCart = [];
        $.ajax({
            url: null,
            type: "GET",
            async: false,
            data: {__collection: 'customer.Cart.Products'},
            success: function(res) {
                if (res.collection) {
                    let cartProducts = res.collection;
                    for (let i in cartProducts) {
                        productsInCart.push({"Id": cartProducts[i].Id, "Quantity": cartProducts[i].Quantity});
                    }
                }
                callBack(productsInCart);
            }
        });
    },

    checkIfProductIsInCart: function(productsInCart, productId, callBack) {
        if (__productIsInCart == 'productIsInCart-yes') {
            let isInCart = false;
            for (let i in productsInCart) {
                if (productsInCart[i].Id === productId) {
                    isInCart = true;
                }
            }
            return isInCart;
        } else {
            return false;
        }
    },

    enableDisableInCartButton(isInCart, type = 1, index = -1) {
		if (type === 1) { //product presentation
			if (isInCart == true) {
				$('.isInCartIcon-js').removeClass('hidden-js');
			} else {
				$('.isInCartIcon-js').addClass('hidden-js');
			}
		} else if (type === 2) { //products list
			if (isInCart == true) {
				$('.product-item-js').eq(index).find('.isInCartIcon-js').removeClass('hidden-js');
			} else {
				$('.product-item-js').eq(index).find('.isInCartIcon-js').addClass('hidden-js');
			}
		} else if (type === 3) { // products list popup
			if (isInCart == true) {
				$('.add-variants-to-cart-from-prod-list-popup-background').find('.isInCartIcon-js').removeClass('hidden-js');
			} else {
				$('.add-variants-to-cart-from-prod-list-popup-background').find('.isInCartIcon-js').addClass('hidden-js');
			}
		}
    },   

	showTooltip: function (e, tooltipObject, gap, gap2 = 30) {
        let top = e.clientY - e.offsetY + gap;
        let right = "unset";
        let left = (e.clientX - gap2) - (e.offsetX / 2);

        if (left < 0) {
            left = 10;
        } else if (left > (($(window).width() - 200))) {
            left = "unset";
            right = 10;
        }

        tooltipObject.css('top', top);
        tooltipObject.css('right', right);
        tooltipObject.css('left', left);

        tooltipObject.show();
    },

    hideTooltip: function (e, tooltipObject) {
        $(tooltipObject).hide();
    },

    setCartDropdownList() {
        if (($('.cartItemsList-firstOpening-js').index() > -1) && ($('.cartItemsList-firstOpening-js').val() === "true" || $('.cartItemsList-firstOpening-js').val() === true)) {
            $('.cartItemsList-firstOpening-js').val("false");
            let url = ',' + $('.cartItemsList-cartId-js').val();

            $.get(url, {__collection: 'cart.VATValue|cart.TotalDepositValue|customer.Cart.Count'}, function(res) {
                if (res.collection !== null) {
                    const cartValue = parseFloat($('.cartItemsList-cartValue-js').val().replace(',', '.'));
					const countValue = res.collection['customer.Cart.Count'];
					const totalDepositValue = res.collection['cart.TotalDepositValue'];
					let vatValue = res.collection['cart.VATValue'];
					if (vatValue) {
						vatValue = parseFloat(vatValue);
					} else {
						vatValue = 0;
					}
                    let subTotalCartValue = parseFloat(cartValue - vatValue);

                    $('.cartItemsList-quantity-js').parent().removeClass('hidden-js');
                    $('.cartItemsList-totalValue-js').parent().removeClass('hidden-js');
					$('.cartItemsList-subTotalValue-js').parent().removeClass('hidden-js');
					if (totalDepositValue != null && totalDepositValue > 0) {
						$('.cartItemsList-totalDepositValue-js').parent().removeClass('hidden-js');
					}
					$('.cartItemsList-quantity-js').text(countValue);
                    $('.cartItemsList-totalValue-js').text((cartValue).toPrice() + ' ' + __curr);
					$('.cartItemsList-subTotalValue-js').text(subTotalCartValue.toPrice() + ' ' + __curr);
					if (totalDepositValue != null && totalDepositValue > 0) {
						$('.cartItemsList-totalDepositValue-js').text((totalDepositValue).toPrice() + ' ' + __curr);
					}
                } else {
					$('.cartItemsList-quantity-js').parent().addClass('hidden-js');
                    $('.cartItemsList-totalValue-js').parent().addClass('hidden-js');
					$('.cartItemsList-subTotalValue-js').parent().addClass('hidden-js');
					if (totalDepositValue == null || totalDepositValue == 0) {
						$('.cartItemsList-totalDepositValue-js').parent().addClass('hidden-js');
					}
                }
            });
        }       
    },

	changeQuantityInCartHeader: function(e) {
		let parentElement = $(e.currentTarget).parents('.header-cart-product-js');
		$('.change-quantity-header').prop('disabled', true);
		let url = ',' + $('.cartItemsList-cartId-js').val();
		$.get(url, {__collection: 'customer.Cart.Value|customer.Cart.TotalValue|cart.VATValue|cart.TotalDepositValue'}, function(res) {
			const vatValue = res.collection['cart.VATValue'] ? res.collection['cart.VATValue'] : 0;
			const totalValue = res.collection['customer.Cart.TotalValue'] ? res.collection['customer.Cart.TotalValue'] : 0;
			const totalDepositValue = res.collection['cart.TotalDepositValue'] ? res.collection['cart.TotalDepositValue'] : 0;
			$('.cartItemsList-totalValue-js').text(totalValue.toPrice() + ' ' + __curr);
			$('.cartItemsList-subTotalValue-js').text((parseFloat(totalValue) - parseFloat(vatValue)).toPrice() + ' ' + __curr);
			if (totalDepositValue != null && totalDepositValue > 0) {
				$('.cartItemsList-totalDepositValue-js').text(totalDepositValue.toPrice() + ' ' + __curr);
			}

			$('.cart-value-js').text(res.collection['customer.Cart.Value'] > 0 ? parseFloat(res.collection['customer.Cart.Value']).toPrice() : 0);
			$('.cart-value-with-currency-js').text(res.collection['customer.Cart.Value'] > 0 ? parseFloat(res.collection['customer.Cart.Value']).toPrice() + ' ' + __curr : 0);

			let quantity = parentElement.find('input[name="quantity"]').val();
			let price = parentElement.attr('data-price').replace(',', '.');
			let currentValue = price * quantity;
			parentElement.find('.cartItemsList-product--details_price').text(currentValue.toPrice() + ' ' + __curr);

			setTimeout(function() {
				$('.change-quantity-header').prop('disabled', false);
					$('.change-quantity-header-input').each(function(index) {
						if ((parseFloat($('.change-quantity-header-input').eq(index).val()).toFixed(2)) <= 1.00) {
							$('.change-quantity-header.decrement').eq(index).prop('disabled', true);
						}
					});
			}, 700);
		});
	},

	removeItemFromCartHeader: function(count) {
		let url = ',' + $('.cartItemsList-cartId-js').val();
		$.get(url, {__collection: 'customer.Cart.Value|customer.Cart.TotalValue|cart.VATValue|cart.TotalDepositValue|customer.Cart.Count'}, function(res) {
			let newValue = res.collection["customer.Cart.Value"] ? parseFloat(res.collection["customer.Cart.Value"]) : 0;

			if (newValue > 0) {
				const vatValue = res.collection['cart.VATValue'] ? res.collection['cart.VATValue'] : 0;
				const totalValue = res.collection['customer.Cart.TotalValue'] ? res.collection['customer.Cart.TotalValue'] : 0;
				const countValue = res.collection['customer.Cart.Count'];
				const totalDepositValue = res.collection['cart.TotalDepositValue'];
				$('.cartItemsList-quantity-js').text(countValue);
				$('.cartItemsList-totalValue-js').text(totalValue.toPrice() + ' ' + __curr);
				$('.cartItemsList-subTotalValue-js').text((parseFloat(totalValue) - parseFloat(vatValue)).toPrice() + ' ' + __curr);
				if (totalDepositValue != null && totalDepositValue > 0) {
					$('.cartItemsList-totalDepositValue-js').text((totalDepositValue).toPrice() + ' ' + __curr);
				}
			}

			$('.cart-value-js').text(newValue > 0 ? newValue.toPrice() : 0);
			$('.cart-value-with-currency-js').text(newValue > 0 ? newValue.toPrice() : 0);
		});
	},

    filtersAmoutCounter: function() {
		return ($('.selected-filter-item-js').length-1)
	},

    showBtnFun: function(time) {
		// $('.filterAllUp-js').animate({opacity: 0}, time); 

		// setTimeout(() => {
		// 	$('.reset-filters-js').show()
		// }, time);
		// setTimeout(() => {
		// 	$('.reset-filters-js').animate({opacity: 1}, time); 
		// 	$('.filterAllUp-js').animate({opacity: 1}, time); 
		// 	$('.filterAllUp-js').css('pointer-events','auto')
		// }, 2*time+200);
	},

	hideBtnFun: function(time) {
		// $('.filterAllUp-js').animate({opacity: 0}, time);
		// $('.reset-filters-js').animate({opacity: 0}, time);
		// setTimeout(() => {
		// 	$('.reset-filters-js').hide()
		// }, time);
		// setTimeout(() => {
		// 	$('.filterAllUp-js').css('pointer-events','none')
		// 	$('.reset-filters-js').animate({opacity: 0}, time); 
		// 	$('.filterAllUp-js').animate({opacity: 0}, time); 
		// }, 2*time+200);
	},

    // Filter products.
	filter: function(e) {
		if(app.validationBeforePost(e) != 'error'){
			if (app.validatePriceFilter(e) != 'error') {
				var form = $(e.currentTarget).parents('.form-js');
				var data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
				var param = $.param(data, true);
				$.get('', param, function (result) {
					app.serverMessage(result, form, e);
					if (result.action.Result) {
						if(result.action.Redirect302 != null){
							app.replace(result.action.Redirect302);
						} else {
							app.replace(window.location.pathname);
						}
					}
				});
			}
		}
	},

    // Validate price filters
	validatePriceFilter: function(e) {
		let inputMin = Number($('input[name="$minPrice"]').val());
		let inputMax = Number($('input[name="$maxPrice"]').val());
		let minimum = Number($('input[name="$minPrice"]').data('min'));
		let maximum = Number($('input[name="$minPrice"]').data('max'));

		if ((inputMin != '' && inputMin > maximum) || (inputMax != '' && inputMax < minimum)) {
			$('.price-error').removeClass('hidden-js');
			setTimeout(function() {
				$('.price-error').addClass('hidden-js');
			}, 1500);
			return 'error';
		}
	},

    // Reset filters.
	resetFilters: function(e,d1) {
		if($('#showBrandOnly').val() == "true") {
			location.href = $('#showBrandOnly').attr('data-categories');
		}
		let d;
		if(e.currentTarget.classList.contains('reset-filters-js')){
			var form = $(e.currentTarget).parents('.form-js');
			form.find('[type="tel"]').val('');
			form.find('[type="checkbox"]').prop('checked', false);
			 d = $('.filter-js input').serializeArray();
			d.push({name: '__action', value: 'get/SearchFilters'});
		}else{
			 d= d1;
		}
		return $.ajax({
			url: window.location.href,
			method: "GET",
			action: 'get/SearchFilters',
			data: d,
			template: 'partials/products/products-list-item.html',
			success: function(data) {
				location.href = data.action.Redirect302;
			}
		});
	},

    filtersAmout: function() {
		if($('.selected-filter-item-js').length>0){
			$('.counter-js').removeClass('hidden-js')
			$('.counterSpan-js').text($('.selected-filter-item-js').length-1)
		}else{
			$('.counter-js').addClass('hidden-js')
			$('.counterSpan-js').text($('.selected-filter-item-js'))
		}
	},

	showClearFiltersBtn: function() {
		let btnContainer = document.querySelector('.btnContainer')
		let counter=0
		let inputMin = Number($('input[name="$minPrice"]').val());
		let inputMax = Number($('input[name="$maxPrice"]').val());
		let allFilters = document.querySelectorAll('.filtersContainer-js')
		for(let h = 0;h<allFilters.length;h++){
			let x=0 
			let allInputCounter=allFilters[h].children
			for(let i = 0;i<allInputCounter.length;i++){
				let inputs = allInputCounter[i].children
				for(let j = 0;j<inputs.length;j++){
					let input = inputs[j].children[0]
					if(input.checked == true){
							x++;
						}
					}
			}
			if(x!=0){
				counter++;
			}
		}
		let time = 400; 
		if((counter != 0 || inputMax !='' || inputMin !='') && btnContainer!=null ){
			btnContainer.style.transition = 'bottom '+time+'ms';
			btnContainer.style.bottom = "0px";
		}else if((counter == 0 || inputMax =='' || inputMin =='') && btnContainer!=null){
			btnContainer.style.transition = 'bottom '+time+'ms';
			btnContainer.style.bottom = "-45px";
		}
	},

	reloadFilters: function(filteringOptions) {
        var filters = filteringOptions;
        var countSelected = 0;
        var isSelected = [];
		for(f in filters) {
            for(val in filters[f].Values) {
				if(filters[f].Values[val].Selected) {
					countSelected++;
				}
			}
		}
		$(".selected-filters-js").empty();
		$.get('', {__collection:'products.FilteringOptions|products.TotalItems'}, function(data) {
			var fo = data.collection['products.FilteringOptions'];
			var ti = data.collection['products.TotalItems'];
			if(fo != null){
				if(fo.PriceFrom > 0){
					countSelected++;
				}
				if(fo.PriceTo > 0){
					countSelected++;
				}
				if(countSelected > 0){
					$(".selected-filters-js").prepend('<input type="hidden" name="__action" value="Get/SearchFilters"><span class="selected-filters__clear-all selected-filter-item-js" data-field="all">'+ __translations.ClearAllFilters + '(' + countSelected +')</span>');
				}
				if(fo.PriceFrom > 0){
					$('.selected-filters-js').append('<button class="selected-filters__item selected-filter-item-js" data-field="$minPrice"><span>'+__translations.PriceFrom+' <strong>'+fo.PriceFrom+'</strong>'+__curr+'</span><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button><input aria-label="'+__translations.PriceFrom+'" name="$minPrice" type="hidden" value="'+fo.PriceFrom+'" maxlength="12">')
				}
				if(fo.PriceTo > 0){
					$('.selected-filters-js').append('<button class="selected-filters__item selected-filter-item-js" data-field="$maxPrice"><span>'+__translations.PriceTo+' <strong>'+fo.PriceTo+'</strong>'+__curr+'</span><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button><input aria-label="'+__translations.PriceTo+'" name="$maxPrice" type="hidden" value="'+fo.PriceTo+'" maxlength="12">')
				}
        for(f in filters) {
            isSelected[f] = false;

            for(val in filters[f].Values) {
				if(filters[f].Values[val].Selected) {
                    isSelected[f] = true;
						let tt = filters[f].Values[val];
						let heading = filters[f].Heading;
								$('.selected-filters-js').append('<button class="selected-filters__item selected-filter-item-js" data-field="'+tt.Field+'" data-value="'+tt.Value+'"><span>'+ heading +': ' +'<strong>'+ tt.Text+'</strong>'+'</span><svg><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg></button><input type="hidden" name="'+tt.Field+'" value="'+tt.Value+'"/>' );
                }
            }
				}
			}
			// app.filtersAmout()
			$('.total-items-js').text(ti);
			if(ti > 0 && window.productList.selectedViewName == 'quick-shopping'){
				$('.quick-shopping-buttons-container__buttons-js').removeClass('hidden-js');
			} else {
				$('.quick-shopping-buttons-container__buttons-js').addClass('hidden-js');
			}
		});
	},
	
	filtersCount: function() {
		let amount=0;
		// let allInputCounter=document.querySelectorAll('.filters-js')
		let allColumnValueFilterCheckbox = document.querySelectorAll('.all-values-checkbox-js')
		let columnCheckBoxCounter = 0;

		let allFilters = document.querySelectorAll('.filtersContainer-js');
		for(let h = 0;h<allFilters.length;h++){
			let x=0;
			let allInputCounter=allFilters[h].children;
			for(let i = 0;i<allInputCounter.length;i++){
				let inputs = allInputCounter[i].children;
				for(let j = 0;j<inputs.length;j++){
					let input = inputs[j].children[0];
					if(input.checked == true){
							x++;
						}
					}
			}
			if(x!=0){
				amount++;
			}
		}

		allColumnValueFilterCheckbox.forEach( valueFilterColumn => {
			if(valueFilterColumn.checked){
				columnCheckBoxCounter++;
			}
		})
		if(columnCheckBoxCounter>=2){ 
			return 3;
		}
		else if(columnCheckBoxCounter===1){
			return 1;
		}

		if (amount == 1){
			return 1
		}else if(amount == 0){
			return 0
		}else{
			return 3
		}
		
	},

	filtersApply: function(d, e) {
		countSelected = app.filtersCount()
			return $.ajax({
				url: window.location.href,
				method: "GET",
				action: 'get/SearchFilters',
				data: d,
				template: 'partials/products/products-list-item.html',
				success: function(data) {
					window.history.replaceState('', '', data.action.Redirect302);
					countSelected = app.filtersCount()
					if($('#showBrandOnly').val() == "true" && countSelected==0) {
						location.href = $('#showBrandOnly').attr('data-categories');
					}
					let getTemplate = 'partials/products/products-list.html';
					if (e != undefined) {
						getTemplate = $(e.target).parents('.product-filters-js').data('list-template');
					}
					$.get('', {__collection:'products', __template: getTemplate}, function(data) {
						let divContainer = $('.view-container-js');
						if (e !== undefined) {
							divContainer = $('.products-page-js');
						}
						divContainer.html(data.template)	
					})
				}
			});
	},

    updateSlider: function() {
		var $active = $('.change-type-js.active');
		if ($active.length) {
		  var leftPosition = $active.position().left;
		  var width = $active.outerWidth();
		  $('.slider').css({
			'left': leftPosition,
			'width': width
		  });
		}
	  },
	
	selects: function() {
		$('.select-js').each((i, select) => {
			if (select.dataset.initialized) return;
			select.dataset.initialized = 'true';
			
			if (!select.hasAttribute('tabindex')) select.setAttribute('tabindex', '0');
			const optionsContainer = select.querySelector('.options-js');
			const nativeSelect = select.querySelector('.memory-js');
			const selected = select.querySelector('.selected-js');
			const dialogParent = select.closest('dialog');
			
			const state = {
				isOpen: false,
				focusedOptionIndex: -1,
				disabled: select.classList.contains('disabled'),
				keyboardEventHandler: null
			};

			setTimeout(() => {
				if (nativeSelect?.options?.[nativeSelect.selectedIndex] && !nativeSelect.closest('.form__input-wrapper')) {
					selected.textContent = nativeSelect.options[nativeSelect.selectedIndex].textContent;
					selected.setAttribute('title', selected.textContent);
				}
			}, 100);
			
			const getOptionsContainer = () => select.querySelector('.options-js') || 
				document.querySelector('.options-js[data-select-id="' + (select.getAttribute('data-ref') || 'select-' + i) + '"]');
			
			const getOptions = () => {
				const container = getOptionsContainer();
				return container ? container.querySelectorAll('li') : [];
			};
			
			const updateDropdownPosition = () => {
				if (!state.isOpen) return;
				
				const optionsContainer = getOptionsContainer();
				if (!optionsContainer) return;
				
				const selectRect = select.getBoundingClientRect();
				const viewportHeight = window.innerHeight;
				
				if ((dialogParent && optionsContainer.parentElement !== dialogParent) || 
					(!dialogParent && optionsContainer.parentElement !== document.body)) {
					
					optionsContainer._originalParent = optionsContainer.parentElement;

					if (dialogParent) {
						dialogParent.appendChild(optionsContainer);
					} else {
						document.body.appendChild(optionsContainer);
					}
					
					const selectRef = select.getAttribute('data-ref') || 'select-' + i;
					optionsContainer.dataset.selectId = selectRef;
					if (!select.hasAttribute('data-ref')) select.setAttribute('data-ref', selectRef);
					
					optionsContainer.setAttribute('role', 'listbox');
					optionsContainer.setAttribute('aria-labelledby', select.getAttribute('data-ref'));
					
					attachKeyboardHandlers(optionsContainer);
				}
				
				if (dialogParent) {
					const dialogRect = dialogParent.getBoundingClientRect();
					const relativeTop = selectRect.bottom - dialogRect.top;
					const relativeLeft = selectRect.left - dialogRect.left;
					
					Object.assign(optionsContainer.style, {
						position: 'absolute',
						display: 'block',
						height: 'max-content',
						width: selectRect.width + 'px',
						zIndex: '9999',
						overflowY: 'auto',
						left: relativeLeft + 'px'
					});
					
					const dropdownHeight = optionsContainer.offsetHeight;
					const spaceBelow = dialogRect.height - relativeTop;
					const spaceAbove = selectRect.top - dialogRect.top;
					
					if (relativeTop + dropdownHeight > dialogRect.height && spaceAbove > dropdownHeight && spaceAbove > spaceBelow) {
						optionsContainer.style.top = 'auto';
						optionsContainer.style.bottom = (dialogRect.height - spaceAbove) + 'px';
					} else {
						optionsContainer.style.top = relativeTop + 'px';
						optionsContainer.style.bottom = 'auto';
						
						if (relativeTop + dropdownHeight > dialogRect.height) {
							optionsContainer.style.maxHeight = (dialogRect.height - relativeTop - 10) + 'px';
						}
					}
				} else {
					Object.assign(optionsContainer.style, {
						position: 'fixed',
						display: 'block',
						height: 'max-content',
						width: selectRect.width + 'px',
						zIndex: '9999',
						overflowY: 'auto'
					});
					
					const dropdownHeight = optionsContainer.offsetHeight;
					const spaceBelow = viewportHeight - selectRect.bottom;
					const spaceAbove = selectRect.top;
					
					if (selectRect.bottom + dropdownHeight > viewportHeight && spaceAbove > dropdownHeight && spaceAbove > spaceBelow) {
						optionsContainer.style.top = 'auto';
						optionsContainer.style.bottom = (window.innerHeight - selectRect.top) + 'px';
					} else {
						optionsContainer.style.top = selectRect.bottom + 'px';
						optionsContainer.style.bottom = 'auto';
						if (selectRect.bottom + dropdownHeight > viewportHeight) {
							optionsContainer.style.maxHeight = (viewportHeight - selectRect.bottom - 10) + 'px';
						}
					}
					
					let leftPosition = selectRect.left;
					if (leftPosition + selectRect.width > window.innerWidth) {
						leftPosition = window.innerWidth - selectRect.width - 10;
					}
					optionsContainer.style.left = leftPosition + 'px';
				}
			};
			
			const focusOption = (index) => {
				const options = getOptions();
				
				Array.from(options).forEach(opt => {
					opt.classList.remove('focused-option-js');
					opt.setAttribute('tabindex', '-1');
					opt.setAttribute('aria-selected', 'false');
				});
				
				if (index >= 0 && index < options.length) {
					const focusedItem = options[index];
					focusedItem.classList.add('focused-option-js');
					focusedItem.setAttribute('tabindex', '0');
					focusedItem.setAttribute('aria-selected', 'true');
					
					if (state.isOpen) {
						focusedItem.focus();
						focusedItem.scrollIntoView?.({ block: 'nearest' });
					}
					
					state.focusedOptionIndex = index;
				} else {
					state.focusedOptionIndex = -1;
				}
			};
			
			const attachKeyboardHandlers = (container) => {
				if (state.keyboardEventHandler) {
					document.removeEventListener('keydown', state.keyboardEventHandler);
				}
				
				state.keyboardEventHandler = (e) => {
					const isSelectActive = select === document.activeElement || select.contains(document.activeElement) || container.contains(document.activeElement);
					
					if (!isSelectActive) return;
					
					const options = getOptions();
					
					switch (e.key) {
						case 'Enter':
						case ' ':
							e.preventDefault();
							if (state.isOpen) {
								const focusedOption = container.querySelector('.focused-option-js');
								if (focusedOption) {
									const clickEvent = new CustomEvent('click', {
										bubbles: true,
										cancelable: true,
										view: window,
										detail: { isOptionSelect: true }
									});
									focusedOption.dispatchEvent(clickEvent);
									
									choseOption(focusedOption);
								} else {
									closeDropdown();
								}
							} else {
								openDropdown();
							}
							break;
						case 'Escape':
							if (state.isOpen) {
								e.preventDefault();
								closeDropdown();
								select.focus();
							}
							break;
						case 'ArrowDown':
							e.preventDefault();
							if (state.isOpen) {
								focusOption(state.focusedOptionIndex < options.length - 1 ? 
									state.focusedOptionIndex + 1 : 0);
							} else {
								openDropdown();
							}
							break;
						case 'ArrowUp':
							e.preventDefault();
							if (state.isOpen) {
								focusOption(state.focusedOptionIndex > 0 ? 
									state.focusedOptionIndex - 1 : options.length - 1);
							} else {
								openDropdown();
								focusOption(options.length - 1);
							}
							break;
						case 'Home':
							if (state.isOpen) {
								e.preventDefault();
								focusOption(0);
							}
							break;
						case 'End':
							if (state.isOpen) {
								e.preventDefault();
								focusOption(options.length - 1);
							}
							break;
						case 'Tab':
							if (state.isOpen) closeDropdown();
							break;
					}
				};
				
				document.addEventListener('keydown', state.keyboardEventHandler);
			};
			
			const choseOption = (selectedOption) => {
				if (!selectedOption || selectedOption._beingProcessed) {
					return;
				}
				
				selectedOption._beingProcessed = true;
				
				selected.textContent = selectedOption.textContent;

				if (nativeSelect) {
					const newValue = selectedOption.dataset.value;
					nativeSelect.value = newValue;
					
					const changeEvent = new Event('change', { bubbles: true });
					nativeSelect.dispatchEvent(changeEvent);
				}
				
				selected.setAttribute('title', selectedOption.textContent);
				
				closeDropdown();
				select.focus();
				
				if (nativeSelect.closest('.form__input-wrapper')) {
					formLabelAnimationFocus(nativeSelect);
				}
				
				setTimeout(() => delete selectedOption._beingProcessed, 0);
			};
			
			const openDropdown = () => {
				document.querySelectorAll('.opened-select-js').forEach(openSelect => {
					if (openSelect !== select) {
						openSelect.dispatchEvent(new CustomEvent('forcedClose'));
					}
				});
				
				select.classList.add('opened-select-js');
				select.setAttribute('aria-expanded', 'true');
				state.isOpen = true;
				
				updateDropdownPosition();
				
				window.addEventListener('scroll', handleScroll, { passive: true });
				window.addEventListener('resize', handleScroll, { passive: true });

				let parent = select.parentElement;
				while (parent && parent !== document.body) {
					parent.addEventListener('scroll', handleScroll, { passive: true });
					parent = parent.parentElement;
				}
				
				const options = getOptions();
				let selectedIndex = 0;
				
				if (nativeSelect) {
					selectedIndex = Array.from(options).findIndex(opt => 
						opt.dataset.value === nativeSelect.value);
				}
				
				focusOption(selectedIndex >= 0 ? selectedIndex : 0);
			};
			
			const handleScroll = () => {
				if (state.isOpen) closeDropdown();
			};
			
			const closeDropdown = () => {
				select.classList.remove('opened-select-js');
				select.setAttribute('aria-expanded', 'false');
				state.isOpen = false;
				state.focusedOptionIndex = -1;
				
				const optionsContainer = getOptionsContainer();
				
				if (optionsContainer) {
					if (optionsContainer._originalParent) {
						if (optionsContainer.parentElement === document.body || 
							optionsContainer.parentElement === dialogParent) {
							optionsContainer._originalParent.appendChild(optionsContainer);
						}
						delete optionsContainer._originalParent;
					}
					
					['position', 'top', 'left', 'width', 'zIndex', 'maxHeight', 
					'overflowY', 'display', 'bottom'].forEach(prop => {
						optionsContainer.style[prop] = '';
					});
					optionsContainer.scrollTop = 0;
				}
				
				window.removeEventListener('scroll', handleScroll);
				
				if (state.keyboardEventHandler) {
					document.removeEventListener('keydown', state.keyboardEventHandler);
					state.keyboardEventHandler = null;
				}
				
				let parent = select.parentElement;
				while (parent && parent !== document.body) {
					parent.removeEventListener('scroll', handleScroll);
					parent = parent.parentElement;
				}
				
				const swiperContainer = select.closest('.swiper-container, .swiper, .swiper-slide');
				if (swiperContainer) {
					swiperContainer.removeEventListener('scroll', handleScroll);
				}
				
				if (dialogParent) {
					dialogParent.removeEventListener('scroll', handleScroll);
				}
			};
			
			select.setAttribute('role', 'combobox');
			select.setAttribute('aria-haspopup', 'listbox');
			select.setAttribute('aria-expanded', 'false');
			optionsContainer.setAttribute('role', 'listbox');
			
			Array.from(optionsContainer.querySelectorAll('li')).forEach((option) => {
				option.setAttribute('role', 'option');
				option.setAttribute('aria-selected', 'false');
				option.setAttribute('tabindex', '-1');
			});
			
			select.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				if (state.disabled || (e.detail && e.detail.isOptionSelect)) {
					return;
				}

				state.isOpen ? closeDropdown() : openDropdown();
			});
			
			select.addEventListener('forcedClose', () => {
				if (state.isOpen) closeDropdown();
			});
			
			select.addEventListener('keydown', (e) => {
				if (state.disabled) {
					return;
				}
				
				if (!state.isOpen && (e.key === 'Enter' || e.key === ' ' || 
					e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
					e.preventDefault();
					e.stopPropagation();
					openDropdown();
					return false;
				}
			});
			
			document.addEventListener('click', (e) => {
				if (state.isOpen && 
					!select.contains(e.target) && 
					!getOptionsContainer()?.contains(e.target)) {
					closeDropdown();
				}
			});
			
			optionsContainer.addEventListener('click', (e) => {
				if (e.target.tagName === 'LI') choseOption(e.target);
			});
			
			Array.from(optionsContainer.querySelectorAll('li')).forEach(option => {
				option.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						
						const clickEvent = new CustomEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window,
							detail: { isOptionSelect: true }
						});
						option.dispatchEvent(clickEvent);
						
						choseOption(option);
					}
				});
			});
		});
	},
	
	getProperBackground: function() {
        $('.attributes-list-js').each(function() {
            var $list = $(this);
            var $listItems = $list.find('li');
            var $visibleItems = $listItems.filter(':visible');
            var visibleCount = $visibleItems.length;
            
            $listItems.removeClass('odd-element').css('border-bottom', '1px solid #D5D5D5');
            $visibleItems.filter(':even').addClass('odd-element');
            
            if (visibleCount % 2 !== 0) {
                $visibleItems.last().css('border-bottom', 'none');
            } else {
                $visibleItems.slice(-2).css('border-bottom', 'none');
            }
        });
    },
	
	isCartListInitialized: false,


    openCookiePopup: function(){
		const cookieSettings = document.querySelector('.cookie-container-js');
        if (cookieSettings) {
            cookieSettings.classList.toggle('hidden-js');
        }
	},

    cookieConsentSwitch: function(e) {
		const consentSwitch = e.currentTarget;
        if (consentSwitch.dataset.value == "denied" || consentSwitch.dataset.value == "") {
            consentSwitch.dataset.value = "granted";
        } else {
            consentSwitch.dataset.value = "denied";
        }
	},

	preventCookieMessage: function(e) {
		const name = $(e.currentTarget).data('name');
		const days = $(e.currentTarget).data('days');
		app.setCookie(name, 'hidden', days);
	},

    acceptAllCookies: function(e) {
        const days = $(e.currentTarget).attr('data-days');
        app.setCookie('cookieSettings', 'granted', days);
        document.querySelectorAll('.cookie-container-js .cookie-consent-js').forEach(consent => {
            consent.dataset.value = "granted";
        });

		if (typeof gtag != 'undefined') {
            gtag("consent", "update", {
                ad_storage: "granted",
                analytics_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
            });
        }

        const cookieContainer = document.querySelector('.cookie-container-js');
        if (!cookieContainer.classList.contains("hidden-js")){
            cookieContainer.classList.add("hidden-js");
        }
    },

    saveCookieSettings: function(e) {
		const cookieContainer = document.querySelector('.cookie-container-js');
		if (!cookieContainer.classList.contains("hidden-js")){
			cookieContainer.classList.add("hidden-js");
		}
		const cookieSettings = {
            analytical: "denied",
            community: "denied",
            advertising: "denied"
        };

        cookieContainer.querySelectorAll('.cookie-consent-js').forEach(consent => {
            cookieSettings[consent.dataset.name] = consent.dataset.value;
        });

		const salesMenago = document.querySelector('#bhr-chat-744bdd00-145f-4250-b0d7-2760307492c3');
        if(salesMenago != null && cookieSettings.analytical == "denied"){
            salesMenago.remove();
        }

		const days = $(e.currentTarget).attr('data-days');
		app.setCookie('cookieSettings', [cookieSettings.analytical, cookieSettings.community, cookieSettings.advertising], days);
        document.querySelectorAll('.cookie-container-js .cookie-consent-js').forEach(consent => {
            if (cookieSettings[consent.dataset.name]) {
                consent.dataset.value = cookieSettings[consent.dataset.name];
            }
        });
		
        if (typeof gtag != 'undefined') {
			gtag("consent", "update", {
				ad_storage: cookieSettings.advertising,
				analytics_storage: cookieSettings.analytical,
				ad_user_data: cookieSettings.advertising,
				ad_personalization: cookieSettings.advertising,
			});
		}
	},

	showCookieMessage: function() {
		$('body').find('.cookie-message-popup-js').removeClass('hidden-js');
	},

    initFocusManagement: function() {
        let usingKeyboard = false;
    
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Tab') {
                usingKeyboard = true;
                document.body.setAttribute('data-using-keyboard', 'true');
            }
        });
    
        document.addEventListener('mousedown', function() {
            usingKeyboard = false;
            document.body.removeAttribute('data-using-keyboard');
        });
    
        document.addEventListener('focusin', function(e) {
            if (usingKeyboard) {
                e.target.classList.add('keyboard-focus');
            } else {
                e.target.classList.remove('keyboard-focus');
            }
        });
    
        document.addEventListener('focusout', function(e) {
            e.target.classList.remove('keyboard-focus');
        });
    },

    removeProductFromCart: function(e) {
        $('.cart-products-container-js .during-ajax-modal-js').removeClass('hidden-js');
        if($(e.currentTarget).hasClass('remove-offer-js')){
            app.post(e, app.replace, window.location.pathname, '.client-area-js', 'partials/common/header/client-area.html');
        } else {
            if ($('.cart-products-container-js').index() != -1 && $('.cart-products-container-js .remove-product-from-cart-js').length == 1) {
                const currentPage = Number($('.cart-products-container-js').data('include'));
                if (currentPage > 1) {
                    $('.cart-products-container-js').data('include', currentPage - 1);
                    $('.order-template-js').data('include', currentPage - 1);
                }    
            }
            app.post(e, undefined, undefined, '.client-area-js', 'partials/common/header/client-area.html');
            const product = $(e.currentTarget);
            const itemId = product.data('id');
            const itemName = product.data('name');
            const price = Number(product.data('price'));
            let quantity = Number(product.find('[name=quantity]').val());
            if(product.data('quantity')){
                quantity = Number(product.data('quantity'));
            }
            if(typeof gtag != 'undefined'){
                const productsForGA4DataLayer = [{ item_id: itemId, item_name: itemName, price: price, quantity: quantity }];
                const totalValue = price * quantity;
                gtag("event", "remove_from_cart", {
                    currency: __currCode,
                    value: totalValue,
                    items: productsForGA4DataLayer
                });
            }
            if ($(e.currentTarget).hasClass('last-product-header-js')) {
                app.deleteCart();
            }
        }
    },

    checkAndDeleteCart: async function() {
        await js.post({__action: 'Cart/Delete' });
        window.app.setCookie('cartAuthenticateStep', 'false');
        if(window.location.search == '?add-inquiry=true'){
            app.replace(window.location.href.split('?')[0] + '?empty-inquiry=true');
            window.app.setCookie('activeInquiryId', -1);
        } else {
            window.app.setCookie('lastCartId', -1);
            app.replace(window.location.pathname);
        }
    },
    
    deleteCart: function() {
        if(typeof gtag != 'undefined'){
            let getUrl = '';
            if ($('body').find('.order-template-js').length < 1 && $('.client-area-js').data('cart-url')) {
                getUrl = $('.client-area-js').data('cart-url');
            }
            $.get(getUrl, {__collection:'cart.Products'}, async function(res){
                const products = res.collection;
                let productsForGA4DataLayer = [];
                let totalValue = 0;
                for (const product of products) {
                    const productGA4DL = { item_id: product.Id.toString(), item_name: product.NameNoHtml, price: product.TotalPrice, quantity: product.Quantity };
                    productsForGA4DataLayer.push(productGA4DL);
                    totalValue = totalValue + (product.TotalPrice * product.Quantity);
                }
                gtag("event", "remove_from_cart", {
                    currency: __currCode,
                    value: totalValue,
                    items: productsForGA4DataLayer
                });
                app.checkAndDeleteCart();
            });
        } else {
            app.checkAndDeleteCart();
        }
    },

	// Customer Profile Routing
	customerProfileRouting: (function() {
        const TEMPLATES = {
            orders: 'partials/customer-profile/orders/orders.html',
            orderDetails: 'partials/customer-profile/orders/order-details.html',
            offers: 'partials/customer-profile/offers/offers.html',
            offerDetails: 'partials/customer-profile/offers/offer-details.html',
            inquiries: 'partials/customer-profile/inquiries/inquiries.html',
            inquiryDetails: 'partials/customer-profile/inquiries/inquiry-details.html',
            invoices: 'partials/customer-profile/invoices/invoices.html',
            sor: 'partials/customer-profile/sor/sor.html',
            wm: 'partials/customer-profile/wm/wm.html',
            customerDetails: 'partials/customer-profile/customer-details/customer-details.html',
            employeesList: 'partials/customer-profile/employees-list/employees-list.html',
            loyaltyList: 'partials/customer-profile/loyalty-list/loyalty-list.html',
            consents: 'partials/customer-profile/consents/consents.html',
            toDownload: 'partials/customer-profile/to-download/to-download.html',
            complaints: 'partials/customer-profile/complaints/complaints.html',
            complaintDetails: 'partials/customer-profile/complaints/complaint-details.html',
            yourAccount: 'partials/customer-profile/your-account/your-account.html',
            employeeData: 'partials/customer-profile/your-account/employee-data.html',
            history: 'partials/customer-profile/your-account/history.html',
            discounts: 'partials/customer-profile/discounts/discounts.html',
            discountsContent: 'partials/customer-profile/discounts/discounts-content.html',
            couponsContent: 'partials/customer-profile/discounts/coupons-content.html',
            discountDetails: 'partials/customer-profile/discounts/discount-details.html',
            couponDetails: 'partials/customer-profile/discounts/coupon-details.html'
        };

        const TAB_CONFIG = {
            'eshop-orders':        { template: TEMPLATES.orders, menuTab: TEMPLATES.orders },
            'executed-orders':     { template: TEMPLATES.orders, menuTab: TEMPLATES.orders },
            'active-orders':       { template: TEMPLATES.orders, menuTab: TEMPLATES.orders },
            'erp-orders':          { template: TEMPLATES.orders, menuTab: TEMPLATES.orders },
            'offers':              { template: TEMPLATES.offers, menuTab: TEMPLATES.offers },
            'inquiries':           { template: TEMPLATES.inquiries, menuTab: TEMPLATES.inquiries },
            'invoices':            { template: TEMPLATES.invoices, menuTab: TEMPLATES.invoices },
            'sor':                 { template: TEMPLATES.sor, menuTab: TEMPLATES.sor },
            'wm':                  { template: TEMPLATES.wm, menuTab: TEMPLATES.wm },
            'customer-details':    { template: TEMPLATES.customerDetails, menuTab: TEMPLATES.customerDetails },
            'employees-list':      { template: TEMPLATES.employeesList, menuTab: TEMPLATES.employeesList },
            'loyalty-list':        { template: TEMPLATES.loyaltyList, menuTab: TEMPLATES.loyaltyList },
            'consents':            { template: TEMPLATES.consents, menuTab: TEMPLATES.consents },
            'to-download':         { template: TEMPLATES.toDownload, menuTab: TEMPLATES.toDownload },
            'active-complaints':   { template: TEMPLATES.complaints, menuTab: TEMPLATES.complaints },
            'executed-complaints': { template: TEMPLATES.complaints, menuTab: TEMPLATES.complaints },
            'order-details':       { template: TEMPLATES.orderDetails, menuTab: TEMPLATES.orders },
            'offer-details':       { template: TEMPLATES.offerDetails, menuTab: TEMPLATES.offers },
            'inquiry-details':     { template: TEMPLATES.inquiryDetails, menuTab: TEMPLATES.inquiries },
            'active-complaint-details':   { template: TEMPLATES.complaintDetails, menuTab: TEMPLATES.complaints },
            'executed-complaint-details': { template: TEMPLATES.complaintDetails, menuTab: TEMPLATES.complaints },
            'discount-details':    { template: TEMPLATES.discountDetails, menuTab: TEMPLATES.discounts },
            'coupon-details':      { template: TEMPLATES.couponDetails, menuTab: TEMPLATES.discounts },
            'your-account': { template: TEMPLATES.employeeData, parent: TEMPLATES.yourAccount, container: '.employee-data-js', menuTab: TEMPLATES.yourAccount },
            'history': { template: TEMPLATES.history, parent: TEMPLATES.yourAccount, container: '.employee-data-js', menuTab: TEMPLATES.yourAccount },
            'discounts': { template: TEMPLATES.discountsContent, parent: TEMPLATES.discounts, container: '.promotions-content-js', menuTab: TEMPLATES.discounts },
            'coupons': { template: TEMPLATES.couponsContent, parent: TEMPLATES.discounts, container: '.promotions-content-js', menuTab: TEMPLATES.discounts }
        };

        const getDefaultTab = () => typeof __isB2B !== 'undefined' && __isB2B ? 'eshop-orders' : 'executed-orders';
        const getConfig = (tab) => TAB_CONFIG[tab] || null;
        
        const getTabFromUrl = (url) => {
            try {
                return new URLSearchParams(new URL(url, window.location.origin).search).get('tab');
            } catch (e) { return null; }
        };

        const getTabFromTemplate = (template) => {
            for (const [tab, config] of Object.entries(TAB_CONFIG)) {
                if (config.template === template && !config.parent) return tab;
            }
            for (const [tab, config] of Object.entries(TAB_CONFIG)) {
                if (config.parent === template) return tab;
            }
            return null;
        };

        const buildUrl = (tab) => {
            const baseUrl = typeof __CPLink !== 'undefined' ? __CPLink : window.location.pathname;
            const separator = baseUrl.includes('?') ? '&' : '?';
            return baseUrl + separator + 'tab=' + tab;
        };

        const updateMenuHighlight = (menuTemplate) => {
            $('.customer-profile-menu-js .customer-container-menu__label').removeClass('active-js');
            $('.customer-container-menu__label[data-template="' + menuTemplate + '"]').addClass('active-js');
        };

        const updateSubTabHighlight = (template, tab) => {
            $('.change-type-js').removeClass('active');
            if (template) $('.change-type-js[data-template="' + template + '"]').addClass('active');
            if (tab) $('.change-type-js[data-url*="tab=' + tab + '"]').addClass('active');
        };

        const afterContentLoad = (container) => {
            app.formLabelAnimationOnLoadPage();
            app.updateSlider();
            app.selects(container || $('.customer-profile-content-js'));
        };

        const navigate = (e, skipHistoryPush = false) => {
            const button = $(e.currentTarget);
            const template = button.data('template');
            const url = button.data('url');
            const contentBox = $('.customer-profile-content-js');

            if (!contentBox.length) {
                const tabValue = getTabFromTemplate(template);
                window.location.href = tabValue ? buildUrl(tabValue) : __CPLink;
                return;
            }

            const tabValue = getTabFromTemplate(template);
            const finalUrl = url || buildUrl(tabValue || getDefaultTab());

            if (!skipHistoryPush) {
                window.history.pushState({ tab: tabValue, template: template, url: finalUrl }, '', app.historyUrl(finalUrl));
            }

            updateMenuHighlight(template);
            app.replaceTemplate(e, undefined, () => afterContentLoad(contentBox), e);
        };

        const navigateSubTab = (e) => {
            const button = $(e.currentTarget);
            const template = button.data('template');
            const url = button.data('url');
            const container = button.closest('[data-subtab-container]').data('subtab-container') || button.data('container');
            
            let tab = url ? getTabFromUrl(url) : null;
            if (!tab) {
                for (const [tabName, config] of Object.entries(TAB_CONFIG)) {
                    if (config.template === template) { tab = tabName; break; }
                }
            }

            const config = tab ? getConfig(tab) : null;
            const finalUrl = url || buildUrl(tab || getDefaultTab());

            window.history.pushState({ tab, template, url: finalUrl, isSubTab: true }, '', app.historyUrl(finalUrl));
            updateSubTabHighlight(template, tab);
            
            const $container = container ? $(container) : null;
            if ($container && $container.length) {
                $.get(finalUrl, { __template: template }, (result) => {
                    $container.html(result.template);
                    afterContentLoad($container);
                });
            } else {
                const contentBox = $('.customer-profile-content-js');
                $.get(finalUrl, { __template: template }, (result) => {
                    contentBox.html(result.template);
                    if (config && config.menuTab) updateMenuHighlight(config.menuTab);
                    afterContentLoad(contentBox);
                });
            }
        };

        const navigateToDetails = (e, callback) => {
            const button = $(e.currentTarget);
            const url = button.data('url');
            const template = button.data('template');
            const tab = getTabFromUrl(url);
            const config = tab ? getConfig(tab) : null;

            window.history.pushState({ tab, template, url, isDetails: true }, '', app.historyUrl(url));
            if (config && config.menuTab) updateMenuHighlight(config.menuTab);

            app.replaceTemplate(e, undefined, (evt) => {
                if (callback) callback(evt);
                afterContentLoad();
            }, e);
        };

        const navigateToList = (e, callback) => {
            const button = $(e.currentTarget);
            const url = button.data('url');
            const template = button.data('template');
            const tab = getTabFromUrl(url);
            const config = tab ? getConfig(tab) : null;

            window.history.pushState({ tab, template, url, isList: true }, '', app.historyUrl(url));
            if (config && config.menuTab) updateMenuHighlight(config.menuTab);
            else if (template) updateMenuHighlight(template);
            if (tab) updateSubTabHighlight(null, tab);

            app.replaceTemplate(e, undefined, (evt) => {
                window.erpPageNo = window.erpOrderId = window.erpInvoiceId = window.erpSORId = window.erpWMId = undefined;
                if (callback) callback(evt);
                afterContentLoad();
            }, e);
        };

        const handlePopState = (state) => {
            const contentBox = $('.customer-profile-content-js');
            if (!contentBox.length) return;

            let currentTab = state?.tab || getTabFromUrl(window.location.href) || getDefaultTab();
            let config = getConfig(currentTab);
            if (!config) { currentTab = getDefaultTab(); config = getConfig(currentTab); }
            
            const url = state?.url || window.location.href;
            const templateToLoad = state?.template || config?.template || TAB_CONFIG[getDefaultTab()].template;

            if (config?.parent && config?.container) {
                const $container = $(config.container);
                if ($container.length > 0) {
                    $.get(url, { __template: config.template }, (result) => {
                        $container.html(result.template);
                        updateMenuHighlight(config.menuTab || config.parent);
                        updateSubTabHighlight(config.template, currentTab);
                        afterContentLoad($container);
                    });
                } else {
                    $.when(
                        $.get(url, { __template: config.parent }),
                        $.get(url, { __template: config.template })
                    ).done((parentResult, subTabResult) => {
                        const $temp = $('<div>').html(parentResult[0].template);
                        $temp.find(config.container).html(subTabResult[0].template);
                        contentBox.html($temp.html());
                        updateMenuHighlight(config.menuTab || config.parent);
                        updateSubTabHighlight(config.template, currentTab);
                        afterContentLoad(contentBox);
                    });
                }
                return;
            }

            $.get(url, { __template: templateToLoad }, (result) => {
                contentBox.html(result.template);
                updateMenuHighlight(config?.menuTab || templateToLoad);
                updateSubTabHighlight(null, currentTab);
                afterContentLoad(contentBox);
            });
        };

        const init = () => {
            if (window.__cpRoutingInitialized || $('.customer-profile-js').length === 0) return;
            window.__cpRoutingInitialized = true;

            let currentTab = getTabFromUrl(window.location.href);
            let initialUrl = window.location.href;
            const defaultTab = getDefaultTab();
            
            if (!currentTab) {
                currentTab = defaultTab;
                const url = new URL(window.location.href);
                url.searchParams.set('tab', currentTab);
                initialUrl = url.toString();
            }
            
            const config = getConfig(currentTab);
            
            window.history.replaceState({ tab: currentTab, template: config?.template, url: initialUrl }, '', initialUrl);
            window.addEventListener('popstate', (event) => {
                if ($('.customer-profile-js').length > 0) handlePopState(event.state);
            });

            // Update menu highlight based on current tab (content is already server-rendered)
            if (config) {
                updateMenuHighlight(config.menuTab || config.parent || config.template);
                if (config.parent) {
                    updateSubTabHighlight(config.template, currentTab);
                } else {
                    updateSubTabHighlight(null, currentTab);
                }
                app.updateSlider();
            }
        };

        const updateTabFromUrl = () => {
            const currentTab = getTabFromUrl(window.location.href);
            if (!currentTab) return;
            const config = getConfig(currentTab);
            if (!config) return;

            updateMenuHighlight(config.menuTab || config.parent || config.template);
            config.parent ? updateSubTabHighlight(config.template, currentTab) : updateSubTabHighlight(null, currentTab);
            app.updateSlider();
        };

        return { navigate, navigateSubTab, navigateToDetails, navigateToList, handlePopState, init, updateTabFromUrl, getTabFromUrl, getConfig };
    })(),

    activateFocusTrap(containerSelector, triggerElement, delay = 100, reloadAfter = false, manuallyIndex = null) {
		let index = 0;

		if (reloadAfter && manuallyIndex == null) {
				let triggerElementClassList = '.' + triggerElement.classList.toString().split(' ').join('.');
				if (triggerElementClassList[triggerElementClassList.length - 1] == '.') {
					triggerElementClassList = triggerElementClassList.slice(0, -1);
				}
				let elementsToFind = document.querySelectorAll(triggerElementClassList);
				for (let item of elementsToFind) {
					if (item == triggerElement) {
						break;
					}
					index += 1;
				}
			}

			const container = document.querySelector(containerSelector);
			if (!container) return;
		
			const allFocusable = container.querySelectorAll(
				'iframe, a[href], button:not([disabled]), textarea, input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), select, [tabindex]:not([tabindex="-1"])'
			);
			
			const focusableElements = Array.from(allFocusable).filter(el => {
				return el.offsetParent !== null || $(el).attr('data-focusable') === 'true';
			});

			if (focusableElements.length === 0) return;
		
			const firstFocusable = focusableElements[0];
			const lastFocusable = focusableElements[focusableElements.length - 1];
			setTimeout(() => {
				if (firstFocusable && firstFocusable.focus) {
					firstFocusable.focus();
				}
			}, 100);
		
			function trapFocus(e) {
				if (e.key !== 'Tab') return;
				if (e.shiftKey) {
					if (document.activeElement === firstFocusable) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					if (document.activeElement === lastFocusable) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}        
		const closeButton = container.querySelectorAll('.close-js, .cancel-js, .hide-container-js');
			if (closeButton) {
				function isFocusable(el) {
					if (!el) return false;
					const focusableSelectors = [
						'a[href]',
						'button:not([disabled])',
						'textarea',
						'input:not([disabled]):not([type="hidden"])',
						'select',
						'[tabindex]:not([tabindex="-1"])',
						'i[tabindex="0"]'
					];
					return el.matches(focusableSelectors.join(', '));
				}
			
				var triggerElementToFocus = null;
				if (isFocusable(triggerElement)) {
					triggerElementToFocus = triggerElement;
				} else {
					triggerElementToFocus = triggerElement.querySelector(
						'a[href], button:not([disabled]), textarea, input:not([disabled]):not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])'
					);
				}
			
				if (!triggerElementToFocus) return;
				for (let el of closeButton) {
					el.addEventListener('click', function () {
					$('.popup-to-focus-js').removeClass('popup-to-focus-js');
						setTimeout(function () {
						if (reloadAfter ) {
								let newElementToFocus = '.' + triggerElementToFocus.classList.toString().split(' ').join('.');
								if (newElementToFocus[newElementToFocus.length - 1] == '.') {
									newElementToFocus = newElementToFocus.slice(0, -1);
								}
							if (!manuallyIndex) {
								$(newElementToFocus).eq(index).focus();
							} else {
								$(newElementToFocus).eq(manuallyIndex).focus();
							}
							} else {
								triggerElementToFocus.focus();
							}
						}, delay);
					});
				
					el.addEventListener('keydown', function (e) {
						if (e.key === 'Enter' || e.keyCode === 13) {
							e.preventDefault();
							el.click();
						}
					});
				}
			}
		
			container.addEventListener('keydown', trapFocus);
		
			return () => {
			$('.popup-to-focus-js').removeClass('popup-to-focus-js');
				container.removeEventListener('keydown', trapFocus);
			};
    },

    closePopupOnEscape(popup, closeButtonClass, nextFocusElement) {
        popup.on('keydown.Focus click.Focus', (e) => {
            if (e.key === 'Escape') {
                const event = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                popup.find('.'+closeButtonClass)[0].dispatchEvent(event);
                nextFocusElement.focus();
            } else if (e.type === 'click' && e.target.classList.contains(closeButtonClass)) {
                nextFocusElement.focus();
            }
            popup.off('keydown.Focus click.Focus');
        });
    },

    focusManager: {
        lastFocusedElement: document.activeElement,
        lastFocusedElementSelector: '',
        elementIndex: 0,
        observer: null,
        
        trackFocus: function(e) {
            if (e && e.target) {
                this.lastFocusedElement = e.target;
                
                const classes = Array.from(e.target.classList).join('.');
                if (classes) {
                    this.lastFocusedElementSelector = '.' + classes;
                    const similarElements = document.querySelectorAll(this.lastFocusedElementSelector);
                    for (let i = 0; i < similarElements.length; i++) {
                        if (similarElements[i] === e.target) {
                            this.elementIndex = i;
                            break;
                        }
                    }
                }
            }
        },
        
        restoreFocus: function(callback) {
            if (this.lastFocusedElement?.isConnected) {
                return this.applyFocus(this.lastFocusedElement, callback);
            }
            
            if (this.lastFocusedElementSelector) {
                return this.focusSimilarElement(callback);
            }
            
            return false;
        },

        focusSimilarElement: function(callback) {
            const similarElements = document.querySelectorAll(this.lastFocusedElementSelector);
            
            if (similarElements.length === 0) {
                return false;
            }
            
            const indexToFocus = this.elementIndex < similarElements.length ? 
                this.elementIndex : 0;
            
            return this.applyFocus(similarElements[indexToFocus], callback);
        },

        applyFocus: function(element, callback) {
            if (!element) {
                return false;
            }

            element.focus();
            
            if (typeof callback === 'function') {
                callback(element);
            }
            
            return true;
        },

        setFocus: function(element, callback) {
            if (!element) {
                return false;
            }

            const targetElement = typeof element === 'string' 
                ? document.querySelector(element) 
                : element;
            
            if (targetElement) {
                targetElement.focus();
                
                if (typeof callback === 'function') {
                    callback(targetElement);
                }
                return true;
            }
            
            return false;
        },
        
        init: function() {
            document.addEventListener('focusin', this.trackFocus.bind(this));
            
            this.observer = new MutationObserver((mutations) => {
                let shouldRestoreFocus = false;
                
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList') {
                        mutation.removedNodes.forEach(node => {
                            if (node.contains && this.lastFocusedElement && 
                                (node === this.lastFocusedElement || node.contains(this.lastFocusedElement))) {
                                shouldRestoreFocus = true;
                            }
                        });
                        
                        if (mutation.addedNodes.length > 0) {
                            setTimeout(() => {
                                if (shouldRestoreFocus) {
                                    this.restoreFocus();
                                }
                            }, 50);
                        }
                    }
                });
            });
            
            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    },

    getFirstFocusableElement(containerSelector) {
        let container = document.querySelector(containerSelector);

        const defaultExcludeSelectors = ['.cart-edit-view-js'];
        const allFocusable = container.querySelectorAll(
            'a[href], button:not([disabled]), textarea, input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), select, [tabindex]:not([tabindex="-1"])'
        );

        const focusableElements = Array.from(allFocusable).filter(el => {
            for (const selector of defaultExcludeSelectors) {
                if (el.matches(selector) || el.classList.contains(selector.replace('.', ''))) {
                    return false;
                }
            }
            return el.offsetParent !== null || $(el).attr('data-focusable') === 'true';
        });

        if (focusableElements[0]) {
            focusableElements[0].focus();
            return true;
        } else {
            return false;
        }
    },

    setLockFocus: function(element, closeFunction, switchButton = null, focusFirstElement = true) {
		const focusableElements = element.find('a, button, input:not([type="hidden"]), textarea, details, [tabindex="0"]').filter(function() {
			const $el = $(this);
			if ($el.hasClass('swiper-button-prev') || $el.hasClass('swiper-button-next')) {
				return true;
			}
			return $el.css('visibility') !== 'hidden' && $el.css('display') !== 'none';
		});

		if (focusableElements.length === 0)
			return;
		
		element.removeClass('lock-focus-pre-js');
		switchButton.removeClass('switch-focus-pre-js');
		
		const previousFocus = $('.lock-focus-js');
		const previousSwitchButton = $('.switch-focus-js');
		
		previousFocus.addClass('lock-focus-pre-js');
		previousSwitchButton.addClass('switch-focus-pre-js');

		previousFocus.removeClass('lock-focus-js');
		previousSwitchButton.removeClass('switch-focus-js');

		switchButton.addClass('switch-focus-js');
		element.addClass('lock-focus-js');

		const firstFocusableElement = focusableElements[0];
		const amountOfFocusableElements = focusableElements.length;
		let lastFocusableElement = focusableElements[amountOfFocusableElements - 1];
		const selects = element.find('.select-wcag-js, .select-js');

		if (focusFirstElement) {
			firstFocusableElement.focus();
		}
		
		element.on('keydown.lockFocus', (e) => {
			if (lastFocusableElement.classList.contains('swiper-button-disabled') && lastFocusableElement !== focusableElements[amountOfFocusableElements - 2]) {
				lastFocusableElement = focusableElements[amountOfFocusableElements - 2];
			} else if (!focusableElements[amountOfFocusableElements - 1].classList.contains('swiper-button-disabled')) {
				lastFocusableElement = focusableElements[amountOfFocusableElements - 1];
			}

			if (e.key === 'Escape') {
				if (!selects.hasClass('opened-select-js')) {
					e.preventDefault();
					closeFunction(e);
					return;
				}
			}

			if (lastFocusableElement === document.activeElement && !e.shiftKey && e.key === 'Tab') {
				e.preventDefault();
				firstFocusableElement.focus();
			} else if (firstFocusableElement === document.activeElement && e.shiftKey && e.key === 'Tab') {
				e.preventDefault();
				lastFocusableElement.focus();
			}
			
		});
	},

	// when focused container changes elements
	resetLockFocus: function(closeFunction, focusFirstElement = true) {
		const element = $('.lock-focus-js');
		const switchButton = $('.switch-focus-js');

		const prevElement = $('.lock-focus-pre-js');
		const prevSwitchButton = $('.switch-focus-pre-js');

		element.off('keydown.lockFocus');
		if (prevElement.length === 0) {
			app.setLockFocus(element, closeFunction, switchButton, focusFirstElement);
		} else {
			app.setLockFocus(prevElement, closeFunction, prevSwitchButton, focusFirstElement);
			element.removeClass('lock-focus-pre-js');
			switchButton.removeClass('switch-focus-pre-js');
		}
	},

	offLockFocus: function() {
		const element = $('.lock-focus-js');
		const switchButton = $('.switch-focus-js');

		if (element.length === 0 && switchButton.length === 0) return;

		element.off('keydown.lockFocus');
		switchButton.focus();
		element.removeClass('lock-focus-js');
		switchButton.removeClass('switch-focus-js');
	},

	// show and close popup
	popupInfo: function() {
		const popup = document.querySelector(".popup-info-js");
	
		if (popup && popup.dataset.isStarted !== "true") {
			popup.dataset.isStarted = "true";
			popup.style.display = "block";

			const closePopup = setTimeout(() => {
				popup.style.display = "none";
				popup.dataset.isStarted = "false";
			}, 4000);
	
			popup.querySelector(".popup-info-close-js").addEventListener("click", () => {
				popup.style.display = "none";
				clearTimeout(closePopup);
				popup.dataset.isStarted = "false";
			});
		}
	},

	// to init manufactures and brands slider
	sliderInit: function(sliderSelector, nextBtnSlider, prevBtnSlider, pauseBtnSlider) {
		const numberOfSlides = $(sliderSelector).find(".companies__wrapper").data("len");
		const timer = $(sliderSelector).data("timer");
		const slider = $(sliderSelector);
		let isAutoplay = false;
		if (typeof(timer) === "number" && timer >= 0) {
			isAutoplay = true;
		}
		
		const swiper = new Swiper(sliderSelector, {
			spaceBetween: 48,
			centerInsufficientSlides: true,
			navigation: {
				nextEl: nextBtnSlider,
				prevEl: prevBtnSlider,
			},
			autoplay: isAutoplay ?  { delay: timer } : false,
			breakpoints: {
				0: {
					slidesPerView: 2.5,
					loop: (numberOfSlides > 3) ? true : false
				},

				769: {
					slidesPerView: 5.5,
					loop: (numberOfSlides > 6) ? true : false
				},

				1440: {
					slidesPerView: 8.5,
					loop: (numberOfSlides > 9) ? true : false,
				},
			},
			pause: {
				enabled: true,
				el: pauseBtnSlider,
			},
			a11y: false,
			keyboard: {
                enabled: true,
				pageUpDown: true
            },
			watchSlidesProgress: true,
			slideToClickedSlide: true,
            scrollOnFocus: true,
			on: {
                init: function () {
                    app.manageTabIndexInsideSlide(this);
                },
                slideChangeTransitionEnd: function () {
                    app.manageTabIndexInsideSlide(this);
                }
            },
		});
	},

	textElement: function() {
		// add content
		const $textElement = $(".textElement");
		$textElement.each((i, item) => {
            const $item = $(item);
            const content = ($item.data("content") === undefined) ? "" : $item.data("content");

            const regex = /(s*(?:w|[^w])*s*)/;

            const text = (content.match(regex) !== null) ? "<div class='textElement__container-column'>" + content.match(regex)[1] + "</div>" : "";

            const $container = $item.find(".textElement__container");

            if (content !== "") 
                $container.html($container.html() + text);

            const height = $container.height();

            if (height > 360) {
                $item.find(".textElement__gradient").css("visibility", "visible");
                $item.find(".textElement__hidder").css("visibility", "visible");
				$item.find(".textElement__container").css("paddingBottom", "40px");
            }
        });

		// roll and unroll content
		$textElement.each((i, item) => {
			const $item = $(item);
            
			$(window).on("resize", () => {
				const height = $item.find(".textElement__container").height() + 112;
				if ($item.hasClass("clicked"))
					$item.css("maxHeight", height);
			});
			
            $item.find(".textElement__hidder-button").on("click", () => {
                if ($item.hasClass("clicked")) {
                    $item.find(".textElement__hidder-button svg").css("rotate", "90deg");
                    $item.find(".rollOut-js").css("display", "inline");
                    $item.find(".rollIn-js").css("display", "none");
                    $item.removeClass("clicked");
                    $item.find(".textElement__gradient").fadeIn(1000);
					const height = $item.find(".textElement__container").height() + 112;
					if ($item.hasClass("open"))
						$item.css("maxHeight", height);
                    $item.animate({ "maxHeight": "360px" }, 1000);
                }
                else {
                    $item.find(".rollOut-js").css("display", "none");
                    $item.find(".rollIn-js").css("display", "inline");
                    $item.find(".textElement__hidder-button svg").css("rotate", "-90deg")
                    $item.addClass("clicked");
                    $item.find(".textElement__gradient").fadeOut(1000);
					const height = $item.find(".textElement__container").height() + 112;
                    $item.animate({ "maxHeight": height}, 1000);
                }
            });
        });
	},

	manageTabIndexInsideSlide: function(swiper) {
		swiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-fully-visible')) {
				slide.querySelectorAll('a:not(.not-focusable-js), button, [tabindex]:not(.not-focusable-js), iframe, video').forEach((sl) => {
					sl.setAttribute('tabindex', '0')
				});
			} else {
				slide.querySelectorAll('a:not(.not-focusable-js), button, [tabindex]:not(.not-focusable-js), iframe, video').forEach((sl) => {
					sl.setAttribute('tabindex', '-1')
				});
			}
		});
		
		const ifFocus = swiper.slides.some((slide) => {
			return slide.contains(document.activeElement);
		});

		const activeSlide = swiper.slides.filter(slide => slide.classList.contains('swiper-slide-active'))[0];
		if (ifFocus) {
			if (activeSlide.querySelector('a:not(.not-focusable-js), button, [tabindex]:not(.not-focusable-js), iframe, video') !== null) {
				activeSlide.querySelector('a:not(.not-focusable-js), button, [tabindex]:not(.not-focusable-js), iframe, video').focus();
			}
		}

		const prev = swiper.navigation.prevEl;
		const next = swiper.navigation.nextEl;

		if (prev) {
			prev.addEventListener('blur', (e) => {
				if (e.currentTarget.classList.contains('swiper-button-disabled')) {
					next.focus();
				}
			});
		}

		if (next) {
			next.addEventListener('blur', (e) => {
				if (e.currentTarget.classList.contains('swiper-button-disabled')) {
					prev.focus();
				}
			});
		}
	},

	getProductIdsAndUnits: function() {
		const productElements = document.querySelectorAll('.client-area-js .header-cart-product-js');
		return [
			Array.from(productElements).map(el => el.dataset.id), 
			Array.from(productElements).map(el => el.dataset.unit)
		];
	},

	isProductInCart: function(productId, unitName) {
		const [productIds, productUnits] = this.getProductIdsAndUnits();

		const idIndexes = productIds
			.map((id, index) => id === productId ? index : -1)
			.filter(index => index !== -1);

		if (idIndexes.length === 0) {
			return false;
		}
		
		for (const index of idIndexes) {
			if (productUnits[index] === unitName) {
				return true;
			}
		}
	},

	/**
	 * Updates the state of Minimum, Multiplicity, Quantity (MMQ) validation for a set of quantity inputs and units.
	 * Adds/removes error classes and disables/enables the add-to-cart button based on validation results.
	 * 
	 * @param {HTMLInputElement[]} inputs - Array of quantity input elements.
	 * @param {HTMLSelectElement[]} allUnits - Array of unit select elements (can be empty).
	 * @param {HTMLButtonElement} addToCartButton - The button to add products to the cart.
	 * @param {HTMLInputElement} input - The specific input being validated.
	 * @param {number} index - Index of the input/unit in their respective arrays.
	 * @param {boolean} [isFirstRun=false] - If true, applies initial validation styling.
	 */
	updateStateOfMMQVal: function(inputs, allUnits, addToCartButton, input, index, isFirstRun = false) {
		const minq = parseFloat(input.dataset.minq);
		const value = parseFloat(input.value);
		const productId = input.dataset.id;
		const ratios = input.dataset.unitRatios.split(',');
		const unitNames = input.dataset.unitNames.split(',');
		const allZeros = Array.from(inputs).every(inp => parseFloat(inp.value) === 0);
		const multiplicity = parseFloat(input.dataset.multiplicity);

		let ratio = parseFloat(ratios[0]);
		let unitName = unitNames[0];

		const unitSelect = Array.from(allUnits).find(
			sel => sel.dataset.index == index
		);
		if (unitSelect) {
			const selectedIndex = unitSelect.selectedIndex;
			ratio = parseFloat(ratios[selectedIndex]);
			unitName = unitNames[selectedIndex];
		}

		const trueValue = value * ratio;
		const rest = value % multiplicity;

		if (((trueValue < minq && trueValue !== 0) && !this.isProductInCart(productId, unitName)) || isNaN(trueValue) || (rest !== 0 && !isNaN(multiplicity))) {
			if (isFirstRun) {
				input.parentElement.classList.add('validation-error');
			} else {
				input.classList.add('q-error-js');
				input.ariaInvalid = 'true';
			}
		} else {
			input.classList.remove('q-error-js');
			input.ariaInvalid = 'false';
		}

		if (input.closest('.form-js').querySelector('.q-error-js') || allZeros) {
			addToCartButton.disabled = true;
			if (allZeros && isFirstRun) {
				input.parentElement.classList.add('validation-error');
			}
		} else {
			addToCartButton.disabled = false;
		}
	},

	/**
	 * Removes MMQ validation event listeners and error classes from quantity inputs and units.
	 * 
	 * @param {HTMLInputElement[]} inputs - Array of quantity input elements.
	 * @param {HTMLSelectElement[]} allUnits - Array of unit select elements (can be empty).
	 * @param {HTMLButtonElement} addToCartButton - The button to add products to the cart.
	 */
	turnOffMMQVal: function(inputs, allUnits, addToCartButton) {
		inputs.forEach((input, index) => {
			input.removeEventListener('input', input._validation);
			input.parentElement.classList.remove('validation-error');
			if (allUnits.length > 0) {
				allUnits[index].removeEventListener('change', allUnits[index]._validation);
			}
		});

		addToCartButton.removeEventListener('click', () => app.turnOffMMQVal(inputs, allUnits, addToCartButton));
	},

	/**
	 * Initializes MMQ validation for quantity inputs and units.
	 * Binds input/change event listeners and disables the add-to-cart button if any errors are present.
	 * 
	 * @param {HTMLInputElement[]} inputs - Array of quantity input elements.
	 * @param {HTMLSelectElement[]} allUnits - Array of unit select elements (can be empty).
	 * @param {HTMLButtonElement} addToCartButton - The button to add products to the cart.
	 */
	MMQVal: function(inputs, allUnits, addToCartButton) {
		inputs.forEach((input, index) => {
			input._validation = function() {
				app.updateStateOfMMQVal(inputs, allUnits, addToCartButton, this, index);
			}

			app.updateStateOfMMQVal(inputs, allUnits, addToCartButton, input, index, true);

			input.addEventListener('input', input._validation);

			if (allUnits.length > 0) {
				allUnits[index]._validation = function() {
					app.updateStateOfMMQVal(inputs, allUnits, addToCartButton, inputs[index], index);
				}

				allUnits[index].addEventListener('change', allUnits[index]._validation);
			}
		});

		const errorInputs = document.querySelectorAll('.validation-error');
		if (errorInputs.length > 0) {
			addToCartButton.disabled = true;
		}

		addToCartButton.addEventListener('click', () => app.turnOffMMQVal(inputs, allUnits, addToCartButton));
	},

	changeSlideOnPaddingSwiper: function(pagination, swiper) {
		pagination.slides.forEach((slide, index) => {
			slide.addEventListener('click', () => {
				swiper.slideTo(index);
			});
		});
	},

	readonlyFormFields: function(container, isReadonly) {
		$(container).find('[name="name"],[name="name2"],[name="street"],[name="streetNo"],[name="unitNo"],[name="zipCode"],[name="city"]').each(function() {
			const input = $(this);
			input.attr('readonly', isReadonly);
			input.parents('label').attr('readonly', isReadonly);
		});
	},

    events: function() {
        $('body').on('click', 'button', function(e) {
			e.preventDefault();
		});
		$('.filterSetAmount-js').on('click', function(e) {
			let filtersCounter = app.filtersCount()
			let inputMin = Number($('input[name="$minPrice"]').val());
			let inputMax = Number($('input[name="$maxPrice"]').val());
			// if((filtersCounter == 0 && inputMin == 0 && inputMax == 0) && $('.selected-filter-item-js').length == 0){
			// 	$('.filterAllUp-js').animate({opacity:0}, 400); 
			// 	$('.filterAllUp-js').css('pointer-events','none')

			// }else{
			// 	$('.filterAllUp-js').animate({opacity: 1}, 400); 
			// 	$('.filterAllUp-js').css('pointer-events','auto')
			// }
		});
		$('.filterInputUp-js').on('change', function(e) {
			let inputMin = Number($('input[name="$minPrice"]').val());
			let inputMax = Number($('input[name="$maxPrice"]').val());
			let filtersCounter = app.filtersCount()
			// if((inputMin != 0 || inputMax != 0)){
			// 	$('.filterAllUp-js').animate({opacity: 1}, 400); 
			// 	$('.reset-filters-js').css('pointer-events','auto')
			// 	$('.filterAllUp-js').css('pointer-events','auto')
			// }else if((filtersCounter == 0 && inputMin == 0 && inputMax == 0) && $('.selected-filter-item-js').length == 0){
			// 	$('.filterAllUp-js').animate({opacity: 0}, 400); 
			// 	$('.filterAllUp-js').css('pointer-events','none')
			// }
		});
		$('body').on('keypress', '[name="quantity"]', function(e) {
			app.validateQuantitySigns(e);
		});
        $('body').on('keypress', '[type="quantity"]', function(e) {
            app.validateQuantitySigns(e);
        });
		$('body').on('change', 'select[name="gender"]', function(e) {
			app.validationSelect(e);
		});
		$('body').on('click', '.select__options > li', function (e) {
			var customSelect = $('#selectDSA');
		
			customSelect.val($(this).data('report-type')).trigger('change');
			app.validationSelect({ currentTarget: customSelect });
		});
		$('body').on('focusout', '.form__input-value.select-js', function (e) {
			var wrapper = $(this).closest('.form__input-wrapper');
			var customSelect = wrapper.find('select#selectDSA');

			if (customSelect.length) {
				var selectedValue = customSelect.val();

				if (!selectedValue || selectedValue === 'null') {
					wrapper.find('.validation-required-js').removeClass('hidden-js');
					wrapper.find('.form__input-info').addClass('validation-error');
					wrapper.find('.form__input-value').addClass('validation-error-js');
				} else {
					wrapper.find('.validation-required-js').addClass('hidden-js');
					wrapper.find('.form__input-info').removeClass('validation-error');
					wrapper.find('.form__input-value').removeClass('validation-error-js');
				}
			}
		});
		
		$('body').on('blur', 'input:not(.validation-error-js):not([name=attributeEditable]):not(.onlyInputEventValidation), textarea:not(.validation-error-js)', function(e) {
			app.validation(e);
			if($('.child-js').index() != -1 && $(e.currentTarget).parents('.reviews-js').index() == -1 && $(e.currentTarget).parents('.form-js').find('[value="Product/NotifyAboutProductAvailability"]').index() == -1 && $(e.currentTarget).parents('.form-js').find('[value="Contact/TellFriendAboutProduct"]').index() == -1 && $(e.currentTarget).parents('.form-js').find('[value="Contact/AskAboutProduct"]').index() == -1 && !$(e.currentTarget).hasClass('import-cart-input-js')){
				changeSavedQuantity(e);
			}
		});
		$('body').on('keydown', 'input[name="phoneNo"]', function(e) {
            app.validatePhoneNo(e);
        });
        $('input[name="phoneNo"]').bind('paste', function(e) {
            setTimeout(function() {
                app.validatePhoneNo(e, true);
            });
        });
		$('body').on('input', 'input.validation-error-js, textarea.validation-error-js, [name=password], [name=passwordRepeat], [name=email], [name=emailRepeat]', function(e) {
			app.validation(e);
		});
		$('body').on('input, paste', '[name="tin"]', function(e) {
			if($('[name="countryCode"]').val() == 'PL'){
				app.validation(e);
			}
		});
		$('body').on('change', '[name="countryCode"]:not(.change-delivery-country-js):not(.validate-after-replace-js):not(.register-country), input[type="checkbox"]', function(e) {
			app.validation(e);
		});
		$('body').on('change', '[data-last-proper-quantity]', function(e) {
			app.validation(e);
			app.post(e);
		});
		$('body').on('click', '[name="remember-choice"]', function(e) {
			e.stopPropagation();
		});
		$('body').on('click', '.post-js', function(e) {
			if ($(e.currentTarget).hasClass('delete-cart-coupon-js')) {
				app.post(e, undefined, undefined, '.client-area-js', 'partials/common/header/client-area.html');
				app.getFirstFocusableElement('.cart-coupon-js');
				return;
			}
			app.post(e, undefined, undefined);
		});
		
		$('body').on('click', '.close-js', function(e) {
			app.closeMessagePopup(e);
			if($('.add-variants-to-cart-from-prod-list-popup-background-js').length > 0){
				$('.add-variants-to-cart-from-prod-list-popup-background-js').trigger('click');
			}
		});
		$('body').on('click', '.clear-review-popup-js', function(e) {
			js.resetReviewForm();
		});
		$('body').on('click', '.close-centered-cookie-message-js', function(e) {
			app.closeCenteredCookieMessage(e);
        });
		$('body').on('click', '.open-dropdown-js', function(e) {
			app.openDropdown(e);
		});
		$('body').on('click', '.close-dropdown-js', function(e) {
			app.closeDropdown(e);
		});
		$('body').on('click', '.register-submit-js', function(e) {
			$(e.currentTarget).parents('.form-js').find('[name="countryCode"]').attr('disabled', false);
			app.post(e, app.signUpSuccess, {url:'', delay:10000, form: $(e.currentTarget).parents('.form-js'), event: e});
		});
		$('body').on('click', '.sign-out-js', function(e) {
			app.post(e, app.signOutSuccess);
		});
		
		$('body').on('click', '.reject-js', function(e) {
			var action = $(e.currentTarget).data('action'); 
			var form = $(e.currentTarget).parents('.form-js');
			var data = [];

			data.push({name: "__csrf", value: __CSRF});

			if (action === 'Customer/Logout') {
				data.push({name: "__action", value: 'Customer/Logout'});
			} else {
				data.push({name: "__action", value: 'Customer/ConsentsLoginAccept'});
			}
		
			$.post('', data, function(result) {

				if (result.action.Result) {
					if (result.action.Redirect302 != null) {
						app.temporaryPopupMessage(form, __redirectInfo, undefined);
						setTimeout(function () {
							window.location.assign(result.action.Redirect302);
						}, 3000);
					}
				}
			});
		});

		js.delegate(document.body, 'click', '[data-sorting-type]', app.sort);

		$('body').on('click', '.filterAll-js', function(e) {
			e.preventDefault(); 
			countSelected = app.filtersCount()
			let inputMin = Number($('input[name="$minPrice"]').val());
			let inputMax = Number($('input[name="$maxPrice"]').val());
			// let minimum = Number($('input[name="$minPrice"]').data('min'));
			// let maximum = Number($('input[name="$minPrice"]').data('max'));
			if($('#showBrandOnly').val() == "true" && (countSelected == 0 & (inputMax == 0 && inputMin == 0))) {
				location.href = $('#showBrandOnly').attr('data-categories');
			}
			
			// if ((inputMin != '' && inputMin > maximum) || (inputMax != '' && inputMax < minimum) || (isNaN(inputMax)|| isNaN(inputMin)) ) {
			if (isNaN(inputMax) || isNaN(inputMin)) {
				$('.price-error').removeClass('hidden-js');
				setTimeout(function() {
					$('.price-error').addClass('hidden-js');
				}, 1500);
				var form = $('.product-filters-js');
				form.find('[type="tel"]').val('');
			}
			// else if(inputMin>inputMax && inputMax == 0){
			// 	$('input[name="$maxPrice"]').val(maximum)

			// }else if(inputMin>inputMax){
			// 	$('.price-error').removeClass('hidden-js');
			// 	setTimeout(function() {
			// 		$('.price-error').addClass('hidden-js');
			// 	}, 1500);
			// 	var form = $('.product-filters-js');
			// 	form.find('[type="tel"]').val('');
			// }
			// else{
			// 	if(inputMin == 0 && inputMax != 0){
			// 		$('input[name="$minPrice"]').val(minimum)
			// 	}
				
			// 	if(inputMax == 0 && inputMin != 0){
			// 		$('input[name="$maxPrice"]').val(maximum)
			// 	}
			// }
			var d = $('.checkbox-js input').serializeArray();

			d.push({name: '__action', value: 'get/SearchFilters'});
			if(countSelected > 0 ||Number($('input[name="$minPrice"]').val()) != 0 || Number($('input[name="$minPrice"]').val()) != 0 ){
				if($('.reset-filters-js').css('opacity') == 0 && $('.selected-filter-item-js') != null){
					app.showBtnFun(400)
				}
			}
			else{
				
				if($('.selected-filter-item-js').length > 0 ){
					app.hideBtnFun(400)
				}
			}
			return $.ajax({
				url: window.location.href,
				method: "GET",
				action: 'get/SearchFilters',
				data: d,
				template: 'partials/products/products-list-item.html',
				success: function(data) {
					location.href = data.action.Redirect302;
				}
			});
			
		});

		$(document).ready(function(){
			countSelected = app.filtersCount()
			if(countSelected > 0 ||Number($('input[name="$minPrice"]').val()) != 0 || Number($('input[name="$minPrice"]').val()) != 0 ){
				if($('.reset-filters-js').css('opacity')==0){
					app.showBtnFun(400)
				}
			}
		}),

		$('body').on('change', '.all-values-checkbox-js', function(e) {
			var isChecked = $(e.currentTarget).prop('checked');
			$(e.currentTarget).parents('.filter-item-js').find('[type=checkbox]').prop('checked', isChecked);

			if (__filterOption !== 'filterOption-yes') {
				var d = $('.filter-js input').serializeArray();
				var d1 = $('.filterPrice-js input').serializeArray();
				d=d.concat(d1);
				d.push({name: '__action', value: 'get/SearchFilters'});
				app.filtersApply(d)
			}

		});
		

		app.showClearFiltersBtn()
		$('body').on('click', '.filter-js', function(e) {
			e.preventDefault(); 
			let currElem = e.currentTarget.children[0];
			if(currElem.getAttribute('disabled') == null ){

				if(currElem.checked == false){
					currElem.checked = true;
				}else{
					currElem.checked = false;
				}
				var d = $('.filter-js input').serializeArray();
				var d1 = $('.filterPrice-js input').serializeArray();
				d=d.concat(d1);
				d.push({name: '__action', value: 'get/SearchFilters'});
				app.filtersApply(d, e)
				countSelected = app.filtersCount()
				if($('.reset-filters-js').hasClass('reset-filters-js') && (countSelected > 0 ||Number($('input[name="$minPrice"]').val()) != 0 || Number($('input[name="$minPrice"]').val()) != 0 )){
					app.showBtnFun(400)
				}else{
					app.hideBtnFun(400)
				}
			}
		});

		$('body').on('blur', '.filterInput-js', function(e) {
			let inputMin = Number($('input[name="$minPrice"]').val());
			let inputMax = Number($('input[name="$maxPrice"]').val());
			let minimum = Number($('input[name="$minPrice"]').data('min'));
			let maximum = Number($('input[name="$minPrice"]').data('max'));

			if ((isNaN(inputMax) || isNaN(inputMin)) ) {
				$('.price-error').removeClass('hidden-js');
				setTimeout(function() {
					$('.price-error').addClass('hidden-js');
				}, 1500);
				if(isNaN(inputMax)|| isNaN(inputMin)){
					var form = $('.product-filters-js');
					form.find('[type="tel"]').val('');

				}
			}else{
				e.preventDefault(); 
				
				var d = $('.filterPrice-js input').serializeArray();
				let d1 = $('.filter-js input').serializeArray();
				d=d.concat(d1);
				d.push({name: '__action', value: 'get/SearchFilters'});
				app.filtersApply(d, e)
				if(inputMin == 0 && inputMax != 0){
					$('input[name="$minPrice"]').val(minimum)
				}
				
				if(inputMax == 0 && inputMin != 0){
					$('input[name="$maxPrice"]').val(maximum)
				}
			}


			countSelected = app.filtersCount()
			if($('.reset-filters-js').hasClass('reset-filters-js') && (countSelected > 0 ||Number($('input[name="$minPrice"]').val()) != 0 || Number($('input[name="$minPrice"]').val()) != 0 )){
				app.showBtnFun(400)
			}else{
				app.hideBtnFun(400)
			}
		});

		$(document).ready(() => {
			const options = $('.reset-units-js');
			if (options.length === 0) return;

			const selectedIndex = options.parents('.select-js').find('.memory-js')[0].selectedIndex;
			if (selectedIndex === 0) return;

			const selectedOption = options.eq(0);
			app.replaceTemplate(selectedOption);
		});

		$('body').on('click', '.replace-template-js:not(select)', function(e) {
			app.replaceTemplate(e);
		});
		$('body').on('change', '.replace-template-js', function(e) {
			app.replaceTemplate(e);
		});
		$('body').on('click', '.replace-company-edit-template-js:not(select)', function(e) {
			var currTarget = e.currentTarget;
			app.replaceTemplate(e, "", function() {
				var isReadonly = true;
				var comapnyEditTemplate = $('.change-data-container');
				comapnyEditTemplate.data('allow-edit-gus-js', $(currTarget).data('allow-edit-gus-js'));
				comapnyEditTemplate.data('edit-data-from-vies', $(currTarget).data('edit-data-from-vies'));
				var form = comapnyEditTemplate.find('.form-js');
				var gusBtn = comapnyEditTemplate.find('.download-GUS-data-js');
				var viesBtn = comapnyEditTemplate.find('.download-VIES-data-js');
				var vateu = comapnyEditTemplate.find('[name=vateu]').val();
				if (gusBtn.data('country') == 'PL' && gusBtn.data('company')) {
					gusBtn.removeClass('hidden-js');
					if ($(currTarget).data('edit-data-from-gus') == 'yes') {
						form.addClass('allow-edit-gus-js');
						isReadonly = false;
					}
				}
				if (viesBtn.data('company')) {
					if ((euCountriesISOWithoutPL.includes(viesBtn.data('country')) && vateu != '') || (viesBtn.data('country') == 'GB' && vateu == 'XI')) {
							viesBtn.removeClass('hidden-js');
							if ($(currTarget).data('edit-data-from-vies') == 'yes') {
								form.addClass('allow-edit-vies-js');
								isReadonly = false;
							}
					} else {
						if ($(currTarget).data('edit-data-from-vies') == 'yes') {
							form.addClass('allow-edit-vies-js');
							if (vateu == '') {
								isReadonly = false;
							}
						}
					}
				}
				app.readonlyFormFields(comapnyEditTemplate, isReadonly);
			});
		});

		app.updateSlider();

		let previousWidth = $(window).width();

		$(window).on('resize', function() {
			let currentWidth = $(window).width();

			if (currentWidth !== previousWidth) {
				app.updateSlider();
			}

			previousWidth = currentWidth;
		});

		$('body').on('click', '.change-type-js:not(.active)', function(e) {
			e.preventDefault();
			
			var $this = $(this);

			$('.change-type-js').removeClass('active');
			$this.addClass('active');
			app.updateSlider();

			if ($('.customer-profile-js').length > 0 && 
				typeof app.customerProfileRouting !== 'undefined') {
				
				const url = $this.data('url');
				const template = $this.data('template');
				const tab = url ? app.customerProfileRouting.getTabFromUrl(url) : null;
				
				if (url) {
					window.history.pushState({ 
						tab: tab, 
						template: template, 
						url: url,
						isSubTab: true 
					}, '', app.historyUrl(url));
				}
				
				if ($this.data('container') && $this.hasClass('replace-template-js')) {
					const $container = $($this.data('container'));
					if ($container.length && template) {
						$.get(url || window.location.href, { __template: template }, function(result) {
							$container.html(result.template);
							app.formLabelAnimationOnLoadPage();
							app.updateSlider();
							app.selects($container);
						});
						return;
					}
				}
				
				if ($this.hasClass('parent-container-reload-js') && $this.hasClass('replace-template-js')) {
					app.replaceTemplate(e);
					return;
				}
			}
		});
		
		$('body').on('click', '.delete-js', function(e) {
			app.post(e, app.delete, e, $(e.currentTarget).data('container'));
		});
		$('body').on('click', '.cancel-js', function(e) {
            $('body').removeClass('modal-opened');
			app.offLockFocus();
			app.delete(e);
		});
		$('body').on('click', '.message-popup-on-background-js', function(e) {
			e.stopPropagation();
		});
		$('body').on('click', '.rating-js *', function(e) {
			app.setRating(e);
		});
		$('body').on('mouseover', '.rating-stars-js .star-js', function(e) {
			app.colorStarsNew(e);
		});
		$('body').on('mouseout', '.rating-stars-js .star-js', function(e) {
			app.colorStarsOld(e);
		});
		$('body').on('click', '[data-scroll-to-element]', function(e) {
			app.scrollToElement(e);
		});
		$('body').on('click', '.add-product-to-comparison-tool-js', function(e) {
			app.post(e, app.replace, $(e.currentTarget).data('url'));
		});
		$('body').on('click', '.change-quantity-js:not(.disabled-js)', function(e) {
			e.stopPropagation();
			if ($(e.currentTarget).hasClass('change-quantity-header')) {
				app.changeQuantity(e, undefined, undefined, app.changeQuantityInCartHeader, e);
			} else {
				app.changeQuantity(e);
			}
		});
		$('body').on('click', '[data-attribute-id]', function(e) {
			app.changeInputValue(e, 'attribute-id', '.attributes-js', 'attributeId');
		});
		$('body').on('click', '[data-unit-id]', function(e) {
			app.changeInputValue(e, 'unit-id', '.units-js', 'unitId');
		});
		$('body').on('click', '[data-delivery-id]', function(e) {
			app.changeInputValue(e, 'delivery-id', '.form-js', 'id');
			app.post(e);
		});
		$('body').on('click', '.replace-url-js', function(e) {
			app.newUrl($(e.currentTarget).data('url'));
		});
		$('body').on('change', '.import-cart-input-js:not(.prevent-double-change-js)', withSpinner(async (e) => {
			const file = e.currentTarget.files[0];
			e.currentTarget.classList.add('prevent-double-change-js');

			app.importCSV(file);
        }));
		
		
		

		$('body').on('click', '.standalone-channel-js', function(e) {
            app.toggleParentTOS(e.currentTarget);
        });
      	$('body').on('click', '.channel-js input', function(e) {
          	e.stopPropagation();
		});
		$('body').on('click', '.add-to-cart-update-client-area-js', async function(e) {
			const form = $(e.currentTarget).parents('.form-js');
			const input = form.find('input[name=quantity]');
		
			if(input.data('min') != undefined && input.data('max') != undefined){
				var min = Number(input.data('min').toString().replace(',','.'));
				var max = Number(input.data('max').toString().replace(',','.'));
			}
		
			if(min > max){
				app.temporaryPopupMessage(undefined, __translations.stockLvlExceeded, 'err');
				return;
			} 
		
			const activeInquiryId = app.getCookie('activeInquiryId');
			if($(e.currentTarget).hasClass('add-to-inquiry-js') && (activeInquiryId == -1 || activeInquiryId == '')) {
				try {
					const clonedEvent = {...e};
		
					const response = await $.post('', {
						__action: 'Cart/Create', 
						inquiry: true, 
						__csrf: __CSRF 
					});
		
					const newInquiryId = response?.action?.Object?.CartId;
		
					app.post(clonedEvent, undefined, newInquiryId, '.client-area-js', 'partials/common/header/client-area.html');
		
				} catch (error) {
					console.error(error);
				}
		
			} else {
				app.post(e, undefined, undefined, '.client-area-js', 'partials/common/header/client-area.html');
			}

			let errorInputs = form.find('input.validation-error-js, select.validation-error-js');
            
			if (errorInputs.length > 0) {
				errorInputs.each(function() {
					var expandableParent = $(this).closest('.expandable-js');
					
					if (expandableParent.length > 0 && !expandableParent.hasClass('expanded-js')) {
						var arrow = expandableParent.parent().find('.expand-data-js').first();
						if (arrow.length > 0) {
							arrow.click();
							arrow.addClass('cant-toggle-js');
						};
					}
				});
				app.temporaryPopupMessage(undefined, __translations.fillRequiredAttributes, 'err');
			} else {
				form.find('.expand-data-js').removeClass('cant-toggle-js');
			}
		});
		$('body').on('keydown', '.form-js input', function (e) {
			if (e.keyCode == 13) {
				var form = $(e.currentTarget).parents('.form-js');
				var postTrigger = form.find('.post-js');
				if(postTrigger.length > 0){
					postTrigger.trigger('click');
				} else {
					if(form.find('.enter-key-trigger-js').hasClass('quick-search-js')){
						window.quickSearch.search();
					} else {
						form.find('.enter-key-trigger-js').trigger('click');
					}
				}
			}
		});
		$('body').on('blur', '[name=defectDate]', function (e) {
			var val = $(e.currentTarget).val();
			var min = $(e.currentTarget).attr('min');
			var max = $(e.currentTarget).attr('max');
			if(new Date(val).getTime() < new Date(min).getTime()){
				$(e.currentTarget).val(min);
			} else if(new Date(val).getTime() > new Date(max).getTime() || val == ''){
				$(e.currentTarget).val(max);
			}
		});
		$('body').on('click', '.clear-file-input-js', function(e) {
			var index = $(e.currentTarget).parent().index();
			window.attachementsInComplaint.splice(index - 1, 1);
			$(e.currentTarget).parent().addClass('hidden-js');
			$(e.currentTarget).parent().find('input').val('');
		});
		$('body').on('click', '.clear-contact-file-input-js', function(e) {
			e.stopPropagation();
			var parent = $(e.currentTarget).parent();
			var index = parent.index();
			var input = parent.find('input');
			input.val('');
			parent.find('.input-text-js').html(input.data('empty'));
			var iconUseElement = parent.find('.icon-js use');
			if (iconUseElement.length > 0) {
				iconUseElement.attr('xlink:href', 'css/img/fontawesome-icons.svg?v=' + __lqTS + '#paperclip-'+__iconStyle);
			}
			window.attachementsInComplaint.splice(index - 1, 1);
			var visibleInputs = 0;
			$('.custom-input-file-container-js').each(function(){
				if(!$(this).hasClass('hidden-js') && !$(this).find('.clear-contact-file-input-js').hasClass('hidden-js')){
					visibleInputs += 1;
				}
			})
			var hiddenClass = 'hidden-js';
			var empty = parent.find('[data-empty]').data('empty');
			var accept = $(this).attr('accept');
			var fileSize = $(this).data('file-size');
			var sizeExceeded = $(this).data('size-exceeded');
			var invalidFile = $(this).data('invalid-file');
			parent.parent().append('<div class="file custom-input-file-container-js '+hiddenClass+'">'+
										'<label for="file" class="file">'+
											'<i class="icon-js">'+
												'<svg width="24" height="24" class="svgIcon">'+
													'<use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#paperclip-'+__iconStyle+'"></use>'+
												'</svg>'+
											'</i>'+
											'<span class="input-text-js" data-empty="'+empty+'">'+empty+'</span>'+
											'<input class="add-attachement-in-complaint-js contact-file-js hidden-js" type="file" name="file" accept="'+accept+'" data-file-size="'+fileSize+'" data-size-exceeded="'+sizeExceeded+'" data-invalid-file="'+invalidFile+'" />'+
										'</label>'+
										'<i class="close-button clear-contact-file-input-js hidden-js">'+
											'<svg width="24" height="24" class="svgIcon">'+
												'<use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use>'+
											'</svg>'+
										'</i>'+
									'</div>');
			parent.remove()
		});
		$('body').on('change', '.wishlist-container-js [name="quantity"]', function (e) {
			if (__isB2B == 'true') {
				var productId = $(e.currentTarget).closest('.can-add-js').data('product-id');
				var val = $(e.currentTarget).val();
				if(val == 0){
					val = 1;
				}
				$.post('', {__csrf: __CSRF, __action: 'Wishlist/ProductQuantityChange', id: productId, quantity: val });
			} else {
				var productId = $(e.currentTarget).parents('.form-js').find('[name="productId"]').val()
				$.post('', {__action: 'Product/WishListDelete', productId: productId, __csrf: __CSRF}, function() {
					var val = $(e.currentTarget).val();
					if(val == 0){
						val = 1;
					}
					$.post('', {__action: 'Product/WishListAdd', quantity: val, productId: productId, __csrf: __CSRF});
				});
			}
		});
		$('body').on('click', '.toggle-filters-button-js', function () {
			$('.filters-label-js').toggleClass('hidden-js');
		});
		$('body').on('click', '.open-comfortable-payment-channels-popup-background-js', function (e) {
			$('.comfortable-payment-channels-popup-background-js').removeClass('hidden-js');
			$('body').addClass('modal-open');
			app.activateFocusTrap('.cart__popup-box', e.currentTarget);
		});
		$('body').on('click', '.close-comfortable-payment-channels-popup-background-js', function (e) {
			var key = $(e.currentTarget).find('[name=channel]').val();
			if(key != undefined){
				$('.choosen-payment-channel-js').addClass('hidden-js');
				$('.choosen-payment-channel-js[data-key='+key+']').removeClass('hidden-js');
				$('body').removeClass('modal-open');
			}
			$('.comfortable-payment-channels-popup-background-js').addClass('hidden-js');
		});
		$('body').on('click', '.comfortable-payment-channels-popup-js', function (e) {
			e.stopPropagation();
		});
		window.addEventListener('resize', () => {
			$('.isInCartPopup-js').hide();
		})

		$('body').on('change', '.with-database-check-js [name=vateu]', function (e) {
			var form = $(e.currentTarget).parents('.with-database-check-js');
			var isReadonly = true;
			if (form.find('[name=countryCode]').val() != "PL") {
				if (form.data('edit-data-from-vies') == 'yes') {
					isReadonly = false;
				}
				if ($(e.currentTarget).val() == "" || 
					(form.find('[name=countryCode]').val() == "GB" && $(e.currentTarget).val() != "XI")) {
						isReadonly = false;
				}
			} else {
				if (form.data('edit-data-from-gus') == 'yes') {
					isReadonly = false;
				}
			}
			app.readonlyFormFields(form, isReadonly);
			$(e.currentTarget).parents('.with-database-check-js').find('.second-step-js input[type="text"]').each(function() {
				$(this).prop('readonly', false);
				// $(this).val('');
			});
			if (!$(e.currentTarget).parents('.external-base-js').length > 0) {
				app.getDataFromExternalBase(e);
			}
		});
		$('body').on('change', '.external-base-js [name=vateu]', function (e) {
			var countryCode = $(e.currentTarget).parents('.external-base-js').find('[name=countryCode]').val();
			var vateu = $(e.currentTarget).parents('.external-base-js').find('[name=vateu]').val();
			if ((euCountriesISOWithoutPL.includes(countryCode) && vateu != '') || (countryCode == 'GB' && vateu == 'XI')) {
				$('.external-base-js .download-VIES-data-js').removeClass('hidden-js');
			} else {
				$('.external-base-js .download-VIES-data-js').addClass('hidden-js');
			}
		});
		$('body').on('click', '.download-VIES-data-js', function (e) {
			var currTarget = e.currentTarget;
			app.getDataFromExternalBase(e, function() {
				var form = $(currTarget).parents('.edit-customer-data-js');
				var isReadonly = true;
				if (form.data('edit-data-from-vies') == 'yes') {
					isReadonly = false;
				}
				app.readonlyFormFields(form, isReadonly);
			});
		});
		$('body').on('click', '.download-GUS-data-js', function (e) {
			var currTarget = e.currentTarget;
			app.getDataFromExternalBase(e, function() {
				var form = $(currTarget).parents('.edit-customer-data-js');
				var isReadonly = true;
				if (form.data('edit-data-from-gus') == 'yes') {
					isReadonly = false;
				}
				app.readonlyFormFields(form, isReadonly);
			});
		});
		$('body').on('click', '.open-check-deliveries-popup-js', function(e) {
			e.stopPropagation();
		});
		js.delegate(document.body, 'click', '.open-check-deliveries-popup-js', app.openCheckDeliveriesPopup);
		$('body').on('click', '.check-deliveries-popup-js .close', function(e) {
			$('.check-deliveries-popup-js .purchase-orders-list-js').find('.row').remove();
		});
		$('body').on('change', '.ask-for-price-quantity-js [name=quantity]', function(e) {
			app.validateIntValue(e);
		});
		if($('.map-js').index() != -1){
            app.initiateGoogleMapsApi();
        }
		$('body').on('click', '.show-size-chart-banner-js', function(e) {
			e.stopPropagation();
			$(this).next().removeClass('hidden-js');
		});
		$('body').on('click', '.cp_link', function(e) {
			if(window.location.search == '?add-inquiry=true'){
				setTimeout(() => {
					$.post('', {__action: 'Cart/Change', id: $('.load-inquiry-js').data('inquiry-id'), __csrf: __CSRF}, function() {
						window.location.href = url;
					});
					location.reload();
				}, 2000);
			}
		});
		$(window).scroll(function(){

			if ($('.isInCartPopup-js').css('display') !== 'none' && $(window).width() < 769) {
                $('.isInCartPopup-js').hide();
            }
		});
		$(document).ajaxSuccess(function(a,b,c,d) {
		});
        $(document).ajaxError(function(a,b,c,d) {
        });
        let mousePos = undefined;
        let currentPos = undefined;
        let isFirstRotateImageSet = false;
        let is360ImageSet = false;
        let isMouseDown = false;
        let isProductListRotateImage = false;

        $('body').on('mousedown', function() {
            isMouseDown = true;
        });

        $('body').on('mouseup', function() {
            isMouseDown = false;
        });

        $('body').on('mousedown', '.image360', function(e) {
            e.preventDefault();
        });
        
        $('body').on('mousemove', function(e) {
            //e.target && e.target.classList && (e.target.classList.contains('imageContainer360') || e.target.classList.contains('image360')) && 
            if (autoRotate == false && isMouseDown) {
                if (!isFirstRotateImageSet) {
                    currentPos = e.clientX;
                    isFirstRotateImageSet = true;
                }

                mousePos = e.clientX;
                if(mousePos > currentPos + 20) {
                    if($('.image360').index() >= 0) {
                        app.move360Image('right');
                    }
                    currentPos = mousePos;

                } else if (mousePos < currentPos - 20) {
                    if($('.image360').index() >= 0) {
                        app.move360Image('left');
                    }
                    currentPos = mousePos;
                } 
            }
        });

        $('body').on('click', '.open360-js', function(e) {
            if (!is360ImageSet) {
                if ($(e.currentTarget).attr('data-product-list')) {
					e.preventDefault();
					e.stopPropagation();
                    app.get360Image(e, true);
                    isProductListRotateImage = true;
                } else {
                    app.get360Image(e);
                }
                is360ImageSet = true;
				$('.image-rotate-popup').removeClass('hidden-js');
            } else {
				$('.image-rotate-popup').removeClass('hidden-js');
			}
        });

        $('body').on('click', '.close360-js', function(e) {
            autoRotate = false;
            app.enableDisableAutoRotate('disable');
            $('.image360').addClass('hidden-js').removeClass('cur').removeClass('toRemove');
            $('.image360').eq(0).addClass('cur').removeClass('hidden-js');
			$('.image-rotate-popup').addClass('hidden-js');
            if (isProductListRotateImage) {
                $('.image360').remove();
                is360ImageSet = false;
                maxImgRotateId = 0;
            }
        });

        $('body').on('click', '.imageContainer--360btn.btn-left', function() {
            autoRotate = false;
			app.enableDisableAutoRotate('disable');
            app.move360Image('left');
        });

        $('body').on('click', '.imageContainer--360btn.btn-right', function() {
            autoRotate = false;
			app.enableDisableAutoRotate('disable');
            app.move360Image('right');
        });

        $('body').on('click', '.imageContainer--360btn.btn-auto', function() {
            if (autoRotate == false) {
                autoRotate = true;
                app.enableDisableAutoRotate('enable');
            } else {
                autoRotate = false;
                app.enableDisableAutoRotate('disable');
            }
        });

        $('body').on('click', '.reset360', function() {
            is360ImageSet = false;
            isProductListRotateImage = false;
            isFirstRotateImageSet = false;
        });

		$('body').on('click', '.show-login-popup-js', function() {
			$('.login-popup-js').removeClass('hidden-js');
		});

		$('body').on('change', 'input[name="quantity"]', function() {
			if ($('.product-presentation-js').index() >= 0 && $('.installmentCalculator').index() >= 0) {
				reloadInstallmentButtons();
			}
		});

		$('body').on('click', '.isInCartIcon-js', function (e) {
			if($(e.currentTarget).hasClass('isInCart--variants')) {
				$('.isInCart--variants-js').show();
			} else {
				app.showTooltip(e, $('.isInCartPopup-js'), 45, 160);
			}
		});

        $('body').on('mouseover', '.isInCartIcon-js', function (e) {
			if($(e.currentTarget).hasClass('isInCart--variants')) {
				$('.isInCart--variants-js').show();
			} else {
				app.showTooltip(e, $('.isInCartPopup-js'), 45, 160);
			}
        });

        $('body').on('mouseout', '.isInCartIcon-js', function (e) {
            app.hideTooltip(e, $('.isInCartPopup-js'));
        });

		document.body.addEventListener('click', (event) => {
			const dialog = event.target.closest('dialog');
		
			if (dialog && event.target.closest('.close-js')) {
				dialog.close();
			}
		});

		$('body').on('click', '.closeItemsList-js', function(e) {
			if ($(window).width() > 1279) {
				$('.cartItemsList-js').addClass('hidden-js');
            }   
		});
		
		$('body').on('click', '.js-reportReview', function(e) {
			document.querySelector('.report-review-popup-js').showModal();
            let reviewId = $(e.currentTarget).data('review-id');
            $('.report-review-popup-js').find('input[name="id"]').val(reviewId);
			app.formLabelAnimationOnLoadPage();
        });

		$('body').on('click', '.report-review-popup .close-button', function(e) {
			$('.report-review-popup').addClass('hidden-js');	
		});

        $('body').on('click', '.reportReviewBtn-js', function(e) {
			e.preventDefault();
			e.stopPropagation();
			js.sendReviewReport(e);
        });

        $('body').on('change', '#selectDSA', function(e) {
            if ($('#selectDSA').val() != '') {
                $('#selectDSALabel').removeClass('select-label--notChoosen').addClass('select-label--choosen');
            } else {
                $('#selectDSALabel').removeClass('select-label--choosen').addClass('select-label--notChoosen');
            }
        });
		
		$('body').on('change', '[name="RelatedToEUDirectiveOffense"]', function() {
			let reportContainer = $('.form__input-wrapper');
			let inputs = reportContainer.find('input[name="email"], input[name="name"]');
		
			if ($('#RelatedToEUDirectiveOffenseYes').prop('checked')) {
				inputs.prop('required', false)
					.removeClass('validation-error-js')
					.closest('.form__input-wrapper')
					.find('.required, .validation-required-js').addClass('hidden-js')
					.end()
					.find('.input-info-js').removeClass('validation-error');
			} else {
				inputs.prop('required', true)
					.closest('.form__input-wrapper')
					.find('.required').removeClass('hidden-js');

				inputs.each(function() {
					if ($(this).val().trim() === '') {
						$(this).addClass('validation-error-js')
							.closest('.form__input-wrapper')
							.find('.input-info-js').addClass('validation-error')
							.end()
							.find('.validation-required-js').removeClass('hidden-js');
					}
				});
			}
		});	

		$('body').on('keydown', 'input[type="tel"]', (e) => {
			const focusableElements = $('body').find('a, button, input:not([type="hidden"]), textarea, details, [tabindex]').filter(function() {
				const $el = $(this);
				if ($el.hasClass('swiper-button-prev') || $el.hasClass('swiper-button-next')) {
					return true;
				}
				return $el.css('visibility') !== 'hidden' && $el.css('display') !== 'none';
			});
			const idx = focusableElements.index(e.currentTarget);
			
			if (e.shiftKey && e.key === 'Tab') {
				focusableElements.eq(idx - 1).focus();
			} else if (e.key === 'Tab') {
				focusableElements.eq(idx + 1).focus();
			}
		});

		$('input[type="number"]').on('keydown', (e) => {
			if (e.key === 'Tab') {
				e.stopPropagation();
				return true;
			}
		});

		$('body').on('keydown click', '.select-wcag-js', (e) => {
			const options = e.currentTarget.querySelectorAll('li, .additional-option-js');
			const optionsArray = Array.from(options);
			const focusedOption = e.currentTarget.querySelector('.focused-option-js');
			const dropdown = e.currentTarget.querySelector('.dropdown-js');

			if (dropdown === null || e.currentTarget.classList.contains('suspended-js'))
				return;

			if (focusedOption !== null) {
				focusedOption.classList.remove('focused-option-js');
			}

			switch (e.key) {
				case 'Enter':
				case ' ':
					const isDropdownHidden = dropdown.classList.contains('hidden-js') || $(dropdown).css('display') === 'none';
					const timeOut = setTimeout(() => {
						if (isDropdownHidden) {
							options[0].focus();
							options[0].classList.add('focused-option-js');
						} else {
							e.currentTarget.querySelector('button, [role="button"]').focus();
							if (dropdown.classList.contains('header-more-dropdown-js') && !e.target.classList.contains('header-inquiry-js'))
								e.currentTarget.querySelector('button, [role="button"]').click();
							else if (!e.target.classList.contains('header-inquiry-js'))
								dropdown.classList.add('hidden-js');
						}
						
						clearTimeout(timeOut);
					}, 100);

					break;

				case 'Escape':
					e.preventDefault();
					if (focusedOption !== null) {
						focusedOption.classList.remove('focused-option-js');
					}
					e.currentTarget.querySelector('button, [role="button"]').focus();

					if (dropdown.classList.contains('header-more-dropdown-js'))
						e.currentTarget.querySelector('button, [role="button"]').click();
					else
						dropdown.classList.add('hidden-js');
					break;

				case 'ArrowDown':
					e.preventDefault();
					
					let nextIndex =  optionsArray.indexOf(focusedOption) + 1;
					if (focusedOption !== null)
						focusedOption.classList.remove('focused-option-js');
					
					if (nextIndex === options.length)
						nextIndex = 0;

					options[nextIndex].focus();
					options[nextIndex].classList.add('focused-option-js');

					break;

				case 'ArrowUp':
					e.preventDefault();

					let previousIndex =  optionsArray.indexOf(focusedOption) - 1;
					if (focusedOption !== null)
						focusedOption.classList.remove('focused-option-js');
					
					if (previousIndex === -1)
						previousIndex =  options.length - 1;

					options[previousIndex].focus();
					options[previousIndex].classList.add('focused-option-js');

					break;

				case 'Home':
					e.preventDefault();
					if (focusedOption !== null) {
						focusedOption.classList.remove('focused-option-js');
					}
					options[0].focus();
					options[0].classList.add('focused-option-js');
					break;

				case 'End':
					e.preventDefault();
					if (focusedOption !== null) {
						focusedOption.classList.remove('focused-option-js');
					}
					options[options.length - 1].focus();
					options[options.length - 1].classList.add('focused-option-js');
					break;

				case 'Tab':
					if (focusedOption !== null) {
						focusedOption.classList.remove('focused-option-js');
					}

					if (dropdown.classList.contains('header-more-dropdown-js') &&  $(dropdown).css('display') === 'block') {
						e.currentTarget.querySelector('button, [role="button"]').click();
					}
						
					else if (!dropdown.classList.contains('header-more-dropdown-js'))
						dropdown.classList.add('hidden-js');
					break;
			}
		});

        $('body').on('click', '.reset-filters-js', function(e) {
			if($('#showBrandOnly').val() == "true"){

				location.href = $('#showBrandOnly').attr('data-categories');
			}else{
			app.resetFilters(e);
			$('.selected-filter-item-js').each(function() {
				this.remove()
			});
			countSelected = app.filtersCount()
			if($('.reset-filters-js').hasClass('reset-filters-js') && (countSelected > 0 ||Number($('input[name="$minPrice"]').val()) != 0 || Number($('input[name="$minPrice"]').val()) != 0 )){
				app.showBtnFun(400)
			} else{
				app.hideBtnFun(400)
			}

			}
            app.filtersAmout()
		});

        $('body').on('click', '.open-cookie-popup-js', function(e) {
            app.openCookiePopup(e);
            app.activateFocusTrap('.cookie-container-js', e.currentTarget);
        });

        $('body').on('click', '.cookie-consent-js', app.cookieConsentSwitch);

        $('body').on('click', '.prevent-cookie-message-js', app.preventCookieMessage);

        $('body').on('click', '.close-cookie-message-js', function(e) {
			$(e.currentTarget).parents('.cookie-message-popup-js').addClass('hidden-js');
        });

        $('body').on('click', '.cookie-message-opener-js', function(e) {
            app.showCookieMessage(e);
            app.activateFocusTrap('.cookie-message-popup-js', e.currentTarget);
        });

		$('body').on('click', '.accept-all-cookie-js', app.acceptAllCookies);

		$('body').on('click', '.save-custom-cookie-consents-js', app.saveCookieSettings);

        $(window).scroll(function() {
            const toggleGoToTopBtnTimeout = setTimeout(function() {
                if ($(window).scrollTop() > 300) {
                    if ($('.go-to-top-button-js').css('display') == 'none') {
                        $('.go-to-top-button-js').fadeIn();
                    }
                } else if ($('.go-to-top-button-js').css('display') != 'none') {
                    $('.go-to-top-button-js').fadeOut();
                }
                clearTimeout(toggleGoToTopBtnTimeout);
            }, 400);
        });

        $('.go-to-top-button-js').click(function() {
            $('html, body').animate({scrollTop : 0}, 800);
            return false;
        });

        $('body').on('click', '.remove-product-from-cart-js', function(e) {
            if (!e.detail || e.detail == 1) {
                if($(e.currentTarget).hasClass('last-product-js') || $(e.currentTarget).hasClass('last-product-header-js')){
                    app.deleteCart();
                } else {
                    app.removeProductFromCart(e);
                }
            }
        });

        $('body').on('input', 'textarea', function() {
            const textarea = this;
            const style = window.getComputedStyle(textarea);
            const paddingBottom = parseFloat(style.getPropertyValue('padding-bottom'));
            textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight + paddingBottom;
        });

        app.focusManager.init();
        this.initFocusManagement();

        $('body').on('keypress', '[tabindex="0"]', (e) => {
            const isEnter = e.key === 'Enter';
            const isSpace = e.key === ' ' || e.code === 'Space';
            if (isEnter || isSpace) {
                e.preventDefault();

				if (e.currentTarget.classList.contains('change-slide-js')) return;
                
                const event = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                e.target.dispatchEvent(event);
            }
        });

		$('body').on('click', '.mmq-close-js', (e) => {
			e.currentTarget.closest('.set-amount-popup-js').remove();
		});
    }
}

$('body').on('click', '.customer-container-menu__label', function (e) {
    window.filterDate = null;
    window.erpPage = null;
    app.customerProfileRouting.navigate(e, false);
});

$(document).ready(function() {
    app.customerProfileRouting.init();
    app.customerProfileRouting.updateTabFromUrl();
});

/**
 * Implements lazy loading for images.
 * 
 * This module delays image loading until they become visible in the viewport, thereby improving page load performance,
 * especially on pages with many images. It works in two parts:
 * 
 * 1. IntersectionObserver: Monitors images with \`data-src\` or \`data-lazy\` attributes. When an image is about to enter
 *    the viewport (based on a specified threshold and root margin), the image’s actual source is set, triggering the load.
 * 
 * 2. MutationObserver: Detects dynamically added images (e.g., via AJAX or DOM manipulation) that have lazy-loading
 *    attributes and registers them with the IntersectionObserver automatically.
 * 
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/Performance/Lazy_loading Lazy Loading} - Learn more about lazy loading.
 */
const lazyLoading = (() => {
    /**
     * Registers all existing images with \`data-src\` or \`data-lazy\` attributes with the IntersectionObserver.
     * This ensures that images present in the DOM at initialization are set up for lazy loading.
     */
    const observeImages = () => {
        const images = document.querySelectorAll('img[data-src], img[data-lazy]');
        images.forEach(image => { observer.observe(image); });
    };

    /**
     * Configuration object for the IntersectionObserver.
     * 
     * @property {Element|null} root -  A value of \`null\` defaults to the browser's viewport.
     * @property {number} threshold - A threshold of 0.05 means the callback fires when 5% of the image is visible.
     * @property {string} rootMargin - A bottom margin of 350px to trigger loading  before the image fully enters the viewport.
     */
    const config = {
        root: null,
        threshold: 0.05,
        rootMargin: "0px 0px 350px 0px"
    };

    /**
     * Loads an image by setting its \`src\` attribute from the value provided in either \`data-src\` or \`data-lazy\`.
     * Once the image source is set, the lazy-loading attributes are removed to avoid reprocessing.
     *
     * @param {HTMLImageElement} image - The image element to load.
     */
	const loadImage = (image, retries = 3, delay = 1000) => {
        const src = image.getAttribute('data-src') || image.getAttribute('data-lazy');
        if (!src) {
			return;
		}

        const attemptLoad = (retryCount) => {
            const onLoad = () => {
				image.removeEventListener('load', onLoad);
				image.removeEventListener('error', onError);
                image.removeAttribute('data-src');
                image.removeAttribute('data-lazy');
            };

            const onError = () => {
				image.removeEventListener('load', onLoad);
				image.removeEventListener('error', onError);

                if (retryCount > 0) {
                    setTimeout(() => attemptLoad(retryCount - 1), delay);
                } else {
                    console.error('Image failed to load after multiple attempts:', image);
                }
            };

            image.src = src;
            image.addEventListener('load', onLoad);
            image.addEventListener('error', onError);
        };

        attemptLoad(retries);
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadImage(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, config);

    observeImages();

	const mutationObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.matches && node.matches('img[data-src], img[data-lazy]')) {
                        observer.observe(node);
                    }
                    const images = node.querySelectorAll && node.querySelectorAll('img[data-src], img[data-lazy]');
                    images && images.forEach(img => observer.observe(img));
                }
            });
        });
	});

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return {
        destroy: () => {
            observer.disconnect();
            mutationObserver.disconnect();
        }
    };
})();

if($('.textElement').length > 0) {
	app.textElement();
}
app.selects();

var autoRotate = false;
var rotateInterval;
var maxImgRotateId;

app.blockIE();

setInterval(() => fetch(document.baseURI + 'xhr?__action=svc/ping'), 600000);

//variable to clearTimeout in changeQuantity function
var timeOut = null;
`